export const strainData = {
 IL : [
    {
      "id": "IL-184",
      "strain": "Tropical Railroad",
      "type": "Hybrid",
      "thc": 62.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-173",
      "strain": "Hawaiian Kush",
      "type": "Sativa",
      "thc": 61.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-157",
      "strain": "Blueberry OG",
      "type": "Indica",
      "thc": 61.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-308",
      "strain": "Garlic and Bananas",
      "type": "Hybrid",
      "thc": 58.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-299",
      "strain": "Pineapple Express (H",
      "type": "Hybrid",
      "thc": 58.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-155",
      "strain": "Blue Blast",
      "type": "Indica",
      "thc": 57.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-301",
      "strain": "Purple Churro",
      "type": "Sativa",
      "thc": 57.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-311",
      "strain": "Mandarin Z",
      "type": "Indica",
      "thc": 57.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-182",
      "strain": "Strawberry Smash",
      "type": "Indica",
      "thc": 55.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-310",
      "strain": "MAC 1",
      "type": "Hybrid",
      "thc": 55.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-419",
      "strain": "Lemon Sorbet",
      "type": "Hybrid",
      "thc": 55.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-306",
      "strain": "Butterstuff",
      "type": "Hybrid",
      "thc": 53.93,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.24,
        "Limonene": 0.27,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "IL"
    },
    {
      "id": "IL-307",
      "strain": "Citrus MAC",
      "type": "Sativa",
      "thc": 53.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.11,
        "Limonene": 0.1,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "IL"
    },
    {
      "id": "IL-176",
      "strain": "Lucid Blue",
      "type": "Sativa",
      "thc": 53.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-416",
      "strain": "Do Si Dos (I",
      "type": "Indica",
      "thc": 53.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-181",
      "strain": "Strawberry Gas",
      "type": "Sativa",
      "thc": 52.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-309",
      "strain": "Georgia Pie",
      "type": "Hybrid",
      "thc": 52.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-289",
      "strain": "Bio Jesus",
      "type": "Indica",
      "thc": 51.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-179",
      "strain": "Palm Tree Punch",
      "type": "Sativa",
      "thc": 49.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-140",
      "strain": "Orange (S",
      "type": "Sativa",
      "thc": 48.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-185",
      "strain": "Venom OG (S",
      "type": "Sativa",
      "thc": 48.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-283",
      "strain": "Problem Child H",
      "type": "Indica",
      "thc": 45.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-275",
      "strain": "Secret Stash",
      "type": "Hybrid",
      "thc": 45.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-284",
      "strain": "Titan Express",
      "type": "Hybrid",
      "thc": 42.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-340",
      "strain": "Scotch & Soda",
      "type": "Hybrid",
      "thc": 42.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-457",
      "strain": "Fruit Stand",
      "type": "Indica",
      "thc": 42.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-159",
      "strain": "Candy Melonz",
      "type": "Indica",
      "thc": 41.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-280",
      "strain": "Blue Lobster",
      "type": "Hybrid",
      "thc": 41.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-272",
      "strain": "Kush Mints",
      "type": "Indica",
      "thc": 40.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-454",
      "strain": "Berried Treasure",
      "type": "Indica",
      "thc": 40.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-228",
      "strain": "Mint Sherbert",
      "type": "Indica",
      "thc": 39.93,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-123",
      "strain": "Blueberry (I",
      "type": "Indica",
      "thc": 38.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-258",
      "strain": "Indica",
      "type": "Indica",
      "thc": 38.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-263",
      "strain": "Sativa",
      "type": "Sativa",
      "thc": 38.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-296",
      "strain": "Kush Mints",
      "type": "Indica",
      "thc": 38.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-385",
      "strain": "Gelly Roll",
      "type": "Hybrid",
      "thc": 37.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-452",
      "strain": "Billionaire",
      "type": "Sativa",
      "thc": 37.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-479",
      "strain": "Nutcrackerz",
      "type": "Indica",
      "thc": 36.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-430",
      "strain": "Candied Pound Cake",
      "type": "Hybrid",
      "thc": 36.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.11,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.72,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "IL"
    },
    {
      "id": "IL-335",
      "strain": "Blue Unicorn Poop",
      "type": "Sativa",
      "thc": 36.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-108",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 36.57,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-217",
      "strain": "Double Stuffed Oreoz",
      "type": "Hybrid",
      "thc": 36.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-225",
      "strain": "Grapple Pie (H",
      "type": "Hybrid",
      "thc": 36.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-221",
      "strain": "Supreme Planet",
      "type": "Hybrid",
      "thc": 35.93,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-222",
      "strain": "Chem Chillz #17",
      "type": "Indica",
      "thc": 35.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-270",
      "strain": "Blue Sapphire",
      "type": "Sativa",
      "thc": 35.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-480",
      "strain": "Space Mints",
      "type": "Hybrid",
      "thc": 35.6,
      "cbd": 0.1,
      "lineage": "beloved Wedding Cake and Kush Mints",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-148",
      "strain": "Strawberry (H",
      "type": "Hybrid",
      "thc": 35.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-239",
      "strain": "Cinnamon Milk",
      "type": "Hybrid",
      "thc": 35.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-227",
      "strain": "Lemon Crème Cookies",
      "type": "Sativa",
      "thc": 35.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-334",
      "strain": "Animal Kush Mintz",
      "type": "Sativa",
      "thc": 35.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-240",
      "strain": "Circus Ring",
      "type": "Indica",
      "thc": 34.94,
      "cbd": 0.1,
      "lineage": "crossing Gelato 41 with Animal Cookies",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-387",
      "strain": "Royal Gorilla",
      "type": "Sativa",
      "thc": 34.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-393",
      "strain": "Dual OG",
      "type": "Hybrid",
      "thc": 34.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-214",
      "strain": "Garlic Cocktail",
      "type": "Hybrid",
      "thc": 34.79,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-359",
      "strain": "Garlic Z",
      "type": "Indica",
      "thc": 34.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-273",
      "strain": "Morning Dew",
      "type": "Sativa",
      "thc": 34.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-338",
      "strain": "Peanut Butter Cherry Pie",
      "type": "Hybrid",
      "thc": 34.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-200",
      "strain": "Jungle Juice",
      "type": "Hybrid",
      "thc": 34.45,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-204",
      "strain": "Cap Junky I",
      "type": "Indica",
      "thc": 34.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-271",
      "strain": "Dew Too",
      "type": "Hybrid",
      "thc": 34.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-213",
      "strain": "Double Baked Cake",
      "type": "Indica",
      "thc": 34.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-111",
      "strain": "Jet Fuel OG (H",
      "type": "Hybrid",
      "thc": 34.15,
      "cbd": 0.1,
      "lineage": "Aspen OG x High Country Diesel",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-313",
      "strain": "No Strain",
      "type": "Indica",
      "thc": 34.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-436",
      "strain": "Glitter Bomb (I",
      "type": "Hybrid",
      "thc": 33.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.08,
        "Limonene": 0.07,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.94,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.01,
        "b-Pinene": 0.03
      },
      "state": "IL"
    },
    {
      "id": "IL-392",
      "strain": "Reserve Butterstuff",
      "type": "Indica",
      "thc": 33.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-396",
      "strain": "Penalty Box",
      "type": "Hybrid",
      "thc": 33.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-117",
      "strain": "Runtz S1",
      "type": "Hybrid",
      "thc": 33.66,
      "cbd": 0.1,
      "lineage": "Runtz x Tropical ZKZ",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-216",
      "strain": "Apricot Chem",
      "type": "Sativa",
      "thc": 33.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-226",
      "strain": "Guava Now N Later",
      "type": "Indica",
      "thc": 33.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-391",
      "strain": "Butterstuff",
      "type": "Indica",
      "thc": 33.11,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-341",
      "strain": "Crazy Hazey",
      "type": "Sativa",
      "thc": 33.09,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-152",
      "strain": "Animal Kush",
      "type": "Hybrid",
      "thc": 32.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-481",
      "strain": "Yum Yum",
      "type": "Hybrid",
      "thc": 32.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-129",
      "strain": "Gas and Glue",
      "type": "Hybrid",
      "thc": 32.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-192",
      "strain": "Cash Cow",
      "type": "Hybrid",
      "thc": 32.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-336",
      "strain": "Blue Zushi",
      "type": "Hybrid",
      "thc": 32.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-386",
      "strain": "No Strain",
      "type": "Indica",
      "thc": 32.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-199",
      "strain": "Jenny Kush",
      "type": "Sativa",
      "thc": 32.45,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-465",
      "strain": "Weedies",
      "type": "Hybrid",
      "thc": 32.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.12,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.2,
        "b-Pinene": 0.2
      },
      "state": "IL"
    },
    {
      "id": "IL-445",
      "strain": "Lemon Voltage",
      "type": "Hybrid",
      "thc": 32.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.12,
        "Limonene": 0.09,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.34,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "IL"
    },
    {
      "id": "IL-274",
      "strain": "Purple Plague",
      "type": "Hybrid",
      "thc": 32.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-395",
      "strain": "Garlic & Bananas",
      "type": "Hybrid",
      "thc": 32.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-434",
      "strain": "Garlic Sorbet",
      "type": "Hybrid",
      "thc": 32.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.2,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.04,
        "Myrcene": 0.47,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "IL"
    },
    {
      "id": "IL-106",
      "strain": "Gas Guzzler",
      "type": "Hybrid",
      "thc": 32.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-477",
      "strain": "Gator Breath",
      "type": "Hybrid",
      "thc": 32.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-384",
      "strain": "Mandala's Dream",
      "type": "Hybrid",
      "thc": 32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-194",
      "strain": "GMO (I",
      "type": "Indica",
      "thc": 31.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-337",
      "strain": "G Code",
      "type": "Hybrid",
      "thc": 31.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-167",
      "strain": "Garlic Kush",
      "type": "Indica",
      "thc": 31.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-397",
      "strain": "PK Crasher",
      "type": "Hybrid",
      "thc": 31.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-215",
      "strain": "Lemonberry Stomper",
      "type": "Hybrid",
      "thc": 31.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-464",
      "strain": "Triangle Cake",
      "type": "Hybrid",
      "thc": 31.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.81,
        "Humulene": 0.26,
        "Limonene": 0.66,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.35,
        "Terpinolene": 0,
        "Bisabolol": 0.14,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "IL"
    },
    {
      "id": "IL-186",
      "strain": "Do Si Dos (I",
      "type": "Indica",
      "thc": 31.43,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-321",
      "strain": "Grease Monkey",
      "type": "Indica",
      "thc": 31.37,
      "cbd": 0.1,
      "lineage": "GG4 x Cookies n Cream",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-168",
      "strain": "Gellie Gas",
      "type": "Hybrid",
      "thc": 31.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-229",
      "strain": "Violet Fog (I",
      "type": "Indica",
      "thc": 31.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-476",
      "strain": "Gas Powdered Cake",
      "type": "Hybrid",
      "thc": 31.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-316",
      "strain": "Cheetah Piss",
      "type": "Sativa",
      "thc": 31.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-107",
      "strain": "Giggle Gas",
      "type": "Hybrid",
      "thc": 31.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-433",
      "strain": "Garlic & Bananas",
      "type": "Hybrid",
      "thc": 31.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-119",
      "strain": "Sneak Attack OG",
      "type": "Hybrid",
      "thc": 31.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-453",
      "strain": "Lemon Dosie",
      "type": "Sativa",
      "thc": 31.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-388",
      "strain": "Reserve Animal Cake",
      "type": "Hybrid",
      "thc": 31.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-247",
      "strain": "Rainbows & Cherries (S",
      "type": "Sativa",
      "thc": 30.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-444",
      "strain": "Lemon Voltage (S",
      "type": "Hybrid",
      "thc": 30.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.48,
        "Humulene": 0.12,
        "Limonene": 0.08,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.36,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "IL"
    },
    {
      "id": "IL-139",
      "strain": "OMG",
      "type": "Hybrid",
      "thc": 30.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-242",
      "strain": "Jester",
      "type": "Indica",
      "thc": 30.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-197",
      "strain": "Hashburger",
      "type": "Indica",
      "thc": 30.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-418",
      "strain": "Guava Jam",
      "type": "Hybrid",
      "thc": 30.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-471",
      "strain": "Durban Poison",
      "type": "Hybrid",
      "thc": 30.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-134",
      "strain": "Indica Blend",
      "type": "Indica",
      "thc": 30.45,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-351",
      "strain": "Gushmintz",
      "type": "Hybrid",
      "thc": 30.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-183",
      "strain": "Sunset Ceremony",
      "type": "Hybrid",
      "thc": 30.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-223",
      "strain": "Dominion Diesel",
      "type": "Hybrid",
      "thc": 30.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-473",
      "strain": "Hella Jelly",
      "type": "Hybrid",
      "thc": 30.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-324",
      "strain": "Lime Skunk",
      "type": "Sativa",
      "thc": 30.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-344",
      "strain": "Lemon Fatman",
      "type": "Sativa",
      "thc": 29.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-478",
      "strain": "Moon Boots",
      "type": "Hybrid",
      "thc": 29.83,
      "cbd": 0.1,
      "lineage": "White Tahoe Cookies x Moon Bow",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-205",
      "strain": "Glitterbomb",
      "type": "Indica",
      "thc": 29.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-326",
      "strain": "Moonbow",
      "type": "Hybrid",
      "thc": 29.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.17,
        "Limonene": 0.64,
        "Ocimene": 0,
        "Linalool": 0.47,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "IL"
    },
    {
      "id": "IL-209",
      "strain": "Mayday",
      "type": "Hybrid",
      "thc": 29.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-357",
      "strain": "Umami (H",
      "type": "Hybrid",
      "thc": 29.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-342",
      "strain": "Garlic Z",
      "type": "Indica",
      "thc": 29.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-390",
      "strain": "BanOreoz",
      "type": "Hybrid",
      "thc": 29.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-361",
      "strain": "Marz",
      "type": "Hybrid",
      "thc": 29.61,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-248",
      "strain": "Rollins",
      "type": "Sativa",
      "thc": 29.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-250",
      "strain": "Sugar Storm",
      "type": "Indica",
      "thc": 29.55,
      "cbd": 0.1,
      "lineage": "Bubba Gum x Candy Rain #4",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-237",
      "strain": "Bio Jesus",
      "type": "Indica",
      "thc": 29.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-116",
      "strain": "Regina George",
      "type": "Hybrid",
      "thc": 29.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-236",
      "strain": "Billy Ocean",
      "type": "Hybrid",
      "thc": 29.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-360",
      "strain": "Grease Monkey (H",
      "type": "Hybrid",
      "thc": 29.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-362",
      "strain": "Moonbow",
      "type": "Hybrid",
      "thc": 29.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-435",
      "strain": "Georgia Pie",
      "type": "Hybrid",
      "thc": 29.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-110",
      "strain": "Granny Candy",
      "type": "Sativa",
      "thc": 29.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-162",
      "strain": "Couch Candy",
      "type": "Hybrid",
      "thc": 29.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-394",
      "strain": "Fruit Guru",
      "type": "Hybrid",
      "thc": 29.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-323",
      "strain": "Lemon Fatman H",
      "type": "Hybrid",
      "thc": 29.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.23,
        "Humulene": 0.07,
        "Limonene": 0.29,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 1.23,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.02,
        "b-Pinene": 0.06
      },
      "state": "IL"
    },
    {
      "id": "IL-104",
      "strain": "Easy Bake",
      "type": "Indica",
      "thc": 29.28,
      "cbd": 0.1,
      "lineage": "Brownie Scout x Tyde Podz",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-343",
      "strain": "Layer Cake (H",
      "type": "Hybrid",
      "thc": 29.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-325",
      "strain": "Mandarin Z (H",
      "type": "Hybrid",
      "thc": 29.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.45,
        "Humulene": 0.01,
        "Limonene": 0.32,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.1,
        "b-Pinene": 0.09
      },
      "state": "IL"
    },
    {
      "id": "IL-170",
      "strain": "GMO Skunk Cake",
      "type": "Hybrid",
      "thc": 29.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-448",
      "strain": "Mandarin Z (H",
      "type": "Hybrid",
      "thc": 29.16,
      "cbd": 0.1,
      "lineage": "Mandarin Sunset x California Black Rose",
      "terpenes": {
        "Caryophyllene": 0.35,
        "Humulene": 0.15,
        "Limonene": 0.46,
        "Ocimene": 0,
        "Linalool": 0.38,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0.23,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "IL"
    },
    {
      "id": "IL-417",
      "strain": "Guava Casquitos (H",
      "type": "Hybrid",
      "thc": 29.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-153",
      "strain": "Berry Cream Crunch",
      "type": "Hybrid",
      "thc": 29.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-109",
      "strain": "Graham Cracker",
      "type": "Indica",
      "thc": 29.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-427",
      "strain": "BanOreoz",
      "type": "Hybrid",
      "thc": 29.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.18,
        "Humulene": 0.06,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 0.1,
        "Terpinolene": 0,
        "Bisabolol": 0.15,
        "Pinene": 0.08,
        "b-Pinene": 0.09
      },
      "state": "IL"
    },
    {
      "id": "IL-409",
      "strain": "Paradise",
      "type": "Sativa",
      "thc": 29.09,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-332",
      "strain": "Truffle Monkey",
      "type": "Hybrid",
      "thc": 29.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.16,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.24,
        "Myrcene": 0.02,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "IL"
    },
    {
      "id": "IL-224",
      "strain": "Dutch Treat x Cherry Pie",
      "type": "Sativa",
      "thc": 29.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-262",
      "strain": "Petit Dejeuner",
      "type": "Sativa",
      "thc": 29.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-241",
      "strain": "Gas Station Sushi",
      "type": "Sativa",
      "thc": 28.99,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-165",
      "strain": "Flavorbow",
      "type": "Sativa",
      "thc": 28.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.14,
        "Limonene": 0.53,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.32,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "IL"
    },
    {
      "id": "IL-232",
      "strain": "Blue Suede",
      "type": "Hybrid",
      "thc": 28.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-322",
      "strain": "Layer Cake (H",
      "type": "Hybrid",
      "thc": 28.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-180",
      "strain": "Skunk Aura",
      "type": "Sativa",
      "thc": 28.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-287",
      "strain": "Tropical Cherry",
      "type": "Hybrid",
      "thc": 28.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-339",
      "strain": "Redneck ZaZa",
      "type": "Hybrid",
      "thc": 28.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-249",
      "strain": "Rose Gold Runtz",
      "type": "Hybrid",
      "thc": 28.87,
      "cbd": 0.1,
      "lineage": "Rose Gold x Runtz",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-345",
      "strain": "Moonbow",
      "type": "Hybrid",
      "thc": 28.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.14,
        "Limonene": 0.65,
        "Ocimene": 0,
        "Linalool": 0.42,
        "Myrcene": 0.05,
        "Terpinolene": 0,
        "Bisabolol": 0.32,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "IL"
    },
    {
      "id": "IL-424",
      "strain": "Yuzu Sour H",
      "type": "Hybrid",
      "thc": 28.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-281",
      "strain": "Delphi Diesel",
      "type": "Hybrid",
      "thc": 28.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-136",
      "strain": "Jet Fuel OG (H",
      "type": "Hybrid",
      "thc": 28.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-244",
      "strain": "Mango Mintality",
      "type": "Sativa",
      "thc": 28.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-149",
      "strain": "Sunset Sherbet",
      "type": "Hybrid",
      "thc": 28.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-161",
      "strain": "Cosmic OG",
      "type": "Hybrid",
      "thc": 28.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-389",
      "strain": "Animal Cake",
      "type": "Sativa",
      "thc": 28.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.6,
        "Humulene": 0.2,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "IL"
    },
    {
      "id": "IL-260",
      "strain": "No Talking",
      "type": "Indica",
      "thc": 28.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-319",
      "strain": "Booberry Cookies",
      "type": "Hybrid",
      "thc": 28.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-438",
      "strain": "Gush Mints (I",
      "type": "Hybrid",
      "thc": 28.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-245",
      "strain": "Pineapple Express (H",
      "type": "Hybrid",
      "thc": 28.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-312",
      "strain": "GMOmoso",
      "type": "Hybrid",
      "thc": 28.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-235",
      "strain": "That Badu",
      "type": "Hybrid",
      "thc": 28.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-295",
      "strain": "Jester",
      "type": "Indica",
      "thc": 28.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-128",
      "strain": "Fantasy Melonz",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-246",
      "strain": "Pineapple Punch S",
      "type": "Sativa",
      "thc": 28.28,
      "cbd": 0.1,
      "lineage": "Pineapple Express x Durban",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-160",
      "strain": "Citrus Bliss",
      "type": "Hybrid",
      "thc": 28.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-212",
      "strain": "Sugar Shack",
      "type": "Hybrid",
      "thc": 28.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-102",
      "strain": "Dulce de Uva",
      "type": "Indica",
      "thc": 28.21,
      "cbd": 0.1,
      "lineage": "Ice Cream Cake x (Grape Pie x Wedding Crasher",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-120",
      "strain": "Taffy Twist",
      "type": "Indica",
      "thc": 28.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-171",
      "strain": "Gorilla Cookies",
      "type": "Hybrid",
      "thc": 28.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-304",
      "strain": "Runtz Buttons",
      "type": "Hybrid",
      "thc": 28.09,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-251",
      "strain": "Alternate Reality",
      "type": "Sativa",
      "thc": 28.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-333",
      "strain": "Weedies",
      "type": "Hybrid",
      "thc": 28.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-143",
      "strain": "Rose Gold Runtz",
      "type": "Hybrid",
      "thc": 27.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-231",
      "strain": "Blue Raz",
      "type": "Hybrid",
      "thc": 27.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-462",
      "strain": "LA Wedding Pop",
      "type": "Hybrid",
      "thc": 27.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-330",
      "strain": "Sake",
      "type": "Indica",
      "thc": 27.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.34,
        "Humulene": 0.11,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.3,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.03,
        "b-Pinene": 0.07
      },
      "state": "IL"
    },
    {
      "id": "IL-118",
      "strain": "Samsquanch",
      "type": "Hybrid",
      "thc": 27.86,
      "cbd": 0.1,
      "lineage": "Brownie Scout x Baby Yoda",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-269",
      "strain": "Wandering Mind",
      "type": "Sativa",
      "thc": 27.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-290",
      "strain": "Chem Scout",
      "type": "Indica",
      "thc": 27.83,
      "cbd": 0.1,
      "lineage": "Chem 91 x GSC",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-238",
      "strain": "Canal Street Runtz ",
      "type": "Indica",
      "thc": 27.82,
      "cbd": 0.1,
      "lineage": "Pre-64 Runtz xTHC Bomb",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-475",
      "strain": "White Widow (H",
      "type": "Hybrid",
      "thc": 27.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-243",
      "strain": "Lemon Bean",
      "type": "Sativa",
      "thc": 27.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-421",
      "strain": "Modified Macberry Moonshine",
      "type": "Indica",
      "thc": 27.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-293",
      "strain": "Gas Station Sushi",
      "type": "Sativa",
      "thc": 27.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-190",
      "strain": "Silver Project",
      "type": "Hybrid",
      "thc": 27.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-446",
      "strain": "MAC 1",
      "type": "Hybrid",
      "thc": 27.57,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-207",
      "strain": "Grapes & Cream",
      "type": "Hybrid",
      "thc": 27.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-169",
      "strain": "GMO Banana",
      "type": "Indica",
      "thc": 27.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-219",
      "strain": "Pineapple Fruz",
      "type": "Hybrid",
      "thc": 27.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-412",
      "strain": "Total Eclipse",
      "type": "Sativa",
      "thc": 27.43,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-317",
      "strain": "Strawberry Twiz",
      "type": "Indica",
      "thc": 27.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-255",
      "strain": "Floor to Ceiling",
      "type": "Sativa",
      "thc": 27.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-292",
      "strain": "Gas Station Candy",
      "type": "Sativa",
      "thc": 27.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-422",
      "strain": "Private Banana",
      "type": "Hybrid",
      "thc": 27.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-156",
      "strain": "Blueberry Cookies",
      "type": "Indica",
      "thc": 27.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-401",
      "strain": "Garlic OG",
      "type": "Sativa",
      "thc": 27.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-318",
      "strain": "Umami",
      "type": "Hybrid",
      "thc": 27.29,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-124",
      "strain": "Bubba Fett",
      "type": "Indica",
      "thc": 27.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-189",
      "strain": "Melonade H",
      "type": "Hybrid",
      "thc": 27.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-112",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 27.13,
      "cbd": 0.1,
      "lineage": "Oregon Lemon x Orange Crush",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-463",
      "strain": "Sake",
      "type": "Indica",
      "thc": 27.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.32,
        "Humulene": 0.1,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 0.32,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "IL"
    },
    {
      "id": "IL-208",
      "strain": "Lou's Legacy",
      "type": "Hybrid",
      "thc": 27.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.15,
        "Humulene": 0.04,
        "Limonene": 0.13,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.26,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "IL"
    },
    {
      "id": "IL-105",
      "strain": "EverCrisp",
      "type": "Hybrid",
      "thc": 27.02,
      "cbd": 0.1,
      "lineage": "Apple Fritter x SinMint Cookies",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-261",
      "strain": "Open Harmony",
      "type": "Indica",
      "thc": 27.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-350",
      "strain": "Banana Deep",
      "type": "Hybrid",
      "thc": 26.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-450",
      "strain": "Super Citrus Haze",
      "type": "Hybrid",
      "thc": 26.92,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-439",
      "strain": "Gush Mints",
      "type": "Hybrid",
      "thc": 26.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-122",
      "strain": "Black Maple #22",
      "type": "Hybrid",
      "thc": 26.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-193",
      "strain": "G Tank",
      "type": "Hybrid",
      "thc": 26.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-331",
      "strain": "Triangle Cake (I",
      "type": "Indica",
      "thc": 26.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-285",
      "strain": "Bananaconda (S",
      "type": "Hybrid",
      "thc": 26.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-206",
      "strain": "Grape Pie (I",
      "type": "Indica",
      "thc": 26.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-467",
      "strain": "Goon Berries",
      "type": "Indica",
      "thc": 26.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-175",
      "strain": "Kush Cake (I",
      "type": "Indica",
      "thc": 26.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-201",
      "strain": "MAC 1",
      "type": "Hybrid",
      "thc": 26.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-202",
      "strain": "Banana Deep",
      "type": "Hybrid",
      "thc": 26.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-432",
      "strain": "Diesel Breath",
      "type": "Hybrid",
      "thc": 26.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-431",
      "strain": "Citrus Crush",
      "type": "Hybrid",
      "thc": 26.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-203",
      "strain": "Banana Drank",
      "type": "Hybrid",
      "thc": 26.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-461",
      "strain": "Blue Power",
      "type": "Hybrid",
      "thc": 26.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-252",
      "strain": "Arc Reactor",
      "type": "Sativa",
      "thc": 26.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-466",
      "strain": "Black Lime 98",
      "type": "Indica",
      "thc": 26.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-420",
      "strain": "Mega Squirt",
      "type": "Hybrid",
      "thc": 26.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-103",
      "strain": "Durban Z",
      "type": "Sativa",
      "thc": 26.44,
      "cbd": 0.1,
      "lineage": "ZKZ x Durban Poison",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-145",
      "strain": "SinMint Sundae",
      "type": "Hybrid",
      "thc": 26.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-233",
      "strain": "Fried Bananas",
      "type": "Hybrid",
      "thc": 26.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-265",
      "strain": "Soul Stone",
      "type": "Sativa",
      "thc": 26.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-400",
      "strain": "Full Metal B",
      "type": "Hybrid",
      "thc": 26.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-305",
      "strain": "The Bling",
      "type": "Hybrid",
      "thc": 26.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-126",
      "strain": "Confidential Cherries",
      "type": "Indica",
      "thc": 26.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-151",
      "strain": "White Durban",
      "type": "Sativa",
      "thc": 26.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-254",
      "strain": "Concierge",
      "type": "Indica",
      "thc": 26.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-291",
      "strain": "Cinnamon Milk",
      "type": "Hybrid",
      "thc": 26.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-127",
      "strain": "Creamsicle Sunset",
      "type": "Hybrid",
      "thc": 26.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-347",
      "strain": "Planet of the Grapes",
      "type": "Sativa",
      "thc": 26.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.1,
        "Limonene": 0.07,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.38,
        "Terpinolene": 0,
        "Bisabolol": 0.13,
        "Pinene": 0,
        "b-Pinene": 0.02
      },
      "state": "IL"
    },
    {
      "id": "IL-423",
      "strain": "Rocky Road",
      "type": "Indica",
      "thc": 26.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-474",
      "strain": "NF-1",
      "type": "Hybrid",
      "thc": 25.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-329",
      "strain": "Planet Sherb",
      "type": "Indica",
      "thc": 25.92,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-294",
      "strain": "Ice Cream Cake",
      "type": "Indica",
      "thc": 25.91,
      "cbd": 0.1,
      "lineage": "Wedding Cake and Gelato #33",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-320",
      "strain": "Crazy Hazey",
      "type": "Sativa",
      "thc": 25.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.06,
        "Humulene": 0.02,
        "Limonene": 0.12,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.3,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.07,
        "b-Pinene": 0.12
      },
      "state": "IL"
    },
    {
      "id": "IL-132",
      "strain": "Honey Zanana",
      "type": "Hybrid",
      "thc": 25.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-426",
      "strain": "Applescotti",
      "type": "Hybrid",
      "thc": 25.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-297",
      "strain": "Lemon Bean",
      "type": "Sativa",
      "thc": 25.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-328",
      "strain": "Planet of the Grapes",
      "type": "Hybrid",
      "thc": 25.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.12,
        "Limonene": 0.08,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.94,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0,
        "b-Pinene": 0.02
      },
      "state": "IL"
    },
    {
      "id": "IL-399",
      "strain": "Crunch Berries",
      "type": "Indica",
      "thc": 25.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-256",
      "strain": "Hidden Message",
      "type": "Sativa",
      "thc": 25.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-348",
      "strain": "Planet Sherb",
      "type": "Indica",
      "thc": 25.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-406",
      "strain": "Farmer's Daughter",
      "type": "Hybrid",
      "thc": 25.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-358",
      "strain": "Crazy Hazey",
      "type": "Sativa",
      "thc": 25.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-163",
      "strain": "Crazy FaceBow",
      "type": "Sativa",
      "thc": 25.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-178",
      "strain": "Nightcap Nectar",
      "type": "Indica",
      "thc": 25.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-141",
      "strain": "Paradise Snacks",
      "type": "Indica",
      "thc": 25.75,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-196",
      "strain": "Gorilla Cookies",
      "type": "Hybrid",
      "thc": 25.75,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-363",
      "strain": "Papaya (H",
      "type": "Hybrid",
      "thc": 25.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-402",
      "strain": "Rainbow Runtz",
      "type": "Hybrid",
      "thc": 25.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-158",
      "strain": "California Sunset",
      "type": "Hybrid",
      "thc": 25.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-302",
      "strain": "Purple Plague",
      "type": "Sativa",
      "thc": 25.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-195",
      "strain": "GMO Oz",
      "type": "Hybrid",
      "thc": 25.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-210",
      "strain": "Michelin Star",
      "type": "Hybrid",
      "thc": 25.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-414",
      "strain": "Zeebra Cakez",
      "type": "Sativa",
      "thc": 25.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-440",
      "strain": "Heir Heads",
      "type": "Hybrid",
      "thc": 25.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-100",
      "strain": "Chicken N Waffles",
      "type": "Sativa",
      "thc": 25.51,
      "cbd": 0.1,
      "lineage": "Jelly Donutz x Purple Cartel",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-443",
      "strain": "LA Runtz",
      "type": "Hybrid",
      "thc": 25.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-408",
      "strain": "Mac and Cheese",
      "type": "Sativa",
      "thc": 25.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-407",
      "strain": "Frost Donkey BX1",
      "type": "Sativa",
      "thc": 25.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-472",
      "strain": "Headband",
      "type": "Hybrid",
      "thc": 25.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-234",
      "strain": "Ridgeline Lantz",
      "type": "Hybrid",
      "thc": 25.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-264",
      "strain": "Shutter Speed",
      "type": "Sativa",
      "thc": 25.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-130",
      "strain": "Grinch Mints",
      "type": "Hybrid",
      "thc": 25.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-365",
      "strain": "Super Boof",
      "type": "Hybrid",
      "thc": 25.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-135",
      "strain": "Jack Herer",
      "type": "Sativa",
      "thc": 25.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-137",
      "strain": "Lavender Gelato",
      "type": "Hybrid",
      "thc": 25.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-442",
      "strain": "Kush & Cream",
      "type": "Hybrid",
      "thc": 25.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-164",
      "strain": "Electric Kush",
      "type": "Sativa",
      "thc": 25.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-327",
      "strain": "Papaya (H",
      "type": "Hybrid",
      "thc": 25.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-378",
      "strain": "Goon Berries",
      "type": "Indica",
      "thc": 25.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-455",
      "strain": "Blueberry Clementine",
      "type": "Indica",
      "thc": 25.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-298",
      "strain": "Morning Dew",
      "type": "Sativa",
      "thc": 25.11,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-405",
      "strain": "Closet Gremlin",
      "type": "Indica",
      "thc": 25.02,
      "cbd": 0.1,
      "lineage": "GMO x (Secret Weapon x Cookies & Cream",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-470",
      "strain": "Blue Dream (H",
      "type": "Hybrid",
      "thc": 25.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-113",
      "strain": "Mystic Mint",
      "type": "Indica",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Kush Mints x Cookies & Cream",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-425",
      "strain": "Apples & Bananas",
      "type": "Hybrid",
      "thc": 24.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.09,
        "Limonene": 0.06,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 1.11,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.26,
        "b-Pinene": 0.08
      },
      "state": "IL"
    },
    {
      "id": "IL-315",
      "strain": "Bubble Bath",
      "type": "Indica",
      "thc": 24.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-460",
      "strain": "Yuzu Sour",
      "type": "Sativa",
      "thc": 24.87,
      "cbd": 0.1,
      "lineage": "Orange Sherbert x OZ Kush x Gastropop",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-253",
      "strain": "Brainteaser",
      "type": "Hybrid",
      "thc": 24.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-447",
      "strain": "Mandarin Z (I",
      "type": "Hybrid",
      "thc": 24.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-346",
      "strain": "Papaya (H",
      "type": "Hybrid",
      "thc": 24.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-131",
      "strain": "Head Cracker",
      "type": "Indica",
      "thc": 24.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-403",
      "strain": "Baker's Dream",
      "type": "Hybrid",
      "thc": 24.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-451",
      "strain": "Vanilla Frost H",
      "type": "Hybrid",
      "thc": 24.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-230",
      "strain": "Apples and Bananas",
      "type": "Hybrid",
      "thc": 24.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-349",
      "strain": "The Scrooge",
      "type": "Sativa",
      "thc": 24.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.68,
        "Humulene": 0.2,
        "Limonene": 0.46,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "IL"
    },
    {
      "id": "IL-147",
      "strain": "Sour Diesel (S",
      "type": "Sativa",
      "thc": 24.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-188",
      "strain": "Gastro Pop",
      "type": "Hybrid",
      "thc": 24.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-380",
      "strain": "Jokerz Candy",
      "type": "Indica",
      "thc": 24.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-459",
      "strain": "Royale",
      "type": "Indica",
      "thc": 24.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-410",
      "strain": "Purple Milk",
      "type": "Indica",
      "thc": 24.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-211",
      "strain": "Platinum Strawberries",
      "type": "Hybrid",
      "thc": 24.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-266",
      "strain": "Spirit Bond I",
      "type": "Indica",
      "thc": 24.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-278",
      "strain": "Skywalker (I",
      "type": "Indica",
      "thc": 24.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-382",
      "strain": "Snapplez",
      "type": "Sativa",
      "thc": 24.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-282",
      "strain": "Orange Z",
      "type": "Sativa",
      "thc": 24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-379",
      "strain": "Island Berry Pie",
      "type": "Hybrid",
      "thc": 24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-101",
      "strain": "Confidential Cherries",
      "type": "Indica",
      "thc": 23.99,
      "cbd": 0.1,
      "lineage": "LA Confidential x Sour Animal Cherries",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-437",
      "strain": "Guava Smash",
      "type": "Hybrid",
      "thc": 23.99,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-376",
      "strain": "Coffee Creamer",
      "type": "Indica",
      "thc": 23.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-370",
      "strain": "Deep Fried Runtz",
      "type": "Hybrid",
      "thc": 23.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-415",
      "strain": "Animal Fuel",
      "type": "Indica",
      "thc": 23.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-428",
      "strain": "Blue Dream (H",
      "type": "Hybrid",
      "thc": 23.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.15,
        "Humulene": 0.05,
        "Limonene": 0.05,
        "Ocimene": 0,
        "Linalool": 0.03,
        "Myrcene": 0.35,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.24,
        "b-Pinene": 0.11
      },
      "state": "IL"
    },
    {
      "id": "IL-458",
      "strain": "Georgia Pie",
      "type": "Hybrid",
      "thc": 23.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-356",
      "strain": "Strawberry Twiz",
      "type": "Indica",
      "thc": 23.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-375",
      "strain": "Black Lime 98",
      "type": "Hybrid",
      "thc": 23.57,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-413",
      "strain": "Yuzu Sour",
      "type": "Sativa",
      "thc": 23.45,
      "cbd": 0.1,
      "lineage": "Orange Sherbert x OZ Kush x Gastropop",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-268",
      "strain": "Transposition",
      "type": "Hybrid",
      "thc": 23.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-456",
      "strain": "Frost Donkey BX1",
      "type": "Sativa",
      "thc": 23.41,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-449",
      "strain": "Runtz",
      "type": "Hybrid",
      "thc": 23.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-352",
      "strain": "Lemon Cherry Garlic",
      "type": "Indica",
      "thc": 23.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.07,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.11,
        "b-Pinene": 0.12
      },
      "state": "IL"
    },
    {
      "id": "IL-366",
      "strain": "Truffle Monkey",
      "type": "Hybrid",
      "thc": 23.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-172",
      "strain": "Grape Chem",
      "type": "Hybrid",
      "thc": 23.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-276",
      "strain": "Apple Cup",
      "type": "Hybrid",
      "thc": 23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-198",
      "strain": "Jack Herer",
      "type": "Sativa",
      "thc": 22.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-218",
      "strain": "Grape Crasher",
      "type": "Hybrid",
      "thc": 22.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-166",
      "strain": "Frostline Mint",
      "type": "Hybrid",
      "thc": 22.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-398",
      "strain": "Apple Fritter",
      "type": "Hybrid",
      "thc": 22.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-115",
      "strain": "Paradise Snacks",
      "type": "Indica",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-411",
      "strain": "Samba Slapz",
      "type": "Sativa",
      "thc": 22.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-314",
      "strain": "Booger Sugar",
      "type": "Sativa",
      "thc": 22.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-404",
      "strain": "Berried Treasure",
      "type": "Indica",
      "thc": 22.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-383",
      "strain": "Supreme Diesel",
      "type": "Hybrid",
      "thc": 22.43,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-353",
      "strain": "Big Perm",
      "type": "Indica",
      "thc": 22.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-286",
      "strain": "Pineapple Fruz",
      "type": "Hybrid",
      "thc": 22.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-377",
      "strain": "GMO Z",
      "type": "Hybrid",
      "thc": 22.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-364",
      "strain": "The Scrooge I",
      "type": "Indica",
      "thc": 22.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-177",
      "strain": "Monkey Bread",
      "type": "Sativa",
      "thc": 22.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-138",
      "strain": "Living Legend",
      "type": "Sativa",
      "thc": 22.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-154",
      "strain": "Berry Nebula",
      "type": "Hybrid",
      "thc": 22.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-303",
      "strain": "Rollins",
      "type": "Sativa",
      "thc": 22.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-367",
      "strain": "Zushi Generous",
      "type": "Indica",
      "thc": 22.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-125",
      "strain": "Clementine (S",
      "type": "Sativa",
      "thc": 21.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-146",
      "strain": "Slapz",
      "type": "Hybrid",
      "thc": 21.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-277",
      "strain": "Double Durban Kush",
      "type": "Sativa",
      "thc": 21.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-187",
      "strain": "Facetz (I",
      "type": "Hybrid",
      "thc": 21.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-469",
      "strain": "Vlad the Inhaler",
      "type": "Indica",
      "thc": 21.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-121",
      "strain": "Vanilla Frosting",
      "type": "Indica",
      "thc": 21.2,
      "cbd": 0.1,
      "lineage": "Humboldt Frost x Humboldt Gelato Bx3",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-288",
      "strain": "ZKTZ Cubed",
      "type": "Hybrid",
      "thc": 21.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-267",
      "strain": "The Thinker",
      "type": "Sativa",
      "thc": 21.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-279",
      "strain": "Sour Banana Sherbet No.2",
      "type": "Hybrid",
      "thc": 20.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-142",
      "strain": "Regina George",
      "type": "Hybrid",
      "thc": 20.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-355",
      "strain": "Gelly Roll",
      "type": "Hybrid",
      "thc": 20.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-220",
      "strain": "Runtz Medley",
      "type": "Hybrid",
      "thc": 20.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-429",
      "strain": "Blueberry Sugar",
      "type": "Hybrid",
      "thc": 20.45,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.13,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.64,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.14,
        "b-Pinene": 0.08
      },
      "state": "IL"
    },
    {
      "id": "IL-354",
      "strain": "Booger Sugar",
      "type": "Sativa",
      "thc": 20.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-300",
      "strain": "Pineapple Express",
      "type": "Hybrid",
      "thc": 20.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-468",
      "strain": "Purple Pineapple",
      "type": "Indica",
      "thc": 19.99,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-441",
      "strain": "Jokerz Candy 5",
      "type": "Hybrid",
      "thc": 19.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-150",
      "strain": "Vanilla Frosting",
      "type": "Indica",
      "thc": 19.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-259",
      "strain": "Melon Water",
      "type": "Hybrid",
      "thc": 18.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-144",
      "strain": "Sativa Blend",
      "type": "Sativa",
      "thc": 18.55,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-133",
      "strain": "Hybrid Blend",
      "type": "Hybrid",
      "thc": 14.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-114",
      "strain": "Orange Herijuana (CBD",
      "type": "Cbd",
      "thc": 12.72,
      "cbd": 0.1,
      "lineage": "Orange Creamsicle x Herijuana",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-381",
      "strain": "Skywalker (I",
      "type": "Indica",
      "thc": 2.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-174",
      "strain": "Hybrid",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-191",
      "strain": "8 Inch Bagel",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-257",
      "strain": "Hybrid",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-368",
      "strain": "Bluenana",
      "type": "Indica",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-369",
      "strain": "Cherry Cheeks",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-371",
      "strain": "Double Durban Kush",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-372",
      "strain": "Snapplez",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-373",
      "strain": "Sour Banana Sherbet #2",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    },
    {
      "id": "IL-374",
      "strain": "Wedding Cake",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "IL"
    }
  ],
  NJ: [
    {
      "id": "NJ-227",
      "strain": "Chocolate Cherry OG",
      "type": "Indica",
      "thc": 54.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.45,
        "Humulene": 0.11,
        "Limonene": 0.16,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.15,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.01,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-226",
      "strain": "Billionaire",
      "type": "Sativa",
      "thc": 51.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.44,
        "Humulene": 0.11,
        "Limonene": 0.2,
        "Ocimene": 0,
        "Linalool": 0.27,
        "Myrcene": 0.11,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-228",
      "strain": "Sour Banana Sherbet",
      "type": "Hybrid",
      "thc": 51.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.7,
        "Humulene": 0.17,
        "Limonene": 0.21,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.12,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-151",
      "strain": "Orange Push Pop",
      "type": "Hybrid",
      "thc": 37.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.08,
        "Limonene": 0.61,
        "Ocimene": 0,
        "Linalool": 0.32,
        "Myrcene": 0.27,
        "Terpinolene": 0.07,
        "Bisabolol": 0.03,
        "Pinene": 0.07,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-193",
      "strain": "Ghost OG",
      "type": "Hybrid",
      "thc": 32.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.14,
        "Limonene": 0.67,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.78,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-146",
      "strain": "Fig Bar",
      "type": "Hybrid",
      "thc": 32.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.12,
        "Limonene": 0.76,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.26,
        "Terpinolene": 0.08,
        "Bisabolol": 0.02,
        "Pinene": 0.09,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-169",
      "strain": "24k",
      "type": "Sativa",
      "thc": 32.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.44,
        "Humulene": 0.25,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.7,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-152",
      "strain": "Tahoe OG",
      "type": "Indica",
      "thc": 32.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.12,
        "Limonene": 0.94,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.73,
        "Terpinolene": 0.08,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-229",
      "strain": "Fresh Powder #9",
      "type": "Sativa",
      "thc": 31.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.11,
        "Limonene": 0.34,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.28,
        "Terpinolene": 0.37,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-202",
      "strain": "White Iverson",
      "type": "Indica",
      "thc": 31.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0.13,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.24,
        "Terpinolene": 0.01,
        "Bisabolol": 0.02,
        "Pinene": 1.21,
        "b-Pinene": 0.37
      },
      "state": "NJ"
    },
    {
      "id": "NJ-168",
      "strain": "Watermelon Cakez",
      "type": "Hybrid",
      "thc": 31.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.97,
        "Humulene": 0.32,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.46,
        "Myrcene": 0.9,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-231",
      "strain": "Motorbreath",
      "type": "Indica",
      "thc": 31.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.66,
        "Humulene": 0.17,
        "Limonene": 0.51,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 1.12,
        "Terpinolene": 0.03,
        "Bisabolol": 0.12,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-190",
      "strain": "Washington Apple",
      "type": "Hybrid",
      "thc": 31.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.07,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.38,
        "Myrcene": 0.57,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-104",
      "strain": "VelcroZ",
      "type": "Hybrid",
      "thc": 31.09,
      "cbd": 0.1,
      "lineage": "Blue Flame OG x Blue Zushi",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.15,
        "Limonene": 0.81,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.63,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-196",
      "strain": "Max AC",
      "type": "Hybrid",
      "thc": 31.01,
      "cbd": 0.1,
      "lineage": "MAC 1 and Animal Cookies",
      "terpenes": {
        "Caryophyllene": 0.59,
        "Humulene": 0.19,
        "Limonene": 0.38,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.29,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-148",
      "strain": "J1",
      "type": "Hybrid",
      "thc": 30.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.11,
        "Limonene": 0.14,
        "Ocimene": 0,
        "Linalool": 0.03,
        "Myrcene": 0.24,
        "Terpinolene": 1.59,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-149",
      "strain": "LA Piff",
      "type": "Hybrid",
      "thc": 30.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.68,
        "Humulene": 0.17,
        "Limonene": 0.49,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.37,
        "Terpinolene": 1.6,
        "Bisabolol": 0,
        "Pinene": 0.11,
        "b-Pinene": 0.16
      },
      "state": "NJ"
    },
    {
      "id": "NJ-197",
      "strain": "Mintlato",
      "type": "Hybrid",
      "thc": 29.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.99,
        "Humulene": 0.24,
        "Limonene": 0.79,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.11,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-160",
      "strain": "Sticky Buns x Gelato",
      "type": "Hybrid",
      "thc": 29.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.7,
        "Humulene": 0.16,
        "Limonene": 0.81,
        "Ocimene": 0,
        "Linalool": 0.5,
        "Myrcene": 0.31,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-117",
      "strain": "GMO (I",
      "type": "Indica",
      "thc": 29.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.57,
        "Humulene": 0.17,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.44,
        "Terpinolene": 0.01,
        "Bisabolol": 0.07,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-215",
      "strain": "Gelato 41",
      "type": "Indica",
      "thc": 29.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.82,
        "Humulene": 0.2,
        "Limonene": 0.67,
        "Ocimene": 0,
        "Linalool": 0.44,
        "Myrcene": 0.15,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-120",
      "strain": "Kush Mountains",
      "type": "Indica",
      "thc": 29.57,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.34,
        "Humulene": 0.1,
        "Limonene": 0.85,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.77,
        "Terpinolene": 0.03,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-210",
      "strain": "Apple Fritter",
      "type": "Hybrid",
      "thc": 29.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.92,
        "Humulene": 0.24,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.07,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.15,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-219",
      "strain": "Motorbreath",
      "type": "Indica",
      "thc": 29.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.79,
        "Humulene": 0.18,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.78,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-153",
      "strain": "Black Cherry Gelato",
      "type": "Indica",
      "thc": 28.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.11,
        "Limonene": 0.64,
        "Ocimene": 0,
        "Linalool": 0.46,
        "Myrcene": 0.87,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-199",
      "strain": "Cherry Slushee",
      "type": "Hybrid",
      "thc": 28.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.3,
        "Humulene": 0.05,
        "Limonene": 0.16,
        "Ocimene": 0,
        "Linalool": 0.03,
        "Myrcene": 1.92,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.14,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-218",
      "strain": "Lemon Cherry Pie (S",
      "type": "Sativa",
      "thc": 28.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.48,
        "Humulene": 0.1,
        "Limonene": 0.93,
        "Ocimene": 0,
        "Linalool": 0.39,
        "Myrcene": 0.51,
        "Terpinolene": 0.04,
        "Bisabolol": 0,
        "Pinene": 0.12,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-207",
      "strain": "Cake Walk",
      "type": "Hybrid",
      "thc": 28.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.12,
        "Limonene": 0.25,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.2,
        "Terpinolene": 0.01,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-141",
      "strain": "Whoa-Si-Whoa",
      "type": "Hybrid",
      "thc": 28.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.53,
        "Humulene": 0.14,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.32,
        "Terpinolene": 0.01,
        "Bisabolol": 0.1,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-230",
      "strain": "Grape Gasoline",
      "type": "Indica",
      "thc": 28.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.6,
        "Humulene": 0.12,
        "Limonene": 0.25,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.74,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-164",
      "strain": "Pineapple Donut",
      "type": "Indica",
      "thc": 28.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.04,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.45,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-170",
      "strain": "Candy Fumez",
      "type": "Hybrid",
      "thc": 28.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.58,
        "Humulene": 0.26,
        "Limonene": 0.95,
        "Ocimene": 0,
        "Linalool": 0.5,
        "Myrcene": 0.06,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.19,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-239",
      "strain": "GP II",
      "type": "Sativa",
      "thc": 28.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.82,
        "Humulene": 0.27,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.15,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-232",
      "strain": "Purple Octane x Jealousy",
      "type": "Hybrid",
      "thc": 28.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.05,
        "Humulene": 0.25,
        "Limonene": 1.11,
        "Ocimene": 0,
        "Linalool": 0.35,
        "Myrcene": 0.15,
        "Terpinolene": 0.05,
        "Bisabolol": 0.12,
        "Pinene": 0.22,
        "b-Pinene": 0.15
      },
      "state": "NJ"
    },
    {
      "id": "NJ-150",
      "strain": "Lemon Cherry Gelato",
      "type": "Hybrid",
      "thc": 28.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.91,
        "Humulene": 0.26,
        "Limonene": 0.82,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.09,
        "Terpinolene": 0.1,
        "Bisabolol": 0.13,
        "Pinene": 0.13,
        "b-Pinene": 0.17
      },
      "state": "NJ"
    },
    {
      "id": "NJ-209",
      "strain": "Sour Orange",
      "type": "Indica",
      "thc": 28.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.3,
        "Humulene": 0.07,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.19,
        "Terpinolene": 0.02,
        "Bisabolol": 0.03,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-159",
      "strain": "Mexican Flan",
      "type": "Hybrid",
      "thc": 28.08,
      "cbd": 0.1,
      "lineage": "Experience:",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.1,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.39,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-187",
      "strain": "Permanent Marker",
      "type": "Hybrid",
      "thc": 27.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.66,
        "Humulene": 0.16,
        "Limonene": 1.11,
        "Ocimene": 0,
        "Linalool": 0.48,
        "Myrcene": 0.09,
        "Terpinolene": 0.01,
        "Bisabolol": 0.11,
        "Pinene": 0.32,
        "b-Pinene": 0.17
      },
      "state": "NJ"
    },
    {
      "id": "NJ-162",
      "strain": "Cheddar Cheeze",
      "type": "Hybrid",
      "thc": 27.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.2,
        "Humulene": 0.06,
        "Limonene": 0.41,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.43,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-130",
      "strain": "Fresh Powder #9",
      "type": "Sativa",
      "thc": 27.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.12,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.29,
        "Terpinolene": 0.82,
        "Bisabolol": 0,
        "Pinene": 0.11,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-233",
      "strain": "Bubba Kush (I",
      "type": "Hybrid",
      "thc": 27.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.13,
        "Limonene": 0.77,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.2,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.1,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-235",
      "strain": "Beyond Blueberry",
      "type": "Indica",
      "thc": 27.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.06,
        "Limonene": 0.34,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.37,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-201",
      "strain": "Ice Cream Banger",
      "type": "Hybrid",
      "thc": 27.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.5,
        "Humulene": 0.12,
        "Limonene": 0.92,
        "Ocimene": 0,
        "Linalool": 0.44,
        "Myrcene": 0.24,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-173",
      "strain": "Paydaze",
      "type": "Indica",
      "thc": 27.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.32,
        "Limonene": 0.99,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.25,
        "Terpinolene": 0.02,
        "Bisabolol": 0.07,
        "Pinene": 0.14,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-186",
      "strain": "Mac #1",
      "type": "Hybrid",
      "thc": 27.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.12,
        "Limonene": 0.79,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.19,
        "Terpinolene": 0,
        "Bisabolol": 0.14,
        "Pinene": 0.22,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-103",
      "strain": "Scotch & Soda",
      "type": "Hybrid",
      "thc": 27.11,
      "cbd": 0.1,
      "lineage": "Banana Punch GMO#2 x LilMissHS",
      "terpenes": {
        "Caryophyllene": 0.2,
        "Humulene": 0.06,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 1.22,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-133",
      "strain": "Glaciers",
      "type": "Indica",
      "thc": 27.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.34,
        "Humulene": 0.23,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.34,
        "Myrcene": 0.47,
        "Terpinolene": 0.01,
        "Bisabolol": 0.1,
        "Pinene": 0.05,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-179",
      "strain": "Blue Lobster",
      "type": "Hybrid",
      "thc": 27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.06,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 0.23,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-156",
      "strain": "Cereal Milk x Gelato",
      "type": "Hybrid",
      "thc": 26.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.75,
        "Humulene": 0.18,
        "Limonene": 0.91,
        "Ocimene": 0,
        "Linalool": 0.82,
        "Myrcene": 0.46,
        "Terpinolene": 0.02,
        "Bisabolol": 0.06,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-135",
      "strain": "PCG Runtz",
      "type": "Hybrid",
      "thc": 26.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.11,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.51,
        "Myrcene": 1.1,
        "Terpinolene": 0.04,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-121",
      "strain": "La Kush Cake",
      "type": "Indica",
      "thc": 26.95,
      "cbd": 0.1,
      "lineage": "Kush Mints x Wedding Cake",
      "terpenes": {
        "Caryophyllene": 0.91,
        "Humulene": 0.2,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.11,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-128",
      "strain": "Blueberry Muffins (I",
      "type": "Indica",
      "thc": 26.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.38,
        "Humulene": 0.38,
        "Limonene": 0.33,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.36,
        "Terpinolene": 0.02,
        "Bisabolol": 0.26,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-205",
      "strain": "Quiet Times Mendo OG Kush",
      "type": "Indica",
      "thc": 26.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.66,
        "Humulene": 0.28,
        "Limonene": 1.26,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.17,
        "Terpinolene": 0.02,
        "Bisabolol": 0.05,
        "Pinene": 0.15,
        "b-Pinene": 0.13
      },
      "state": "NJ"
    },
    {
      "id": "NJ-188",
      "strain": "Pink Lady",
      "type": "Hybrid",
      "thc": 26.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.73,
        "Humulene": 0.18,
        "Limonene": 0.24,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 2.21,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.46,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-109",
      "strain": "Chem Scout '87",
      "type": "Hybrid",
      "thc": 26.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.52,
        "Humulene": 0.16,
        "Limonene": 0.15,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 1.32,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.01,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-114",
      "strain": "Fantasy Melonz",
      "type": "Hybrid",
      "thc": 26.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.35,
        "Humulene": 0.07,
        "Limonene": 0.87,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.26,
        "Terpinolene": 0.01,
        "Bisabolol": 0.06,
        "Pinene": 0.17,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-106",
      "strain": "Black Afghan",
      "type": "Indica",
      "thc": 26.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.44,
        "Humulene": 0.11,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 1.68,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.54,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-139",
      "strain": "Rainbow Belts 3.0",
      "type": "Hybrid",
      "thc": 26.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.72,
        "Humulene": 0.17,
        "Limonene": 0.75,
        "Ocimene": 0,
        "Linalool": 0.49,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-129",
      "strain": "Cookies and Cream (I",
      "type": "Indica",
      "thc": 26.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.05,
        "Humulene": 0.24,
        "Limonene": 0.31,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.31,
        "Terpinolene": 0.01,
        "Bisabolol": 0.1,
        "Pinene": 0,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-182",
      "strain": "Category 5",
      "type": "Sativa",
      "thc": 26.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.23,
        "Limonene": 0.78,
        "Ocimene": 0,
        "Linalool": 0.5,
        "Myrcene": 0.71,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-204",
      "strain": "Rainbow Grapefruit",
      "type": "Sativa",
      "thc": 26.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.67,
        "Humulene": 0.21,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-175",
      "strain": "Sherbanger (H",
      "type": "Hybrid",
      "thc": 26.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.66,
        "Humulene": 0.32,
        "Limonene": 0.57,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.03,
        "Terpinolene": 0.02,
        "Bisabolol": 0.03,
        "Pinene": 0.17,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-157",
      "strain": "Cheetah Piss x Georgia Pie #9",
      "type": "Hybrid",
      "thc": 26.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.36,
        "Humulene": 0.32,
        "Limonene": 0.79,
        "Ocimene": 0,
        "Linalool": 0.37,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-180",
      "strain": "Moonbeam Gelato",
      "type": "Hybrid",
      "thc": 26.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.13,
        "Limonene": 0.86,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.43,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-189",
      "strain": "Pink Passion Fruit",
      "type": "Hybrid",
      "thc": 26.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.06,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 1.61,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.55,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-111",
      "strain": "Donut Trip",
      "type": "Hybrid",
      "thc": 26.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0.12,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.07,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-195",
      "strain": "Grapezilla",
      "type": "Indica",
      "thc": 26.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.76,
        "Humulene": 0.14,
        "Limonene": 0.91,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.18,
        "b-Pinene": 0.18
      },
      "state": "NJ"
    },
    {
      "id": "NJ-122",
      "strain": "OMG",
      "type": "Hybrid",
      "thc": 26.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.1,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 1.21,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-155",
      "strain": "Blueberry Caviar",
      "type": "Hybrid",
      "thc": 25.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.09,
        "Limonene": 1.34,
        "Ocimene": 0,
        "Linalool": 0.73,
        "Myrcene": 0.58,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.1,
        "b-Pinene": 0.16
      },
      "state": "NJ"
    },
    {
      "id": "NJ-172",
      "strain": "Headshot",
      "type": "Hybrid",
      "thc": 25.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.66,
        "Humulene": 0.19,
        "Limonene": 0.09,
        "Ocimene": 0,
        "Linalool": 0.24,
        "Myrcene": 0.9,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-137",
      "strain": "The Soap (S",
      "type": "Sativa",
      "thc": 25.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.12,
        "Limonene": 0.36,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-124",
      "strain": "Rose Gold Runtz",
      "type": "Hybrid",
      "thc": 25.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.7,
        "Humulene": 0.16,
        "Limonene": 0.37,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-183",
      "strain": "GMO Pie",
      "type": "Hybrid",
      "thc": 25.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.77,
        "Humulene": 0.2,
        "Limonene": 0.69,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.09,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-178",
      "strain": "Arancello",
      "type": "Hybrid",
      "thc": 25.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.07,
        "Limonene": 0.26,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.59,
        "Terpinolene": 0.96,
        "Bisabolol": 0,
        "Pinene": 0.11,
        "b-Pinene": 0.14
      },
      "state": "NJ"
    },
    {
      "id": "NJ-177",
      "strain": "Angel Hair",
      "type": "Hybrid",
      "thc": 25.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.64,
        "Humulene": 0.16,
        "Limonene": 1.38,
        "Ocimene": 0,
        "Linalool": 0.7,
        "Myrcene": 0.08,
        "Terpinolene": 0.02,
        "Bisabolol": 0.05,
        "Pinene": 0.17,
        "b-Pinene": 0.16
      },
      "state": "NJ"
    },
    {
      "id": "NJ-212",
      "strain": "Gush Mints",
      "type": "Indica",
      "thc": 25.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.75,
        "Humulene": 0.21,
        "Limonene": 0.37,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-198",
      "strain": "Chem Krush",
      "type": "Sativa",
      "thc": 25.61,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.34,
        "Humulene": 0.08,
        "Limonene": 0.36,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.89,
        "Terpinolene": 1.66,
        "Bisabolol": 0,
        "Pinene": 0.12,
        "b-Pinene": 0.14
      },
      "state": "NJ"
    },
    {
      "id": "NJ-174",
      "strain": "Red Hotz",
      "type": "Hybrid",
      "thc": 25.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.67,
        "Humulene": 0.48,
        "Limonene": 0.76,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.09,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-102",
      "strain": "Runtz",
      "type": "Hybrid",
      "thc": 25.5,
      "cbd": 0.1,
      "lineage": "Gelato x ZKZ",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.11,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.34,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-171",
      "strain": "Fruit Stand",
      "type": "Hybrid",
      "thc": 25.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.86,
        "Humulene": 0.46,
        "Limonene": 0.83,
        "Ocimene": 0,
        "Linalool": 0.27,
        "Myrcene": 0.07,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.18,
        "b-Pinene": 0.14
      },
      "state": "NJ"
    },
    {
      "id": "NJ-208",
      "strain": "Garlic Cookies (H",
      "type": "Hybrid",
      "thc": 25.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.2,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.04,
        "Myrcene": 0.37,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-131",
      "strain": "Gelato 41",
      "type": "Indica",
      "thc": 25.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.57,
        "Humulene": 0.14,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.4,
        "Myrcene": 0.12,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-112",
      "strain": "Dulce de Uva",
      "type": "Hybrid",
      "thc": 25.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.11,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.39,
        "Terpinolene": 0.02,
        "Bisabolol": 0.04,
        "Pinene": 0.07,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-220",
      "strain": "White Runtz",
      "type": "Hybrid",
      "thc": 25.23,
      "cbd": 0.1,
      "lineage": "Runtz x The White",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.1,
        "Limonene": 0.54,
        "Ocimene": 0,
        "Linalool": 0.45,
        "Myrcene": 1.04,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-185",
      "strain": "Jack Herer",
      "type": "Sativa",
      "thc": 25.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.13,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.25,
        "Terpinolene": 0.43,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-234",
      "strain": "Sour Blueberry (S",
      "type": "Hybrid",
      "thc": 25.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.34,
        "Humulene": 0.09,
        "Limonene": 0.57,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.09,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-101",
      "strain": "Lemon Drip",
      "type": "Sativa",
      "thc": 24.97,
      "cbd": 0.1,
      "lineage": "Lemon G x Grease Monkey",
      "terpenes": {
        "Caryophyllene": 0.12,
        "Humulene": 0.04,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 1.93,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.42,
        "b-Pinene": 0.18
      },
      "state": "NJ"
    },
    {
      "id": "NJ-123",
      "strain": "Paradise Snacks",
      "type": "Indica",
      "thc": 24.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.08,
        "Limonene": 0.79,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.23,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-140",
      "strain": "Underground Tangie",
      "type": "Hybrid",
      "thc": 24.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.36,
        "Humulene": 0.09,
        "Limonene": 0.1,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 1.04,
        "Terpinolene": 0.02,
        "Bisabolol": 0.08,
        "Pinene": 0.25,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-236",
      "strain": "Pineapple OG",
      "type": "Hybrid",
      "thc": 24.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.06,
        "Limonene": 0.29,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.4,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-136",
      "strain": "Starkiller",
      "type": "Indica",
      "thc": 24.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.78,
        "Humulene": 0.21,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.7,
        "Terpinolene": 0.02,
        "Bisabolol": 0.11,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-119",
      "strain": "Kong",
      "type": "Indica",
      "thc": 24.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.12,
        "Limonene": 0.87,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.19,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-166",
      "strain": "Primary Colors",
      "type": "Sativa",
      "thc": 24.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.12,
        "Limonene": 0.7,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.13,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-165",
      "strain": "Pomme Jelly",
      "type": "Hybrid",
      "thc": 24.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.17,
        "Humulene": 0.29,
        "Limonene": 0.28,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.29,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-237",
      "strain": "Blue Zushi I",
      "type": "Hybrid",
      "thc": 24.55,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.08,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.58,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.15,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-216",
      "strain": "Glitter Bomb",
      "type": "Indica",
      "thc": 24.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.32,
        "Humulene": 0.07,
        "Limonene": 0.12,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 1.14,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.01,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-176",
      "strain": "Super Lemon Haze",
      "type": "Sativa",
      "thc": 24.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.08,
        "Limonene": 0.06,
        "Ocimene": 0,
        "Linalool": 0.04,
        "Myrcene": 0.31,
        "Terpinolene": 0.86,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-158",
      "strain": "Gary Payton x Cereal Milk",
      "type": "Hybrid",
      "thc": 24.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.96,
        "Humulene": 0.22,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 0.24,
        "Terpinolene": 0,
        "Bisabolol": 0.15,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-142",
      "strain": "Billionaire",
      "type": "Sativa",
      "thc": 24.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.44,
        "Humulene": 0.1,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 0.23,
        "Terpinolene": 0.01,
        "Bisabolol": 0.06,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-154",
      "strain": "Blue Agave",
      "type": "Hybrid",
      "thc": 24.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.09,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.65,
        "Myrcene": 0.36,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-224",
      "strain": "Happy Hour #21",
      "type": "Hybrid",
      "thc": 24.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.61,
        "Humulene": 0.12,
        "Limonene": 0.99,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.42,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-147",
      "strain": "G13",
      "type": "Hybrid",
      "thc": 24.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.08,
        "Limonene": 0.65,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.48,
        "Terpinolene": 0.07,
        "Bisabolol": 0.02,
        "Pinene": 0.08,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-213",
      "strain": "Trop Cherry S",
      "type": "Hybrid",
      "thc": 24.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.12,
        "Limonene": 0.33,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-108",
      "strain": "Cereal Milk",
      "type": "Hybrid",
      "thc": 23.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.19,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.12,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-225",
      "strain": "Sour Orange",
      "type": "Hybrid",
      "thc": 23.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.11,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.18,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-211",
      "strain": "Blue Dream",
      "type": "Hybrid",
      "thc": 23.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.32,
        "Humulene": 0.08,
        "Limonene": 0.03,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.64,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.47,
        "b-Pinene": 0.16
      },
      "state": "NJ"
    },
    {
      "id": "NJ-200",
      "strain": "Durban Poison",
      "type": "Sativa",
      "thc": 23.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.11,
        "Humulene": 0.02,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.01,
        "Myrcene": 0.37,
        "Terpinolene": 1.76,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.14
      },
      "state": "NJ"
    },
    {
      "id": "NJ-145",
      "strain": "La Kush Cake",
      "type": "Hybrid",
      "thc": 23.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.65,
        "Humulene": 0.16,
        "Limonene": 0.6,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.17,
        "Terpinolene": 0.01,
        "Bisabolol": 0.1,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-118",
      "strain": "Jet Fuel OG",
      "type": "Hybrid",
      "thc": 23.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.65,
        "Humulene": 0.16,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.8,
        "Terpinolene": 0.06,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-144",
      "strain": "Chocolate Cherry OG",
      "type": "Indica",
      "thc": 23.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.85,
        "Humulene": 0.19,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.23,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-241",
      "strain": "Mac #1",
      "type": "Indica",
      "thc": 23.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.1,
        "Limonene": 0.57,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.16,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.21,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-107",
      "strain": "Black Maple",
      "type": "Indica",
      "thc": 23.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.12,
        "Limonene": 0.91,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.05,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.41,
        "b-Pinene": 0.21
      },
      "state": "NJ"
    },
    {
      "id": "NJ-223",
      "strain": "Citrus Sour",
      "type": "Hybrid",
      "thc": 23.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.82,
        "Humulene": 0.18,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.39,
        "Terpinolene": 0.18,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-194",
      "strain": "GMO Cookies",
      "type": "Indica",
      "thc": 23.42,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies and Chemdog",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.25,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.59,
        "Terpinolene": 0,
        "Bisabolol": 0.14,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-113",
      "strain": "Durban Z (S",
      "type": "Sativa",
      "thc": 23.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.18,
        "Humulene": 0.05,
        "Limonene": 0.29,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.24,
        "Terpinolene": 0.83,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.11
      },
      "state": "NJ"
    },
    {
      "id": "NJ-126",
      "strain": "Tangerine Haze",
      "type": "Sativa",
      "thc": 23.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.1,
        "Limonene": 0.93,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.05,
        "Terpinolene": 0.01,
        "Bisabolol": 0.14,
        "Pinene": 0.1,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-191",
      "strain": "Animal Star Cookies",
      "type": "Hybrid",
      "thc": 23.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.71,
        "Humulene": 0.25,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.72,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-115",
      "strain": "Frozen Margarita",
      "type": "Sativa",
      "thc": 23.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.08,
        "Limonene": 1.27,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.7,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.14,
        "b-Pinene": 0.16
      },
      "state": "NJ"
    },
    {
      "id": "NJ-105",
      "strain": "95 Cookies",
      "type": "Hybrid",
      "thc": 22.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.81,
        "Humulene": 0.19,
        "Limonene": 0.53,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.2,
        "Terpinolene": 0.01,
        "Bisabolol": 0.08,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-221",
      "strain": "Animal Cake",
      "type": "Sativa",
      "thc": 22.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.98,
        "Humulene": 0.25,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-125",
      "strain": "Strawberry Guava",
      "type": "Hybrid",
      "thc": 22.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.3,
        "Humulene": 0.07,
        "Limonene": 1.03,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.77,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-116",
      "strain": "Gazzurple",
      "type": "Sativa",
      "thc": 22.25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.11,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.45,
        "Myrcene": 0.17,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NJ"
    },
    {
      "id": "NJ-240",
      "strain": "Juicy",
      "type": "Hybrid",
      "thc": 22.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.91,
        "Humulene": 0.3,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.41,
        "Myrcene": 0.15,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NJ"
    },
    {
      "id": "NJ-138",
      "strain": "Purple Punch",
      "type": "Indica",
      "thc": 22.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.58,
        "Humulene": 0.15,
        "Limonene": 0.83,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.1,
        "b-Pinene": 0.1
      },
      "state": "NJ"
    },
    {
      "id": "NJ-238",
      "strain": "Dante's Inferno (S",
      "type": "Sativa",
      "thc": 22.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.09,
        "Limonene": 0.23,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.02,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-127",
      "strain": "White Durban",
      "type": "Sativa",
      "thc": 22.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.18,
        "Humulene": 0.05,
        "Limonene": 0.22,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.25,
        "Terpinolene": 1.24,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.12
      },
      "state": "NJ"
    },
    {
      "id": "NJ-110",
      "strain": "Confidential Cherries",
      "type": "Indica",
      "thc": 21.98,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.07,
        "Limonene": 0.31,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.12,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-214",
      "strain": "Blueberry Muffins (I",
      "type": "Indica",
      "thc": 21.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0.27,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.37,
        "Terpinolene": 0.01,
        "Bisabolol": 0.2,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "NJ"
    },
    {
      "id": "NJ-163",
      "strain": "Muffin Bomb",
      "type": "Hybrid",
      "thc": 21.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.08,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.33,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-217",
      "strain": "Grape Bubblegum",
      "type": "Hybrid",
      "thc": 21.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.18,
        "Humulene": 0.06,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.02,
        "Myrcene": 0.36,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.13,
        "b-Pinene": 0.08
      },
      "state": "NJ"
    },
    {
      "id": "NJ-132",
      "strain": "Ghost Milk",
      "type": "Indica",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.13,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.62,
        "Terpinolene": 0.03,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.06
      },
      "state": "NJ"
    },
    {
      "id": "NJ-134",
      "strain": "Glitter Bomb",
      "type": "Indica",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.08,
        "Limonene": 0.18,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.93,
        "Terpinolene": 0.02,
        "Bisabolol": 0.05,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "NJ"
    },
    {
      "id": "NJ-167",
      "strain": "Slingria",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.06,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.45,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.02,
        "b-Pinene": 0.02
      },
      "state": "NJ"
    },
    {
      "id": "NJ-192",
      "strain": "Dawg Lemons (S",
      "type": "Sativa",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.78,
        "Humulene": 0.23,
        "Limonene": 0.69,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 1.17,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    },
    {
      "id": "NJ-203",
      "strain": "All Times Cherry Stomper",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.21,
        "Limonene": 0.53,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.28,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.06,
        "b-Pinene": 0.07
      },
      "state": "NJ"
    }
  ],
  CA: [
    {
    "id": "CA-100",
    "strain": "Glitter Bomb ",
    "type": "Indica",
    "thc": 27.97,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.03,
      "Humulene": 0.71,
      "Limonene": 0.63,
      "Ocimene": 0,
      "Linalool": 1.08,
      "Myrcene": 4.59,
      "Terpinolene": 0,
      "Bisabolol": 0.12,
      "Pinene": 0.13,
      "b-Pinene": 0.2
    },
    "state": "CA"
  },
  {
    "id": "CA-101",
    "strain": "Point Break",
    "type": "Hybrid",
    "thc": 22.94,
    "cbd": 0.1,
    "lineage": "Tropicana Cookies x Trophy Wife",
    "terpenes": {
      "Caryophyllene": 6.44,
      "Humulene": 1.99,
      "Limonene": 2.75,
      "Ocimene": 0,
      "Linalool": 2.73,
      "Myrcene": 0.64,
      "Terpinolene": 0,
      "Bisabolol": 1.21,
      "Pinene": 0.23,
      "b-Pinene": 0.41
    },
    "state": "CA"
  },
  {
    "id": "CA-102",
    "strain": "Graype",
    "type": "Hybrid",
    "thc": 30.55,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.07,
      "Humulene": 0.62,
      "Limonene": 0.36,
      "Ocimene": 2.04,
      "Linalool": 0.34,
      "Myrcene": 22.66,
      "Terpinolene": 0.14,
      "Bisabolol": 0.25,
      "Pinene": 1.88,
      "b-Pinene": 0.65
    },
    "state": "CA"
  },
  {
    "id": "CA-103",
    "strain": "Gluetopia",
    "type": "Hybrid",
    "thc": 26.46,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.16,
      "Humulene": 1.28,
      "Limonene": 13.4,
      "Ocimene": 0.27,
      "Linalool": 2.52,
      "Myrcene": 0.73,
      "Terpinolene": 0.16,
      "Bisabolol": 0.52,
      "Pinene": 2.49,
      "b-Pinene": 2.41
    },
    "state": "CA"
  },
  {
    "id": "CA-104",
    "strain": "Mount Zereal Kush",
    "type": "Hybrid",
    "thc": 27.25,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.15,
      "Humulene": 1.12,
      "Limonene": 5.77,
      "Ocimene": 0,
      "Linalool": 1.76,
      "Myrcene": 1.69,
      "Terpinolene": 0,
      "Bisabolol": 0.21,
      "Pinene": 0.89,
      "b-Pinene": 1.01
    },
    "state": "CA"
  },
  {
    "id": "CA-105",
    "strain": "Super Mango Haze",
    "type": "Hybrid",
    "thc": 24.86,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.99,
      "Humulene": 0.91,
      "Limonene": 5.18,
      "Ocimene": 1.04,
      "Linalool": 2.19,
      "Myrcene": 2.03,
      "Terpinolene": 0.06,
      "Bisabolol": 0.6,
      "Pinene": 1.12,
      "b-Pinene": 1.09
    },
    "state": "CA"
  },
  {
    "id": "CA-106",
    "strain": "Zatomic",
    "type": "Hybrid",
    "thc": 24.3,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 4.36,
      "Humulene": 1.83,
      "Limonene": 3.54,
      "Ocimene": 0,
      "Linalool": 2.38,
      "Myrcene": 4.38,
      "Terpinolene": 0.05,
      "Bisabolol": 0.91,
      "Pinene": 0.29,
      "b-Pinene": 0.51
    },
    "state": "CA"
  },
  {
    "id": "CA-107",
    "strain": "Black Triangle OG",
    "type": "Indica",
    "thc": 26.3,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.47,
      "Humulene": 0.46,
      "Limonene": 3.19,
      "Ocimene": 0,
      "Linalool": 2.26,
      "Myrcene": 6.28,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.37,
      "b-Pinene": 0.7
    },
    "state": "CA"
  },
  {
    "id": "CA-108",
    "strain": "Cobra Kush",
    "type": "Hybrid",
    "thc": 27.1,
    "cbd": 0.1,
    "lineage": ": Kush, GSC.",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.13,
      "Limonene": 0.1,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.1,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.03
    },
    "state": "CA"
  },
  {
    "id": "CA-109",
    "strain": "Gas Plant",
    "type": "Indica",
    "thc": 26.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.5,
      "Humulene": 1.71,
      "Limonene": 6.01,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 8.16,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.53,
      "b-Pinene": 0.97
    },
    "state": "CA"
  },
  {
    "id": "CA-110",
    "strain": "Guava Gaslato",
    "type": "Hybrid",
    "thc": 32.7,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 6.77,
      "Humulene": 1.74,
      "Limonene": 8.1,
      "Ocimene": 0,
      "Linalool": 5.06,
      "Myrcene": 7.08,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.59,
      "b-Pinene": 1.14
    },
    "state": "CA"
  },
  {
    "id": "CA-111",
    "strain": "The Judge ",
    "type": "Indica",
    "thc": 28.4,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 4.1,
      "Humulene": 1.64,
      "Limonene": 5.03,
      "Ocimene": 0,
      "Linalool": 0.65,
      "Myrcene": 5.05,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.5,
      "b-Pinene": 0.87
    },
    "state": "CA"
  },
  {
    "id": "CA-112",
    "strain": "Cadillac Rainbows",
    "type": "Hybrid",
    "thc": 28,
    "cbd": 0.1,
    "lineage": "Runtz x Pure Michigan",
    "terpenes": {
      "Caryophyllene": 3.72,
      "Humulene": 1.86,
      "Limonene": 3.81,
      "Ocimene": 0,
      "Linalool": 0.83,
      "Myrcene": 4.16,
      "Terpinolene": 0,
      "Bisabolol": 0.23,
      "Pinene": 0.35,
      "b-Pinene": 0.54
    },
    "state": "CA"
  },
  {
    "id": "CA-113",
    "strain": "GMO Garlic Cookies ",
    "type": "Indica",
    "thc": 30.3,
    "cbd": 0.1,
    "lineage": "GSC x Chemdog x Breeder",
    "terpenes": {
      "Caryophyllene": 2.72,
      "Humulene": 1.33,
      "Limonene": 3.48,
      "Ocimene": 0,
      "Linalool": 0.46,
      "Myrcene": 3.82,
      "Terpinolene": 0,
      "Bisabolol": 0.41,
      "Pinene": 0.45,
      "b-Pinene": 0.66
    },
    "state": "CA"
  },
  {
    "id": "CA-114",
    "strain": "Jelly Cake",
    "type": "Hybrid",
    "thc": 29.59,
    "cbd": 0.1,
    "lineage": "Biscotti x Sunset Sherbet",
    "terpenes": {
      "Caryophyllene": 4.64,
      "Humulene": 1.45,
      "Limonene": 2.96,
      "Ocimene": 0,
      "Linalool": 1.61,
      "Myrcene": 0.17,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.24,
      "b-Pinene": 0.37
    },
    "state": "CA"
  },
  {
    "id": "CA-115",
    "strain": "Moroccan Peaches",
    "type": "Hybrid",
    "thc": 29.49,
    "cbd": 0.1,
    "lineage": "Spanish Barbara x Lemon Tree x Breeder",
    "terpenes": {
      "Caryophyllene": 2.4,
      "Humulene": 1,
      "Limonene": 1.44,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.34,
      "Terpinolene": 0,
      "Bisabolol": 0.37,
      "Pinene": 0.11,
      "b-Pinene": 0.18
    },
    "state": "CA"
  },
  {
    "id": "CA-116",
    "strain": "Nimbus Snacks ",
    "type": "Sativa",
    "thc": 28.71,
    "cbd": 0.1,
    "lineage": "Durban Mints x Girl Scout Cookies",
    "terpenes": {
      "Caryophyllene": 2.85,
      "Humulene": 0.93,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 2.29,
      "Terpinolene": 6.84,
      "Bisabolol": 0.16,
      "Pinene": 0.5,
      "b-Pinene": 0.64
    },
    "state": "CA"
  },
  {
    "id": "CA-117",
    "strain": "Papaya Bomb ",
    "type": "Indica",
    "thc": 28.43,
    "cbd": 0.1,
    "lineage": "Papaya x THC Bomb x Breeder",
    "terpenes": {
      "Caryophyllene": 3.49,
      "Humulene": 1.48,
      "Limonene": 5.49,
      "Ocimene": 0,
      "Linalool": 0.75,
      "Myrcene": 3.88,
      "Terpinolene": 0,
      "Bisabolol": 0.51,
      "Pinene": 0.51,
      "b-Pinene": 0.85
    },
    "state": "CA"
  },
  {
    "id": "CA-118",
    "strain": "White Mango",
    "type": "Indica",
    "thc": 30.63,
    "cbd": 0.1,
    "lineage": "Berry White x Mango x Breeder",
    "terpenes": {
      "Caryophyllene": 2.08,
      "Humulene": 0.59,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 7.41,
      "Terpinolene": 0,
      "Bisabolol": 0.36,
      "Pinene": 0.1,
      "b-Pinene": 0.14
    },
    "state": "CA"
  },
  {
    "id": "CA-119",
    "strain": "Toad Venom",
    "type": "Hybrid",
    "thc": 35.1,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 17.6,
      "Humulene": 4.19,
      "Limonene": 6.9,
      "Ocimene": 0,
      "Linalool": 3.13,
      "Myrcene": 3.14,
      "Terpinolene": 0,
      "Bisabolol": 0.34,
      "Pinene": 0.53,
      "b-Pinene": 1.02
    },
    "state": "CA"
  },
  {
    "id": "CA-120",
    "strain": "Banana OG",
    "type": "Hybrid",
    "thc": 0,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.48,
      "Humulene": 0.45,
      "Limonene": 4.04,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 1.7,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 1.26,
      "b-Pinene": 1.29
    },
    "state": "CA"
  },
  {
    "id": "CA-121",
    "strain": "SFV OG",
    "type": "Hybrid",
    "thc": 25.39,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.19,
      "Humulene": 0.38,
      "Limonene": 2.43,
      "Ocimene": 0,
      "Linalool": 1.13,
      "Myrcene": 2.97,
      "Terpinolene": 0,
      "Bisabolol": 0.11,
      "Pinene": 0.35,
      "b-Pinene": 0.63
    },
    "state": "CA"
  },
  {
    "id": "CA-122",
    "strain": "Black Lotus",
    "type": "Indica",
    "thc": 28.34,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.39,
      "Limonene": 5.72,
      "Ocimene": 0,
      "Linalool": 1.34,
      "Myrcene": 2.07,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.47,
      "b-Pinene": 0.77
    },
    "state": "CA"
  },
  {
    "id": "CA-123",
    "strain": "Chem 51",
    "type": "Hybrid",
    "thc": 28.71,
    "cbd": 0.1,
    "lineage": "Compound Genetics x Pheno-Hunted",
    "terpenes": {
      "Caryophyllene": 2.05,
      "Humulene": 0.63,
      "Limonene": 11.8,
      "Ocimene": 0,
      "Linalool": 1.06,
      "Myrcene": 6.02,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 1.57,
      "b-Pinene": 1.78
    },
    "state": "CA"
  },
  {
    "id": "CA-124",
    "strain": "Chroma",
    "type": "Indica",
    "thc": 29.17,
    "cbd": 0.1,
    "lineage": "Prizm x Black Diamond",
    "terpenes": {
      "Caryophyllene": 4.73,
      "Humulene": 1.22,
      "Limonene": 8.12,
      "Ocimene": 0,
      "Linalool": 2.37,
      "Myrcene": 2.11,
      "Terpinolene": 0,
      "Bisabolol": 0.31,
      "Pinene": 1.48,
      "b-Pinene": 1.55
    },
    "state": "CA"
  },
  {
    "id": "CA-125",
    "strain": "French Lotus",
    "type": "Hybrid",
    "thc": 27.64,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.83,
      "Humulene": 1.11,
      "Limonene": 5.13,
      "Ocimene": 0,
      "Linalool": 1.73,
      "Myrcene": 0.31,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.64,
      "b-Pinene": 0.81
    },
    "state": "CA"
  },
  {
    "id": "CA-126",
    "strain": "Lemon Cherry Tropicana",
    "type": "Sativa",
    "thc": 28.32,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.25,
      "Humulene": 0.61,
      "Limonene": 3.87,
      "Ocimene": 0,
      "Linalool": 1.7,
      "Myrcene": 0.19,
      "Terpinolene": 0,
      "Bisabolol": 0.17,
      "Pinene": 0.34,
      "b-Pinene": 0.53
    },
    "state": "CA"
  },
  {
    "id": "CA-127",
    "strain": "Lipstain",
    "type": "Indica",
    "thc": 28.23,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.56,
      "Limonene": 6.98,
      "Ocimene": 0,
      "Linalool": 4.25,
      "Myrcene": 6.73,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.44,
      "b-Pinene": 0.83
    },
    "state": "CA"
  },
  {
    "id": "CA-128",
    "strain": "Orange Sapphire",
    "type": "Sativa",
    "thc": 28.49,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.35,
      "Humulene": 0.67,
      "Limonene": 3.15,
      "Ocimene": 0,
      "Linalool": 0.74,
      "Myrcene": 0.64,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.53,
      "b-Pinene": 0.57
    },
    "state": "CA"
  },
  {
    "id": "CA-129",
    "strain": "Shangri-La",
    "type": "Hybrid",
    "thc": 28,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.136,
      "Humulene": 0.040999999999999995,
      "Limonene": 0.6559999999999999,
      "Ocimene": 0,
      "Linalool": 0.23700000000000002,
      "Myrcene": 0.047,
      "Terpinolene": 0,
      "Bisabolol": 0.012,
      "Pinene": 0.121,
      "b-Pinene": 0.118
    },
    "state": "CA"
  },
  {
    "id": "CA-130",
    "strain": "Gelato X",
    "type": "Indica",
    "thc": 28.8,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.13,
      "Humulene": 0.64,
      "Limonene": 3.09,
      "Ocimene": 0,
      "Linalool": 3.81,
      "Myrcene": 5.69,
      "Terpinolene": 0.04,
      "Bisabolol": 0.04,
      "Pinene": 0.25,
      "b-Pinene": 0.53
    },
    "state": "CA"
  },
  {
    "id": "CA-131",
    "strain": "Mellowz",
    "type": "Sativa",
    "thc": 25.3,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 7.25,
      "Humulene": 2.06,
      "Limonene": 2.92,
      "Ocimene": 0,
      "Linalool": 1.85,
      "Myrcene": 0.18,
      "Terpinolene": 0.04,
      "Bisabolol": 0.43,
      "Pinene": 0.26,
      "b-Pinene": 0.48
    },
    "state": "CA"
  },
  {
    "id": "CA-132",
    "strain": "Grapes and Cream",
    "type": "Indica",
    "thc": 25.2,
    "cbd": 0.1,
    "lineage": "Grape Pie x Cookies and Cream",
    "terpenes": {
      "Caryophyllene": 4.8,
      "Humulene": 2.04,
      "Limonene": 3.89,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.22,
      "Terpinolene": 0.04,
      "Bisabolol": 0.62,
      "Pinene": 0.3,
      "b-Pinene": 0.56
    },
    "state": "CA"
  },
  {
    "id": "CA-133",
    "strain": "Hawaiian Fanta ",
    "type": "Sativa",
    "thc": 20.61,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 4.87,
      "Humulene": 1.54,
      "Limonene": 4.82,
      "Ocimene": 2.46,
      "Linalool": 0.67,
      "Myrcene": 10.19,
      "Terpinolene": 0.07,
      "Bisabolol": 0.06,
      "Pinene": 0.43,
      "b-Pinene": 0.67
    },
    "state": "CA"
  },
  {
    "id": "CA-134",
    "strain": "Hella Jelly",
    "type": "Hybrid",
    "thc": 27.09,
    "cbd": 0.1,
    "lineage": "Hella Jelly BX3 x Notorious T",
    "terpenes": {
      "Caryophyllene": 8.48,
      "Humulene": 2.94,
      "Limonene": 1.04,
      "Ocimene": 0,
      "Linalool": 0.68,
      "Myrcene": 6.65,
      "Terpinolene": 0,
      "Bisabolol": 2.06,
      "Pinene": 0.08,
      "b-Pinene": 0.17
    },
    "state": "CA"
  },
  {
    "id": "CA-135",
    "strain": "Dream Thorn",
    "type": "Hybrid",
    "thc": 19.38,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0,
      "Limonene": 1.49,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 4.48,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 2.55,
      "b-Pinene": 0
    },
    "state": "CA"
  },
  {
    "id": "CA-136",
    "strain": "Mega Diesel",
    "type": "Hybrid",
    "thc": 28.3,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 7.43,
      "Humulene": 3.28,
      "Limonene": 3.38,
      "Ocimene": 0,
      "Linalool": 3.49,
      "Myrcene": 1.59,
      "Terpinolene": 0.18,
      "Bisabolol": 0.84,
      "Pinene": 0.33,
      "b-Pinene": 0.61
    },
    "state": "CA"
  },
  {
    "id": "CA-137",
    "strain": "Mega Wellness",
    "type": "Indica",
    "thc": 25.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.91,
      "Humulene": 1.35,
      "Limonene": 4.13,
      "Ocimene": 0,
      "Linalool": 1.6,
      "Myrcene": 5.31,
      "Terpinolene": 0.07,
      "Bisabolol": 0.34,
      "Pinene": 0.57,
      "b-Pinene": 1.28
    },
    "state": "CA"
  },
  {
    "id": "CA-138",
    "strain": "Sour Runtz",
    "type": "Hybrid",
    "thc": 29.37,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 6.13,
      "Humulene": 2.66,
      "Limonene": 2.83,
      "Ocimene": 0,
      "Linalool": 2.78,
      "Myrcene": 1.66,
      "Terpinolene": 0.18,
      "Bisabolol": 0.79,
      "Pinene": 0.3,
      "b-Pinene": 0.56
    },
    "state": "CA"
  },
  {
    "id": "CA-139",
    "strain": "Super Lemon Haze",
    "type": "Sativa",
    "thc": 24.03,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.36,
      "Humulene": 1.07,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.94,
      "Terpinolene": 3.64,
      "Bisabolol": 0,
      "Pinene": 0.33,
      "b-Pinene": 0.57
    },
    "state": "CA"
  },
  {
    "id": "CA-140",
    "strain": "Oakstradam OG",
    "type": "Indica",
    "thc": 27.96,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 5.49,
      "Humulene": 2.92,
      "Limonene": 4.4,
      "Ocimene": 0,
      "Linalool": 1.16,
      "Myrcene": 10.96,
      "Terpinolene": 0.09,
      "Bisabolol": 0.74,
      "Pinene": 0.5,
      "b-Pinene": 1.25
    },
    "state": "CA"
  },
  {
    "id": "CA-141",
    "strain": "Lemon Up",
    "type": "Sativa",
    "thc": 24.77,
    "cbd": 0.1,
    "lineage": "Super Lemon Haze x Lime Time",
    "terpenes": {
      "Caryophyllene": 5.03,
      "Humulene": 1.54,
      "Limonene": 5.66,
      "Ocimene": 2.27,
      "Linalool": 2.05,
      "Myrcene": 2.98,
      "Terpinolene": 14.77,
      "Bisabolol": 0.89,
      "Pinene": 0.93,
      "b-Pinene": 1.74
    },
    "state": "CA"
  },
  {
    "id": "CA-142",
    "strain": "Rainbow Runtz ",
    "type": "Hybrid",
    "thc": 32.39,
    "cbd": 0.1,
    "lineage": "RS11 x Pink Runtz",
    "terpenes": {
      "Caryophyllene": 2.35,
      "Humulene": 0.79,
      "Limonene": 9.04,
      "Ocimene": 0.48,
      "Linalool": 5.84,
      "Myrcene": 2.36,
      "Terpinolene": 0.1,
      "Bisabolol": 0.07,
      "Pinene": 1.09,
      "b-Pinene": 1.79
    },
    "state": "CA"
  },
  {
    "id": "CA-143",
    "strain": "Sideshow",
    "type": "Indica",
    "thc": 29.68,
    "cbd": 0.1,
    "lineage": "Chem 91 x Face Off OG",
    "terpenes": {
      "Caryophyllene": 3.69,
      "Humulene": 1.18,
      "Limonene": 6.99,
      "Ocimene": 1.17,
      "Linalool": 2.57,
      "Myrcene": 1.84,
      "Terpinolene": 0.13,
      "Bisabolol": 0.07,
      "Pinene": 0.67,
      "b-Pinene": 1.13
    },
    "state": "CA"
  },
  {
    "id": "CA-144",
    "strain": "Zerbert",
    "type": "Hybrid",
    "thc": 21.3,
    "cbd": 0.1,
    "lineage": "Blue Sherb x Z",
    "terpenes": {
      "Caryophyllene": 5.41,
      "Humulene": 2.16,
      "Limonene": 2.08,
      "Ocimene": 0,
      "Linalool": 1.83,
      "Myrcene": 3.04,
      "Terpinolene": 0,
      "Bisabolol": 0.53,
      "Pinene": 0.21,
      "b-Pinene": 0.43
    },
    "state": "CA"
  },
  {
    "id": "CA-145",
    "strain": "Cherry Cheesecake - I",
    "type": "Indica",
    "thc": 28.6,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.89,
      "Humulene": 1.19,
      "Limonene": 3.27,
      "Ocimene": 0,
      "Linalool": 0.38,
      "Myrcene": 2.88,
      "Terpinolene": 0.11,
      "Bisabolol": 1.08,
      "Pinene": 0.7,
      "b-Pinene": 0.65
    },
    "state": "CA"
  },
  {
    "id": "CA-146",
    "strain": "Glitter Bomb",
    "type": "Hybrid",
    "thc": 30.5,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 6.5,
      "Humulene": 1.93,
      "Limonene": 0.63,
      "Ocimene": 0.57,
      "Linalool": 1.05,
      "Myrcene": 6.94,
      "Terpinolene": 0.05,
      "Bisabolol": 0.86,
      "Pinene": 0.07,
      "b-Pinene": 0.14
    },
    "state": "CA"
  },
  {
    "id": "CA-147",
    "strain": "Mandarin Lime Dogz",
    "type": "Hybrid",
    "thc": 26.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 5.06,
      "Humulene": 1.89,
      "Limonene": 2.19,
      "Ocimene": 0.48,
      "Linalool": 0.59,
      "Myrcene": 6.23,
      "Terpinolene": 0.07,
      "Bisabolol": 0.85,
      "Pinene": 1.73,
      "b-Pinene": 0.61
    },
    "state": "CA"
  },
  {
    "id": "CA-148",
    "strain": "Crescendo ",
    "type": "Sativa",
    "thc": 26.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.85,
      "Humulene": 1.21,
      "Limonene": 4.99,
      "Ocimene": 0,
      "Linalool": 0.74,
      "Myrcene": 12.51,
      "Terpinolene": 0,
      "Bisabolol": 0.29,
      "Pinene": 0.41,
      "b-Pinene": 0.8
    },
    "state": "CA"
  },
  {
    "id": "CA-149",
    "strain": "Crescendo",
    "type": "Sativa",
    "thc": 26.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.85,
      "Humulene": 1.21,
      "Limonene": 4.99,
      "Ocimene": 0,
      "Linalool": 0.74,
      "Myrcene": 12.51,
      "Terpinolene": 0,
      "Bisabolol": 0.29,
      "Pinene": 0.41,
      "b-Pinene": 0.8
    },
    "state": "CA"
  },
  {
    "id": "CA-150",
    "strain": "Tangie Frosting",
    "type": "Sativa",
    "thc": 30.2,
    "cbd": 0.1,
    "lineage": "Tangie x Vanilla Frosting",
    "terpenes": {
      "Caryophyllene": 2.1,
      "Humulene": 0.65,
      "Limonene": 0.56,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 5.93,
      "Terpinolene": 0,
      "Bisabolol": 0.3,
      "Pinene": 2.38,
      "b-Pinene": 0.98
    },
    "state": "CA"
  },
  {
    "id": "CA-151",
    "strain": "Acapulco Gold",
    "type": "Hybrid",
    "thc": 23.23,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.73,
      "Humulene": 1.13,
      "Limonene": 1.54,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 9.22,
      "Terpinolene": 0.04,
      "Bisabolol": 0.35,
      "Pinene": 4.52,
      "b-Pinene": 1.66
    },
    "state": "CA"
  },
  {
    "id": "CA-152",
    "strain": "Pink Acai",
    "type": "Hybrid",
    "thc": 29.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 2.01,
      "Humulene": 0.59,
      "Limonene": 0.86,
      "Ocimene": 0,
      "Linalool": 0.48,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.13
    },
    "state": "CA"
  },
  {
    "id": "CA-153",
    "strain": "Tropicana Cherry",
    "type": "Hybrid",
    "thc": 24.63,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 3.5,
      "Humulene": 1.34,
      "Limonene": 1.16,
      "Ocimene": 0,
      "Linalool": 1.01,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 1.18,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CA"
  },
  {
    "id": "CA-154",
    "strain": "White Zaza",
    "type": "Hybrid",
    "thc": 28,
    "cbd": 0.1,
    "lineage": "White Runtz x Zaza",
    "terpenes": {
      "Caryophyllene": 3.63,
      "Humulene": 0,
      "Limonene": 4.79,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CA"
  }
  ],
  PA: [
    {
      "id": "PA-100",
      "strain": "Afternoon Delight #4",
      "type": "Hybrid",
      "thc": 37.9,
      "cbd": 0.1,
      "lineage": "GMO x Trophy Wife",
      "terpenes": {
        "Caryophyllene": 0.592,
        "Limonene": 0.596,
        "Myrcene": 0.402,
        "Linalool": 0.274
      },
      "state": "PA"
    },
    {
      "id": "PA-102",
      "strain": "Animal Scout",
      "type": "Indica",
      "thc": 37.88,
      "cbd": 0.1,
      "lineage": "Animal Face x Brownie Scout",
      "terpenes": {
        "Myrcene": 0.65,
        "Caryophyllene": 0.645,
        "Limonene": 0.591
      },
      "state": "PA"
    },
    {
      "id": "PA-103",
      "strain": "Bananaconda",
      "type": "Hybrid",
      "thc": 37.59,
      "cbd": 0.1,
      "lineage": "Snake Cake x Dual OG",
      "terpenes": {
        "Limonene": 0.872,
        "Linalool": 0.286,
        "Caryophyllene": 0.193
      },
      "state": "PA"
    },
    {
      "id": "PA-124",
      "strain": "Wifi OG",
      "type": "Indica",
      "thc": 36.45,
      "cbd": 0.1,
      "lineage": "Williams Wonder x Roadkill Skunk",
      "terpenes": {
        "Limonene": 0.826,
        "Myrcene": 0.787
      },
      "state": "PA"
    },
    {
      "id": "PA-139",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 35.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.371,
        "Humulene": 0.124,
        "Limonene": 0.66,
        "Ocimene": 0.008,
        "Linalool": 0.347,
        "Myrcene": 0.337,
        "Terpinolene": 0.014,
        "Bisabolol": 0.036,
        "Pinene": 0.055,
        "b-Pinene": 0.108
      },
      "state": "PA"
    },
    {
      "id": "PA-117",
      "strain": "MYSTC MNT",
      "type": "Indica",
      "thc": 34.84,
      "cbd": 0.1,
      "lineage": "Kush Mints x Cookies & Cream",
      "terpenes": {
        "Limonene": 0.987,
        "Myrcene": 0.332
      },
      "state": "PA"
    },
    {
      "id": "PA-105",
      "strain": "BRWN E SCT",
      "type": "Indica",
      "thc": 34.75,
      "cbd": 0.1,
      "lineage": "Brownie Scout",
      "terpenes": {
        "Limonene": 0.727,
        "Caryophyllene": 0.409,
        "Myrcene": 0.32
      },
      "state": "PA"
    },
    {
      "id": "PA-118",
      "strain": "Private Reserve OG",
      "type": "Indica",
      "thc": 34.69,
      "cbd": 0.1,
      "lineage": "OG #18",
      "terpenes": {
        "Myrcene": 0.858,
        "Caryophyllene": 0.547
      },
      "state": "PA"
    },
    {
      "id": "PA-108",
      "strain": "Cranberry Z",
      "type": "Indica",
      "thc": 34.35,
      "cbd": 0.1,
      "lineage": "Cranberry x Zkittlez",
      "terpenes": {
        "Limonene": 0.827,
        "Pinene": 0.183,
        "Linalool": 0.204
      },
      "state": "PA"
    },
    {
      "id": "PA-101",
      "strain": "Animal Face",
      "type": "Indica",
      "thc": 33.89,
      "cbd": 0.1,
      "lineage": "Face Off OG x Animal Mints",
      "terpenes": {
        "Caryophyllene": 0.708,
        "Myrcene": 0.473,
        "Limonene": 0.45
      },
      "state": "PA"
    },
    {
      "id": "PA-104",
      "strain": "BNANA CRM",
      "type": "Indica",
      "thc": 32.84,
      "cbd": 0.1,
      "lineage": "Banana OG x Cookies & Cream",
      "terpenes": {
        "Caryophyllene": 0.486,
        "Myrcene": 0.389,
        "Linalool": 0.337
      },
      "state": "PA"
    },
    {
      "id": "PA-140",
      "strain": "Layer CKE",
      "type": "Hybrid",
      "thc": 32.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.533,
        "Humulene": 0.189,
        "Limonene": 0.836,
        "Ocimene": 0.01,
        "Linalool": 0.207,
        "Myrcene": 0.411,
        "Terpinolene": 0.009,
        "Bisabolol": 0.037,
        "Pinene": 0.07,
        "b-Pinene": 0.131
      },
      "state": "PA"
    },
    {
      "id": "PA-109",
      "strain": "Fantasy MLNZ",
      "type": "Hybrid",
      "thc": 32.26,
      "cbd": 0.1,
      "lineage": "Watermelon Z x Strawberries & Cream",
      "terpenes": {
        "Limonene": 0.467,
        "Myrcene": 0.261,
        "Caryophyllene": 0.257
      },
      "state": "PA"
    },
    {
      "id": "PA-119",
      "strain": "Rose Gold RNTZ",
      "type": "Hybrid",
      "thc": 32.1,
      "cbd": 0.1,
      "lineage": "Apples & Bananas x White Runtz",
      "terpenes": {
        "Caryophyllene": 0.535,
        "Limonene": 0.34
      },
      "state": "PA"
    },
    {
      "id": "PA-130",
      "strain": "Chem Glue",
      "type": "Indica",
      "thc": 31.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.554,
        "Humulene": 0.165,
        "Limonene": 0.809,
        "Ocimene": 0.009,
        "Linalool": 0,
        "Myrcene": 0.33,
        "Terpinolene": 0.01,
        "Bisabolol": 0.072,
        "Pinene": 0.063,
        "b-Pinene": 0.12
      },
      "state": "PA"
    },
    {
      "id": "PA-107",
      "strain": "Chem X",
      "type": "Indica",
      "thc": 31.54,
      "cbd": 0.1,
      "lineage": "Chem 4 x GG4",
      "terpenes": {
        "Caryophyllene": 0.662,
        "Myrcene": 0.492,
        "Limonene": 0.453
      },
      "state": "PA"
    },
    {
      "id": "PA-114",
      "strain": "LA Kush Cake",
      "type": "Indica",
      "thc": 30.62,
      "cbd": 0.1,
      "lineage": "Kush Mints x Wedding Cake",
      "terpenes": {
        "Caryophyllene": 0.445,
        "Limonene": 0.154
      },
      "state": "PA"
    },
    {
      "id": "PA-112",
      "strain": "Jack's Delight",
      "type": "Sativa",
      "thc": 30.58,
      "cbd": 0.1,
      "lineage": "Jack Herer x AD4 x Point Break",
      "terpenes": {
        "Terpinolene": 0.824,
        "Caryophyllene": 0.612
      },
      "state": "PA"
    },
    {
      "id": "PA-136",
      "strain": "Giggle Gas",
      "type": "Hybrid",
      "thc": 30.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.333,
        "Humulene": 0.083,
        "Limonene": 0.612,
        "Ocimene": 0.007,
        "Linalool": 0.148,
        "Myrcene": 0.489,
        "Terpinolene": 0.008,
        "Bisabolol": 0.043,
        "Pinene": 0.061,
        "b-Pinene": 0.117
      },
      "state": "PA"
    },
    {
      "id": "PA-134",
      "strain": "Durban Z",
      "type": "Sativa",
      "thc": 29.9,
      "cbd": 0.1,
      "lineage": "Z x Durban Poison",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0.207,
        "Ocimene": 0.015,
        "Linalool": 0.049,
        "Myrcene": 0.264,
        "Terpinolene": 0.97,
        "Bisabolol": 0,
        "Pinene": 0.076,
        "b-Pinene": 0.122
      },
      "state": "PA"
    },
    {
      "id": "PA-132",
      "strain": "CRMSCL SUNSET",
      "type": "Hybrid",
      "thc": 29.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.409,
        "Humulene": 0.14,
        "Limonene": 0.67,
        "Ocimene": 0.007,
        "Linalool": 0.15,
        "Myrcene": 0.299,
        "Terpinolene": 0.013,
        "Bisabolol": 0.035,
        "Pinene": 0.059,
        "b-Pinene": 0.115
      },
      "state": "PA"
    },
    {
      "id": "PA-121",
      "strain": "Sherbanger",
      "type": "Hybrid",
      "thc": 29.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.522,
        "Limonene": 0.592
      },
      "state": "PA"
    },
    {
      "id": "PA-110",
      "strain": "Fumez",
      "type": "Hybrid",
      "thc": 29.22,
      "cbd": 0.1,
      "lineage": "Runtz x Sour Dubb x Durban",
      "terpenes": {
        "Caryophyllene": 0.599,
        "Limonene": 0.54,
        "Myrcene": 0.386
      },
      "state": "PA"
    },
    {
      "id": "PA-123",
      "strain": "Sour Cherry Melon",
      "type": "Indica",
      "thc": 29.06,
      "cbd": 0.1,
      "lineage": "Zack's Pie x Jungle Cake",
      "terpenes": {
        "Caryophyllene": 0.515,
        "Limonene": 0.456
      },
      "state": "PA"
    },
    {
      "id": "PA-131",
      "strain": "CHCKN N WFFLZ",
      "type": "Sativa",
      "thc": 29.03,
      "cbd": 0.1,
      "lineage": "Jelly Donutz x Purple Cartel",
      "terpenes": {
        "Caryophyllene": 0.285,
        "Humulene": 0.103,
        "Limonene": 0.338,
        "Ocimene": 0,
        "Linalool": 0.247,
        "Myrcene": 0.114,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.038,
        "b-Pinene": 0.071
      },
      "state": "PA"
    },
    {
      "id": "PA-133",
      "strain": "Dulce De Uva",
      "type": "Indica",
      "thc": 28.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.093,
        "Limonene": 0.474,
        "Ocimene": 0.005,
        "Linalool": 0.126,
        "Myrcene": 0.322,
        "Terpinolene": 0.005,
        "Bisabolol": 0.139,
        "Pinene": 0.038,
        "b-Pinene": 0.069
      },
      "state": "PA"
    },
    {
      "id": "PA-115",
      "strain": "Lemon Gelato CKIES",
      "type": "Sativa",
      "thc": 28.54,
      "cbd": 0.1,
      "lineage": "Lemon Cookies x Gelato",
      "terpenes": {
        "Caryophyllene": 0.492,
        "Limonene": 0.299
      },
      "state": "PA"
    },
    {
      "id": "PA-111",
      "strain": "GRNCH MNTS",
      "type": "Hybrid",
      "thc": 28.47,
      "cbd": 0.1,
      "lineage": "Jealousy x SinMint Cookies",
      "terpenes": {
        "Caryophyllene": 0.546,
        "Limonene": 0.329,
        "Myrcene": 0.111
      },
      "state": "PA"
    },
    {
      "id": "PA-138",
      "strain": "GRLC DRIP",
      "type": "Indica",
      "thc": 27.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.285,
        "Humulene": 0.116,
        "Limonene": 0.481,
        "Ocimene": 0,
        "Linalool": 0.383,
        "Myrcene": 0.125,
        "Terpinolene": 0,
        "Bisabolol": 0.049,
        "Pinene": 0,
        "b-Pinene": 0.064
      },
      "state": "PA"
    },
    {
      "id": "PA-125",
      "strain": "95 CKIES",
      "type": "Hybrid",
      "thc": 27.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.511,
        "Myrcene": 0.331
      },
      "state": "PA"
    },
    {
      "id": "PA-116",
      "strain": "Living Legend",
      "type": "Sativa",
      "thc": 27.2,
      "cbd": 0.1,
      "lineage": "24K x OG Fruit Smoothie",
      "terpenes": {
        "Terpinolene": 0.983,
        "Limonene": 0.324
      },
      "state": "PA"
    },
    {
      "id": "PA-128",
      "strain": "Black Maple",
      "type": "Indica",
      "thc": 26.95,
      "cbd": 0.1,
      "lineage": "Dulce de Uva x Sherbanger 22",
      "terpenes": {
        "Caryophyllene": 0.721,
        "Humulene": 0.209,
        "Limonene": 0.633,
        "Ocimene": 0.007,
        "Linalool": 0.182,
        "Myrcene": 0.039,
        "Terpinolene": 0.007,
        "Bisabolol": 0.218,
        "Pinene": 0.159,
        "b-Pinene": 0.126
      },
      "state": "PA"
    },
    {
      "id": "PA-113",
      "strain": "Jet Fuel OG",
      "type": "Hybrid",
      "thc": 26.77,
      "cbd": 0.1,
      "lineage": "Aspen OG x High Country Diesel",
      "terpenes": {
        "Caryophyllene": 0.305,
        "Myrcene": 0.26,
        "Limonene": 0.238
      },
      "state": "PA"
    },
    {
      "id": "PA-135",
      "strain": "Gelato AK",
      "type": "Hybrid",
      "thc": 26.66,
      "cbd": 0.1,
      "lineage": "Cherry AK x Gelato #1",
      "terpenes": {
        "Caryophyllene": 0.692,
        "Humulene": 0.205,
        "Limonene": 0.459,
        "Ocimene": 0,
        "Linalool": 0.045,
        "Myrcene": 0.416,
        "Terpinolene": 0.007,
        "Bisabolol": 0.025,
        "Pinene": 0.051,
        "b-Pinene": 0.083
      },
      "state": "PA"
    },
    {
      "id": "PA-106",
      "strain": "Chem CKIES",
      "type": "Hybrid",
      "thc": 26.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Myrcene": 1.181,
        "Caryophyllene": 0.476,
        "Linalool": 0.273
      },
      "state": "PA"
    },
    {
      "id": "PA-120",
      "strain": "Secret Sunset",
      "type": "Sativa",
      "thc": 26.11,
      "cbd": 0.1,
      "lineage": "Golden Pineapple x Secret OG",
      "terpenes": {
        "Myrcene": 0.979,
        "Caryophyllene": 0.415
      },
      "state": "PA"
    },
    {
      "id": "PA-122",
      "strain": "Slapz",
      "type": "Hybrid",
      "thc": 25.67,
      "cbd": 0.1,
      "lineage": "Runtz x Grease Monkey",
      "terpenes": {
        "Caryophyllene": 0.364,
        "Limonene": 0.313
      },
      "state": "PA"
    },
    {
      "id": "PA-127",
      "strain": "Black Afghan",
      "type": "Indica",
      "thc": 25.17,
      "cbd": 0.1,
      "lineage": "Afghan Kush x Black Domina",
      "terpenes": {
        "Caryophyllene": 0.174,
        "Humulene": 0.065,
        "Limonene": 0.038,
        "Ocimene": 0.006,
        "Linalool": 0.047,
        "Myrcene": 0.737,
        "Terpinolene": 0,
        "Bisabolol": 0.026,
        "Pinene": 0.165,
        "b-Pinene": 0.052
      },
      "state": "PA"
    },
    {
      "id": "PA-126",
      "strain": "APPL CBL",
      "type": "Hybrid",
      "thc": 24.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.347,
        "Humulene": 0.106,
        "Limonene": 1.123,
        "Ocimene": 0.013,
        "Linalool": 0.427,
        "Myrcene": 0.128,
        "Terpinolene": 0.014,
        "Bisabolol": 0.053,
        "Pinene": 0.391,
        "b-Pinene": 0.286
      },
      "state": "PA"
    },
    {
      "id": "PA-129",
      "strain": "Cactus OG",
      "type": "Hybrid",
      "thc": 22.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.181,
        "Humulene": 0.059,
        "Limonene": 0.106,
        "Ocimene": 0,
        "Linalool": 0.098,
        "Myrcene": 0.351,
        "Terpinolene": 0,
        "Bisabolol": 0.242,
        "Pinene": 0.018,
        "b-Pinene": 0.041
      },
      "state": "PA"
    },
    {
      "id": "PA-137",
      "strain": "GMO Thin Mintz",
      "type": "Indica",
      "thc": 20.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.444,
        "Humulene": 0.135,
        "Limonene": 0.886,
        "Ocimene": 0.014,
        "Linalool": 0.197,
        "Myrcene": 0.072,
        "Terpinolene": 0.009,
        "Bisabolol": 0.016,
        "Pinene": 0.13,
        "b-Pinene": 0.138
      },
      "state": "PA"
    }
  ],
  NV: [
    {
      "id": "NV-194",
      "strain": "Jenny Kush",
      "type": "Hybrid",
      "thc": 34.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.54,
        "Humulene": 1.23,
        "Limonene": 6.29,
        "Ocimene": 0,
        "Linalool": 0.73,
        "Myrcene": 9.29,
        "Terpinolene": 0.14,
        "Bisabolol": 0.06,
        "Pinene": 0.43,
        "b-Pinene": 0.79
      },
      "state": "NV"
    },
    {
      "id": "NV-211",
      "strain": "Sunset Mac",
      "type": "Hybrid",
      "thc": 34.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.52,
        "Humulene": 0,
        "Limonene": 3.84,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 6.78,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-219",
      "strain": "Garlic Cookies",
      "type": "Hybrid",
      "thc": 33.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.3,
        "Limonene": 0.76,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.9,
        "Terpinolene": 0.05,
        "Bisabolol": 0.13,
        "Pinene": 0.07,
        "b-Pinene": 0.13
      },
      "state": "NV"
    },
    {
      "id": "NV-301",
      "strain": "Super Runtz",
      "type": "Hybrid",
      "thc": 33.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.78,
        "Humulene": 0.79,
        "Limonene": 8.35,
        "Ocimene": 0,
        "Linalool": 4.11,
        "Myrcene": 7,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.44,
        "b-Pinene": 0.97
      },
      "state": "NV"
    },
    {
      "id": "NV-208",
      "strain": "Fried Banana ",
      "type": "Hybrid",
      "thc": 31.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.14,
        "Humulene": 2.93,
        "Limonene": 2.92,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 4.09,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-296",
      "strain": "Jealousy",
      "type": "Hybrid",
      "thc": 31.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.71,
        "Humulene": 1.81,
        "Limonene": 4.08,
        "Ocimene": 0,
        "Linalool": 4.54,
        "Myrcene": 2.44,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.49,
        "b-Pinene": 0.69
      },
      "state": "NV"
    },
    {
      "id": "NV-183",
      "strain": "First Press",
      "type": "Hybrid",
      "thc": 31.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.9,
        "Humulene": 1.27,
        "Limonene": 5.67,
        "Ocimene": 0,
        "Linalool": 3.43,
        "Myrcene": 2.06,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-180",
      "strain": "High Sierra Kush",
      "type": "Hybrid",
      "thc": 31.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.25,
        "Humulene": 1.08,
        "Limonene": 5.4,
        "Ocimene": 0,
        "Linalool": 2.09,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.68,
        "b-Pinene": 1.09
      },
      "state": "NV"
    },
    {
      "id": "NV-142",
      "strain": "Cap Junkie",
      "type": "Hybrid",
      "thc": 30.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.68,
        "Humulene": 1.14,
        "Limonene": 4.44,
        "Ocimene": 0,
        "Linalool": 3.78,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-240",
      "strain": "Las Vegas Kush Cake",
      "type": "Hybrid",
      "thc": 30.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.72,
        "Humulene": 0.08,
        "Limonene": 4.84,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 3.43,
        "Terpinolene": 0.02,
        "Bisabolol": 0.04,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "NV"
    },
    {
      "id": "NV-143",
      "strain": "Clout Berries",
      "type": "Hybrid",
      "thc": 30.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.36,
        "Humulene": 1.06,
        "Limonene": 1.54,
        "Ocimene": 0,
        "Linalool": 1.44,
        "Myrcene": 8,
        "Terpinolene": 0.29,
        "Bisabolol": 0.6,
        "Pinene": 5.59,
        "b-Pinene": 2.53
      },
      "state": "NV"
    },
    {
      "id": "NV-298",
      "strain": "Lemon Cherry Gelato ",
      "type": "Hybrid",
      "thc": 30.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.09,
        "Humulene": 1.19,
        "Limonene": 7.11,
        "Ocimene": 0,
        "Linalool": 4.48,
        "Myrcene": 8.02,
        "Terpinolene": 0.25,
        "Bisabolol": 0,
        "Pinene": 0.82,
        "b-Pinene": 1.29
      },
      "state": "NV"
    },
    {
      "id": "NV-210",
      "strain": "Sherb Cream Pie",
      "type": "Hybrid",
      "thc": 30.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.35,
        "Humulene": 0,
        "Limonene": 2.89,
        "Ocimene": 0,
        "Linalool": 2.97,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-188",
      "strain": "Red Rockz",
      "type": "Hybrid",
      "thc": 30.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.73,
        "Humulene": 1.4,
        "Limonene": 7.17,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 4.03,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.11
      },
      "state": "NV"
    },
    {
      "id": "NV-144",
      "strain": "Clout Fuel",
      "type": "Hybrid",
      "thc": 29.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.73,
        "Humulene": 1.14,
        "Limonene": 1.3,
        "Ocimene": 0,
        "Linalool": 1.29,
        "Myrcene": 5.58,
        "Terpinolene": 0.23,
        "Bisabolol": 0.56,
        "Pinene": 5.52,
        "b-Pinene": 2.42
      },
      "state": "NV"
    },
    {
      "id": "NV-236",
      "strain": "Mandarin Gold",
      "type": "Hybrid",
      "thc": 29.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.31,
        "Humulene": 0,
        "Limonene": 4,
        "Ocimene": 0,
        "Linalool": 2.61,
        "Myrcene": 2.12,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-166",
      "strain": "Citrus Spritz",
      "type": "Hybrid",
      "thc": 29.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.67,
        "Humulene": 1.57,
        "Limonene": 4.75,
        "Ocimene": 0,
        "Linalool": 5.56,
        "Myrcene": 2.18,
        "Terpinolene": 0.96,
        "Bisabolol": 1.25,
        "Pinene": 0.36,
        "b-Pinene": 0.59
      },
      "state": "NV"
    },
    {
      "id": "NV-311",
      "strain": "Snowball 89",
      "type": "Hybrid",
      "thc": 29.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.68,
        "Humulene": 2.41,
        "Limonene": 4.31,
        "Ocimene": 0,
        "Linalool": 0.92,
        "Myrcene": 6.88,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.28,
        "b-Pinene": 0.65
      },
      "state": "NV"
    },
    {
      "id": "NV-237",
      "strain": "Monkey Bread H",
      "type": "Hybrid",
      "thc": 29.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.07,
        "Humulene": 0.82,
        "Limonene": 4.22,
        "Ocimene": 0,
        "Linalool": 2.3,
        "Myrcene": 2.69,
        "Terpinolene": 0.09,
        "Bisabolol": 0,
        "Pinene": 0.51,
        "b-Pinene": 0.74
      },
      "state": "NV"
    },
    {
      "id": "NV-228",
      "strain": "Gypsy Road",
      "type": "Hybrid",
      "thc": 28.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.65,
        "Humulene": 0,
        "Limonene": 11.31,
        "Ocimene": 0,
        "Linalool": 1.65,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.81,
        "b-Pinene": 1.75
      },
      "state": "NV"
    },
    {
      "id": "NV-147",
      "strain": "Lemon Cherry Headz",
      "type": "Indica",
      "thc": 28.79,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.52,
        "Humulene": 2.83,
        "Limonene": 3.1,
        "Ocimene": 0,
        "Linalool": 1.94,
        "Myrcene": 3.84,
        "Terpinolene": 0,
        "Bisabolol": 0.76,
        "Pinene": 0.41,
        "b-Pinene": 0.74
      },
      "state": "NV"
    },
    {
      "id": "NV-217",
      "strain": "Canal Street Runtz",
      "type": "Hybrid",
      "thc": 28.74,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.09,
        "Humulene": 0.46,
        "Limonene": 0.26,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.5,
        "Terpinolene": 0.03,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "NV"
    },
    {
      "id": "NV-238",
      "strain": "The Toad H",
      "type": "Hybrid",
      "thc": 28.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.57,
        "Humulene": 0.97,
        "Limonene": 5.24,
        "Ocimene": 0,
        "Linalool": 1.93,
        "Myrcene": 6.13,
        "Terpinolene": 0.07,
        "Bisabolol": 0,
        "Pinene": 0.73,
        "b-Pinene": 1.36
      },
      "state": "NV"
    },
    {
      "id": "NV-299",
      "strain": "OG Glue ",
      "type": "Hybrid",
      "thc": 28.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.28,
        "Humulene": 1.22,
        "Limonene": 4.83,
        "Ocimene": 0,
        "Linalool": 0.5,
        "Myrcene": 8.96,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.6,
        "b-Pinene": 0.97
      },
      "state": "NV"
    },
    {
      "id": "NV-168",
      "strain": "Grape Monster",
      "type": "Sativa",
      "thc": 28.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.28,
        "Humulene": 1.55,
        "Limonene": 3.14,
        "Ocimene": 0,
        "Linalool": 4.63,
        "Myrcene": 2.97,
        "Terpinolene": 0,
        "Bisabolol": 1.04,
        "Pinene": 0.33,
        "b-Pinene": 0.49
      },
      "state": "NV"
    },
    {
      "id": "NV-186",
      "strain": "Madrina",
      "type": "Hybrid",
      "thc": 28.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.32,
        "Humulene": 1.17,
        "Limonene": 6.11,
        "Ocimene": 0,
        "Linalool": 2.39,
        "Myrcene": 7.37,
        "Terpinolene": 0.07,
        "Bisabolol": 0.08,
        "Pinene": 0.4,
        "b-Pinene": 0.87
      },
      "state": "NV"
    },
    {
      "id": "NV-140",
      "strain": "702 Headband",
      "type": "Hybrid",
      "thc": 28.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.59,
        "Humulene": 1.26,
        "Limonene": 4.74,
        "Ocimene": 0,
        "Linalool": 0.73,
        "Myrcene": 8.9,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.39
      },
      "state": "NV"
    },
    {
      "id": "NV-218",
      "strain": "Don Mega",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.4,
        "Humulene": 1.97,
        "Limonene": 6.12,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 4.95,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.66,
        "b-Pinene": 0.84
      },
      "state": "NV"
    },
    {
      "id": "NV-169",
      "strain": "Hash OG",
      "type": "Hybrid",
      "thc": 28.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.63,
        "Humulene": 1.86,
        "Limonene": 6.97,
        "Ocimene": 0,
        "Linalool": 0.92,
        "Myrcene": 6.58,
        "Terpinolene": 0,
        "Bisabolol": 0.87,
        "Pinene": 0.58,
        "b-Pinene": 0.81
      },
      "state": "NV"
    },
    {
      "id": "NV-231",
      "strain": "Banana Pie H",
      "type": "Hybrid",
      "thc": 28.25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.95,
        "Humulene": 0.76,
        "Limonene": 3.65,
        "Ocimene": 0,
        "Linalool": 2.3,
        "Myrcene": 1.93,
        "Terpinolene": 0.08,
        "Bisabolol": 0.28,
        "Pinene": 0.43,
        "b-Pinene": 0.62
      },
      "state": "NV"
    },
    {
      "id": "NV-305",
      "strain": "Fig Bar",
      "type": "Hybrid",
      "thc": 28.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.68,
        "Humulene": 1.13,
        "Limonene": 4.45,
        "Ocimene": 0,
        "Linalool": 2.11,
        "Myrcene": 1.64,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.62
      },
      "state": "NV"
    },
    {
      "id": "NV-149",
      "strain": "ZZ Bow",
      "type": "Hybrid",
      "thc": 28.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.89,
        "Humulene": 2.53,
        "Limonene": 2.23,
        "Ocimene": 0,
        "Linalool": 1.68,
        "Myrcene": 3.33,
        "Terpinolene": 0.22,
        "Bisabolol": 0.4,
        "Pinene": 1.45,
        "b-Pinene": 0.97
      },
      "state": "NV"
    },
    {
      "id": "NV-148",
      "strain": "Truffle Butter",
      "type": "Hybrid",
      "thc": 28.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.49,
        "Humulene": 1.84,
        "Limonene": 3.49,
        "Ocimene": 0,
        "Linalool": 1.73,
        "Myrcene": 2.66,
        "Terpinolene": 0,
        "Bisabolol": 0.63,
        "Pinene": 0.29,
        "b-Pinene": 0.62
      },
      "state": "NV"
    },
    {
      "id": "NV-172",
      "strain": "Garlic Cream",
      "type": "Hybrid",
      "thc": 28.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.53,
        "Humulene": 1.71,
        "Limonene": 6.8,
        "Ocimene": 0,
        "Linalool": 0.86,
        "Myrcene": 7.56,
        "Terpinolene": 0.06,
        "Bisabolol": 0.09,
        "Pinene": 0.67,
        "b-Pinene": 1.24
      },
      "state": "NV"
    },
    {
      "id": "NV-297",
      "strain": "Two Face",
      "type": "Hybrid",
      "thc": 28.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.21,
        "Humulene": 1.14,
        "Limonene": 3.09,
        "Ocimene": 0,
        "Linalool": 4.1,
        "Myrcene": 0.92,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.37,
        "b-Pinene": 0.54
      },
      "state": "NV"
    },
    {
      "id": "NV-300",
      "strain": "Papaya X Marathon OG #1",
      "type": "Hybrid",
      "thc": 28.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.98,
        "Humulene": 1.2,
        "Limonene": 8.02,
        "Ocimene": 0,
        "Linalool": 2.74,
        "Myrcene": 4.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.73,
        "b-Pinene": 1.14
      },
      "state": "NV"
    },
    {
      "id": "NV-270",
      "strain": "Alien Kush H",
      "type": "Hybrid",
      "thc": 28.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.9,
        "Humulene": 1.22,
        "Limonene": 4.34,
        "Ocimene": 0,
        "Linalool": 3.81,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-182",
      "strain": "Warheads",
      "type": "Sativa",
      "thc": 28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.78,
        "Humulene": 0.68,
        "Limonene": 2.01,
        "Ocimene": 0,
        "Linalool": 3.29,
        "Myrcene": 1.47,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.62
      },
      "state": "NV"
    },
    {
      "id": "NV-209",
      "strain": "Jack & Coke",
      "type": "Sativa",
      "thc": 27.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.6,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 3.66,
        "Terpinolene": 0.2,
        "Bisabolol": 0,
        "Pinene": 2.27,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-207",
      "strain": "Blue Dream ",
      "type": "Hybrid",
      "thc": 27.87,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 5.82,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 4.92,
        "b-Pinene": 2.18
      },
      "state": "NV"
    },
    {
      "id": "NV-138",
      "strain": "White Cherry Gelato",
      "type": "Hybrid",
      "thc": 27.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.11,
        "Humulene": 1.41,
        "Limonene": 3.57,
        "Ocimene": 0,
        "Linalool": 3.85,
        "Myrcene": 1.75,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.41,
        "b-Pinene": 0.6
      },
      "state": "NV"
    },
    {
      "id": "NV-229",
      "strain": "High Fructose Corn Syrup ",
      "type": "Indica",
      "thc": 27.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.9,
        "Humulene": 1.55,
        "Limonene": 1.88,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1.64,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-275",
      "strain": "The Juice",
      "type": "Hybrid",
      "thc": 27.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.8,
        "Humulene": 2.72,
        "Limonene": 5.96,
        "Ocimene": 0,
        "Linalool": 1.72,
        "Myrcene": 2.18,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.55,
        "b-Pinene": 1.5
      },
      "state": "NV"
    },
    {
      "id": "NV-251",
      "strain": "Tamarindo",
      "type": "Hybrid",
      "thc": 27.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.33,
        "Humulene": 0,
        "Limonene": 3.19,
        "Ocimene": 1.18,
        "Linalool": 0,
        "Myrcene": 5.84,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-190",
      "strain": "Carbon Fiber",
      "type": "Hybrid",
      "thc": 27.29,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.12,
        "Humulene": 2.69,
        "Limonene": 3.8,
        "Ocimene": 0,
        "Linalool": 2.11,
        "Myrcene": 4.66,
        "Terpinolene": 0.07,
        "Bisabolol": 0.88,
        "Pinene": 0.45,
        "b-Pinene": 0.85
      },
      "state": "NV"
    },
    {
      "id": "NV-306",
      "strain": "Coffin Syrup (Wedding Cake",
      "type": "Indica",
      "thc": 27.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.24,
        "Humulene": 1.44,
        "Limonene": 3.67,
        "Ocimene": 0,
        "Linalool": 2.84,
        "Myrcene": 4.94,
        "Terpinolene": 0.02,
        "Bisabolol": 0.06,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NV"
    },
    {
      "id": "NV-139",
      "strain": "White Guava Gelato",
      "type": "Hybrid",
      "thc": 27.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.05,
        "Humulene": 1.37,
        "Limonene": 5.25,
        "Ocimene": 0,
        "Linalool": 4.55,
        "Myrcene": 2.35,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.46,
        "b-Pinene": 0.68
      },
      "state": "NV"
    },
    {
      "id": "NV-195",
      "strain": "Baby Turtle",
      "type": "Hybrid",
      "thc": 27.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.6,
        "Humulene": 0.68,
        "Limonene": 1.61,
        "Ocimene": 1.13,
        "Linalool": 3.07,
        "Myrcene": 15.23,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.5
      },
      "state": "NV"
    },
    {
      "id": "NV-232",
      "strain": "Dynamite Cookies",
      "type": "Hybrid",
      "thc": 27.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.09,
        "Limonene": 0.35,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.18,
        "Terpinolene": 0.01,
        "Bisabolol": 0.04,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NV"
    },
    {
      "id": "NV-191",
      "strain": "Honey Stick",
      "type": "Hybrid",
      "thc": 26.99,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.78,
        "Humulene": 2.55,
        "Limonene": 3.78,
        "Ocimene": 0,
        "Linalool": 1.98,
        "Myrcene": 4.64,
        "Terpinolene": 0.07,
        "Bisabolol": 0.83,
        "Pinene": 0.43,
        "b-Pinene": 0.8
      },
      "state": "NV"
    },
    {
      "id": "NV-177",
      "strain": "Crescendo ",
      "type": "Hybrid",
      "thc": 26.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.21,
        "Humulene": 0.07,
        "Limonene": 1.53,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 2.16,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-175",
      "strain": "Miss B",
      "type": "Indica",
      "thc": 26.84,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.74,
        "Humulene": 0.48,
        "Limonene": 10.21,
        "Ocimene": 0,
        "Linalool": 4.6,
        "Myrcene": 5.16,
        "Terpinolene": 0.14,
        "Bisabolol": 0,
        "Pinene": 0.75,
        "b-Pinene": 1.3
      },
      "state": "NV"
    },
    {
      "id": "NV-184",
      "strain": "Appleato",
      "type": "Hybrid",
      "thc": 26.75,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.1,
        "Humulene": 0,
        "Limonene": 6.03,
        "Ocimene": 0,
        "Linalool": 2.22,
        "Myrcene": 6.9,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-304",
      "strain": "Diamond Dust",
      "type": "Hybrid",
      "thc": 26.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.06,
        "Humulene": 0.86,
        "Limonene": 2.25,
        "Ocimene": 0,
        "Linalool": 1.55,
        "Myrcene": 1.54,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.37
      },
      "state": "NV"
    },
    {
      "id": "NV-174",
      "strain": "Lemon Cherry Gelato ",
      "type": "Hybrid",
      "thc": 26.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.95,
        "Humulene": 0.91,
        "Limonene": 3.35,
        "Ocimene": 0,
        "Linalool": 3.38,
        "Myrcene": 5.06,
        "Terpinolene": 0.53,
        "Bisabolol": 0.59,
        "Pinene": 0.64,
        "b-Pinene": 0.96
      },
      "state": "NV"
    },
    {
      "id": "NV-101",
      "strain": "Cereal Milk",
      "type": "Hybrid",
      "thc": 26.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.28,
        "Humulene": 0.14,
        "Limonene": 2.85,
        "Ocimene": 0,
        "Linalool": 2.79,
        "Myrcene": 0.13,
        "Terpinolene": 0.02,
        "Bisabolol": 0.03,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NV"
    },
    {
      "id": "NV-146",
      "strain": "LCZ",
      "type": "Hybrid",
      "thc": 26.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.49,
        "Humulene": 1.06,
        "Limonene": 1.42,
        "Ocimene": 0,
        "Linalool": 1.35,
        "Myrcene": 6.13,
        "Terpinolene": 0.21,
        "Bisabolol": 0.51,
        "Pinene": 6.19,
        "b-Pinene": 2.69
      },
      "state": "NV"
    },
    {
      "id": "NV-193",
      "strain": "Sticky Fingers",
      "type": "Hybrid",
      "thc": 26.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.51,
        "Humulene": 2.87,
        "Limonene": 6.06,
        "Ocimene": 0.1,
        "Linalool": 0.62,
        "Myrcene": 10.22,
        "Terpinolene": 0.16,
        "Bisabolol": 0,
        "Pinene": 0.61,
        "b-Pinene": 1.35
      },
      "state": "NV"
    },
    {
      "id": "NV-221",
      "strain": "Blue Venom",
      "type": "Hybrid",
      "thc": 26.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.94,
        "Humulene": 1.39,
        "Limonene": 7.89,
        "Ocimene": 0,
        "Linalool": 3.47,
        "Myrcene": 3.12,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.81,
        "b-Pinene": 1.31
      },
      "state": "NV"
    },
    {
      "id": "NV-233",
      "strain": "Flat White",
      "type": "Hybrid",
      "thc": 26.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.47,
        "Humulene": 0,
        "Limonene": 4.57,
        "Ocimene": 0,
        "Linalool": 2.83,
        "Myrcene": 2.49,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-295",
      "strain": "GMO x Lemon",
      "type": "Hybrid",
      "thc": 26.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.11,
        "Humulene": 1.55,
        "Limonene": 4.36,
        "Ocimene": 0,
        "Linalool": 2.39,
        "Myrcene": 2.4,
        "Terpinolene": 0,
        "Bisabolol": 0.71,
        "Pinene": 0.68,
        "b-Pinene": 0.83
      },
      "state": "NV"
    },
    {
      "id": "NV-250",
      "strain": "Ice Cream Man",
      "type": "Hybrid",
      "thc": 26.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.71,
        "Humulene": 1.26,
        "Limonene": 6.36,
        "Ocimene": 0,
        "Linalool": 1.93,
        "Myrcene": 6.08,
        "Terpinolene": 0.27,
        "Bisabolol": 0.6,
        "Pinene": 0.65,
        "b-Pinene": 1.22
      },
      "state": "NV"
    },
    {
      "id": "NV-141",
      "strain": "Anaimal Cookies",
      "type": "Hybrid",
      "thc": 26.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.81,
        "Humulene": 0.12,
        "Limonene": 5.83,
        "Ocimene": 0,
        "Linalool": 2.59,
        "Myrcene": 0.1,
        "Terpinolene": 0,
        "Bisabolol": 0.1,
        "Pinene": 0.08,
        "b-Pinene": 0.12
      },
      "state": "NV"
    },
    {
      "id": "NV-252",
      "strain": "Chemical Cookies ",
      "type": "Hybrid",
      "thc": 26.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.45,
        "Humulene": 2.05,
        "Limonene": 10.77,
        "Ocimene": 0,
        "Linalool": 0.83,
        "Myrcene": 3.85,
        "Terpinolene": 0.09,
        "Bisabolol": 0.1,
        "Pinene": 0.81,
        "b-Pinene": 1.24
      },
      "state": "NV"
    },
    {
      "id": "NV-247",
      "strain": "Apple Tartz",
      "type": "Hybrid",
      "thc": 26.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.42,
        "Humulene": 0.96,
        "Limonene": 4.75,
        "Ocimene": 0,
        "Linalool": 2.7,
        "Myrcene": 2.15,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.48,
        "b-Pinene": 0.91
      },
      "state": "NV"
    },
    {
      "id": "NV-152",
      "strain": "Fuji Sherbert I",
      "type": "Hybrid",
      "thc": 26.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.38,
        "Humulene": 2.09,
        "Limonene": 7.63,
        "Ocimene": 0,
        "Linalool": 3.68,
        "Myrcene": 2,
        "Terpinolene": 0.19,
        "Bisabolol": 0,
        "Pinene": 0.58,
        "b-Pinene": 0.9
      },
      "state": "NV"
    },
    {
      "id": "NV-271",
      "strain": "Canal Street Runtz",
      "type": "Hybrid",
      "thc": 26.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.62,
        "Humulene": 3.62,
        "Limonene": 3.37,
        "Ocimene": 0,
        "Linalool": 2.22,
        "Myrcene": 2.47,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-100",
      "strain": "VelcroZ",
      "type": "Hybrid",
      "thc": 26.27,
      "cbd": 0.1,
      "lineage": "Blue Flame OG x Blue Zushi",
      "terpenes": {
        "Caryophyllene": 5.73,
        "Humulene": 1.8,
        "Limonene": 5.81,
        "Ocimene": 0,
        "Linalool": 2.92,
        "Myrcene": 7.24,
        "Terpinolene": 0,
        "Bisabolol": 0.76,
        "Pinene": 0.46,
        "b-Pinene": 0.96
      },
      "state": "NV"
    },
    {
      "id": "NV-265",
      "strain": "Biofuel",
      "type": "Hybrid",
      "thc": 26.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.87,
        "Humulene": 1.74,
        "Limonene": 3.33,
        "Ocimene": 0,
        "Linalool": 1.19,
        "Myrcene": 0.67,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.41,
        "b-Pinene": 0.63
      },
      "state": "NV"
    },
    {
      "id": "NV-136",
      "strain": "Scoby",
      "type": "Indica",
      "thc": 26.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0.08,
        "Limonene": 0.8,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 1.32,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.09,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-267",
      "strain": "Space Junky",
      "type": "Hybrid",
      "thc": 26.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.64,
        "Humulene": 0.98,
        "Limonene": 5.56,
        "Ocimene": 0,
        "Linalool": 3,
        "Myrcene": 1.07,
        "Terpinolene": 0.27,
        "Bisabolol": 0,
        "Pinene": 0.49,
        "b-Pinene": 0.9
      },
      "state": "NV"
    },
    {
      "id": "NV-185",
      "strain": "Cinnamon Roll",
      "type": "Hybrid",
      "thc": 26.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.13,
        "Limonene": 0.54,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 0.74,
        "Terpinolene": 0.01,
        "Bisabolol": 0.01,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "NV"
    },
    {
      "id": "NV-165",
      "strain": "Bushido OG",
      "type": "Sativa",
      "thc": 26.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.98,
        "Humulene": 0.64,
        "Limonene": 5.37,
        "Ocimene": 0,
        "Linalool": 1.36,
        "Myrcene": 1.83,
        "Terpinolene": 0,
        "Bisabolol": 0.53,
        "Pinene": 11.57,
        "b-Pinene": 4.14
      },
      "state": "NV"
    },
    {
      "id": "NV-234",
      "strain": "Jealousy",
      "type": "Hybrid",
      "thc": 26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.04,
        "Humulene": 0.81,
        "Limonene": 3.7,
        "Ocimene": 0,
        "Linalool": 2.04,
        "Myrcene": 2.51,
        "Terpinolene": 0.08,
        "Bisabolol": 0.3,
        "Pinene": 0.42,
        "b-Pinene": 0.65
      },
      "state": "NV"
    },
    {
      "id": "NV-107",
      "strain": "Chem N' Cookies",
      "type": "Hybrid",
      "thc": 25.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.41,
        "Humulene": 2.21,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 3.49,
        "Myrcene": 12.9,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-145",
      "strain": "Cream Pie",
      "type": "Hybrid",
      "thc": 25.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.44,
        "Humulene": 1.79,
        "Limonene": 3.27,
        "Ocimene": 0,
        "Linalool": 1.55,
        "Myrcene": 1.85,
        "Terpinolene": 0,
        "Bisabolol": 0.59,
        "Pinene": 0.25,
        "b-Pinene": 0.61
      },
      "state": "NV"
    },
    {
      "id": "NV-227",
      "strain": "Cadillac Rainbows ",
      "type": "Hybrid",
      "thc": 25.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.97,
        "Humulene": 1.14,
        "Limonene": 8.22,
        "Ocimene": 0,
        "Linalool": 0.93,
        "Myrcene": 6,
        "Terpinolene": 0.08,
        "Bisabolol": 0.06,
        "Pinene": 0.72,
        "b-Pinene": 1.38
      },
      "state": "NV"
    },
    {
      "id": "NV-272",
      "strain": "OG Diesel",
      "type": "Hybrid",
      "thc": 25.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.4,
        "Humulene": 0.12,
        "Limonene": 3.78,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 7.94,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-269",
      "strain": "Tropicana Acai",
      "type": "Hybrid",
      "thc": 25.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.06,
        "Humulene": 0.35,
        "Limonene": 2.3,
        "Ocimene": 0,
        "Linalool": 0.88,
        "Myrcene": 0.6,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.37
      },
      "state": "NV"
    },
    {
      "id": "NV-279",
      "strain": "Sweet Tangie",
      "type": "Sativa",
      "thc": 25.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.71,
        "Humulene": 0.2,
        "Limonene": 1.03,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.06,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.22,
        "b-Pinene": 0.22
      },
      "state": "NV"
    },
    {
      "id": "NV-197",
      "strain": "Khalifa Mints",
      "type": "Hybrid",
      "thc": 25.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.38,
        "Humulene": 1.44,
        "Limonene": 6.27,
        "Ocimene": 0,
        "Linalool": 5.43,
        "Myrcene": 0.32,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.21,
        "b-Pinene": 1.34
      },
      "state": "NV"
    },
    {
      "id": "NV-266",
      "strain": "Lemon Rope",
      "type": "Hybrid",
      "thc": 25.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.44,
        "Humulene": 1.25,
        "Limonene": 1.34,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1.67,
        "Terpinolene": 16.73,
        "Bisabolol": 0.4,
        "Pinene": 0.92,
        "b-Pinene": 1.53
      },
      "state": "NV"
    },
    {
      "id": "NV-292",
      "strain": "AJ Sour",
      "type": "Hybrid",
      "thc": 25.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.62,
        "Humulene": 0.77,
        "Limonene": 8.69,
        "Ocimene": 0.44,
        "Linalool": 3.11,
        "Myrcene": 7.19,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.38,
        "b-Pinene": 1.26
      },
      "state": "NV"
    },
    {
      "id": "NV-307",
      "strain": "Mule Fuel",
      "type": "Hybrid",
      "thc": 25.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.72,
        "Humulene": 1.03,
        "Limonene": 2.42,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 23.34,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 5.54,
        "b-Pinene": 2.17
      },
      "state": "NV"
    },
    {
      "id": "NV-282",
      "strain": "White Zerbert",
      "type": "Indica",
      "thc": 25.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 9.2,
        "Humulene": 2.84,
        "Limonene": 12.84,
        "Ocimene": 0.04,
        "Linalool": 1.8,
        "Myrcene": 0.74,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 2.59,
        "b-Pinene": 2.42
      },
      "state": "NV"
    },
    {
      "id": "NV-118",
      "strain": "GMO x Z",
      "type": "Indica",
      "thc": 25.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 14.24,
        "Humulene": 5.17,
        "Limonene": 2.78,
        "Ocimene": 0,
        "Linalool": 0.64,
        "Myrcene": 0.49,
        "Terpinolene": 0.95,
        "Bisabolol": 0,
        "Pinene": 0.28,
        "b-Pinene": 0.39
      },
      "state": "NV"
    },
    {
      "id": "NV-167",
      "strain": "Designer Runtz ",
      "type": "Indica",
      "thc": 25.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.72,
        "Humulene": 0.78,
        "Limonene": 5.76,
        "Ocimene": 0.52,
        "Linalool": 5.6,
        "Myrcene": 2.07,
        "Terpinolene": 0.41,
        "Bisabolol": 0,
        "Pinene": 0.62,
        "b-Pinene": 0.85
      },
      "state": "NV"
    },
    {
      "id": "NV-103",
      "strain": "Apple Cobbler",
      "type": "Hybrid",
      "thc": 24.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.39,
        "Humulene": 1.25,
        "Limonene": 10.59,
        "Ocimene": 1.16,
        "Linalool": 3.77,
        "Myrcene": 1.5,
        "Terpinolene": 0.4,
        "Bisabolol": 0,
        "Pinene": 3.82,
        "b-Pinene": 2.77
      },
      "state": "NV"
    },
    {
      "id": "NV-124",
      "strain": "Outta my Head",
      "type": "Hybrid",
      "thc": 24.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3,
        "Humulene": 1.55,
        "Limonene": 4.93,
        "Ocimene": 0,
        "Linalool": 1.57,
        "Myrcene": 2.62,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1.13
      },
      "state": "NV"
    },
    {
      "id": "NV-235",
      "strain": "Lemoncello",
      "type": "Hybrid",
      "thc": 24.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.11,
        "Humulene": 0.05,
        "Limonene": 0.8,
        "Ocimene": 0,
        "Linalool": 0.01,
        "Myrcene": 0.84,
        "Terpinolene": 0.02,
        "Bisabolol": 0.01,
        "Pinene": 0.08,
        "b-Pinene": 0.08
      },
      "state": "NV"
    },
    {
      "id": "NV-196",
      "strain": "Khalifa Kush ",
      "type": "Hybrid",
      "thc": 24.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.78,
        "Humulene": 1.45,
        "Limonene": 2.21,
        "Ocimene": 0,
        "Linalool": 2.13,
        "Myrcene": 2.65,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.35,
        "b-Pinene": 0.55
      },
      "state": "NV"
    },
    {
      "id": "NV-273",
      "strain": "Peak 112",
      "type": "Hybrid",
      "thc": 24.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.85,
        "Humulene": 1.25,
        "Limonene": 6.37,
        "Ocimene": 0,
        "Linalool": 2.16,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-274",
      "strain": "Pink Runtz",
      "type": "Hybrid",
      "thc": 24.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.03,
        "Humulene": 0,
        "Limonene": 4.94,
        "Ocimene": 0,
        "Linalool": 6.61,
        "Myrcene": 2.28,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-239",
      "strain": "Uppercut",
      "type": "Hybrid",
      "thc": 24.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.19,
        "Humulene": 0,
        "Limonene": 4.19,
        "Ocimene": 0,
        "Linalool": 2.22,
        "Myrcene": 2.83,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-291",
      "strain": "Hawaiian Punch",
      "type": "Hybrid",
      "thc": 24.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 8.8,
        "Humulene": 2.44,
        "Limonene": 7.94,
        "Ocimene": 0,
        "Linalool": 4.65,
        "Myrcene": 0.33,
        "Terpinolene": 0.08,
        "Bisabolol": 0,
        "Pinene": 0.58,
        "b-Pinene": 0.96
      },
      "state": "NV"
    },
    {
      "id": "NV-178",
      "strain": "Golden Sands",
      "type": "Hybrid",
      "thc": 24.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.29,
        "Humulene": 0.12,
        "Limonene": 4.6,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 2.88,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NV"
    },
    {
      "id": "NV-179",
      "strain": "Grimmdica",
      "type": "Indica",
      "thc": 24.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.48,
        "Humulene": 0.36,
        "Limonene": 1.97,
        "Ocimene": 0,
        "Linalool": 0.81,
        "Myrcene": 5.61,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.58,
        "b-Pinene": 0.68
      },
      "state": "NV"
    },
    {
      "id": "NV-127",
      "strain": "Prodigy",
      "type": "Hybrid",
      "thc": 24.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.52,
        "Humulene": 3.11,
        "Limonene": 4.44,
        "Ocimene": 0,
        "Linalool": 4.76,
        "Myrcene": 0.12,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.48,
        "b-Pinene": 0.71
      },
      "state": "NV"
    },
    {
      "id": "NV-137",
      "strain": "Truffle Skunk",
      "type": "Hybrid",
      "thc": 24.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.26,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.32,
        "Myrcene": 0.95,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.07,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-120",
      "strain": "Hawaiian Mints ",
      "type": "Hybrid",
      "thc": 24.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.91,
        "Humulene": 0.86,
        "Limonene": 1.36,
        "Ocimene": 0.62,
        "Linalool": 2.09,
        "Myrcene": 5.4,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.15,
        "b-Pinene": 0.23
      },
      "state": "NV"
    },
    {
      "id": "NV-133",
      "strain": "Velvet Glove",
      "type": "Hybrid",
      "thc": 24.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.76,
        "Humulene": 1.48,
        "Limonene": 5.34,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 6.43,
        "Terpinolene": 0.02,
        "Bisabolol": 0.07,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NV"
    },
    {
      "id": "NV-117",
      "strain": "GG4",
      "type": "Hybrid",
      "thc": 24.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 9.73,
        "Humulene": 2.92,
        "Limonene": 4.5,
        "Ocimene": 0,
        "Linalool": 0.92,
        "Myrcene": 3.62,
        "Terpinolene": 0,
        "Bisabolol": 1.65,
        "Pinene": 0.37,
        "b-Pinene": 0.57
      },
      "state": "NV"
    },
    {
      "id": "NV-106",
      "strain": "Cereal Milk",
      "type": "Hybrid",
      "thc": 24.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.8,
        "Humulene": 1.1,
        "Limonene": 2.9,
        "Ocimene": 0,
        "Linalool": 2.28,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-123",
      "strain": "Mystic Mint",
      "type": "Indica",
      "thc": 24.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.04,
        "Humulene": 0.65,
        "Limonene": 4.33,
        "Ocimene": 0,
        "Linalool": 1.58,
        "Myrcene": 1.38,
        "Terpinolene": 0,
        "Bisabolol": 0.62,
        "Pinene": 1.28,
        "b-Pinene": 1.04
      },
      "state": "NV"
    },
    {
      "id": "NV-310",
      "strain": "Sherbanger",
      "type": "Hybrid",
      "thc": 24.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.17,
        "Humulene": 0.64,
        "Limonene": 4.77,
        "Ocimene": 0,
        "Linalool": 1.3,
        "Myrcene": 2.2,
        "Terpinolene": 0,
        "Bisabolol": 0.21,
        "Pinene": 1.11,
        "b-Pinene": 1.02
      },
      "state": "NV"
    },
    {
      "id": "NV-173",
      "strain": "GG4 on Fire",
      "type": "Hybrid",
      "thc": 24.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.88,
        "Humulene": 1.82,
        "Limonene": 4.31,
        "Ocimene": 0,
        "Linalool": 1.09,
        "Myrcene": 9.27,
        "Terpinolene": 0.08,
        "Bisabolol": 0,
        "Pinene": 0.41,
        "b-Pinene": 0.74
      },
      "state": "NV"
    },
    {
      "id": "NV-249",
      "strain": "GMO",
      "type": "Indica",
      "thc": 24.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.7,
        "Humulene": 1.83,
        "Limonene": 3.18,
        "Ocimene": 0,
        "Linalool": 1.76,
        "Myrcene": 7.08,
        "Terpinolene": 0,
        "Bisabolol": 0.67,
        "Pinene": 4.19,
        "b-Pinene": 2.08
      },
      "state": "NV"
    },
    {
      "id": "NV-303",
      "strain": "Tiger Toe",
      "type": "Hybrid",
      "thc": 24.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0.12,
        "Limonene": 0.27,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NV"
    },
    {
      "id": "NV-202",
      "strain": "Headband",
      "type": "Hybrid",
      "thc": 24.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.55,
        "Humulene": 1.74,
        "Limonene": 8.27,
        "Ocimene": 0,
        "Linalool": 1.77,
        "Myrcene": 2.1,
        "Terpinolene": 0.09,
        "Bisabolol": 0,
        "Pinene": 0.72,
        "b-Pinene": 1.32
      },
      "state": "NV"
    },
    {
      "id": "NV-126",
      "strain": "Point Break",
      "type": "Hybrid",
      "thc": 24.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.9,
        "Humulene": 0.09,
        "Limonene": 2.59,
        "Ocimene": 0,
        "Linalool": 1.88,
        "Myrcene": 1.55,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0,
        "b-Pinene": 0.04
      },
      "state": "NV"
    },
    {
      "id": "NV-308",
      "strain": "Chemistry",
      "type": "Hybrid",
      "thc": 24.11,
      "cbd": 0.1,
      "lineage": "Chemdawg x OG Kush",
      "terpenes": {
        "Caryophyllene": 3.85,
        "Humulene": 1.27,
        "Limonene": 4.4,
        "Ocimene": 0,
        "Linalool": 1.84,
        "Myrcene": 12.26,
        "Terpinolene": 0.02,
        "Bisabolol": 0.08,
        "Pinene": 0.04,
        "b-Pinene": 0.09
      },
      "state": "NV"
    },
    {
      "id": "NV-309",
      "strain": "Shady Apples",
      "type": "Hybrid",
      "thc": 24.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.48,
        "Humulene": 1.16,
        "Limonene": 3.61,
        "Ocimene": 0.73,
        "Linalool": 1.26,
        "Myrcene": 2.6,
        "Terpinolene": 0.22,
        "Bisabolol": 0,
        "Pinene": 0.95,
        "b-Pinene": 0.98
      },
      "state": "NV"
    },
    {
      "id": "NV-230",
      "strain": "Super Buff Cherry",
      "type": "Hybrid",
      "thc": 24.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.9,
        "Humulene": 0.59,
        "Limonene": 3.9,
        "Ocimene": 0,
        "Linalool": 1.2,
        "Myrcene": 1.75,
        "Terpinolene": 0.04,
        "Bisabolol": 0,
        "Pinene": 0.33,
        "b-Pinene": 0.55
      },
      "state": "NV"
    },
    {
      "id": "NV-260",
      "strain": "Scooby Snax",
      "type": "Hybrid",
      "thc": 23.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.1,
        "Humulene": 1.64,
        "Limonene": 3.47,
        "Ocimene": 0,
        "Linalool": 0.51,
        "Myrcene": 0.89,
        "Terpinolene": 0,
        "Bisabolol": 0.2,
        "Pinene": 0.29,
        "b-Pinene": 0.5
      },
      "state": "NV"
    },
    {
      "id": "NV-187",
      "strain": "Malibu Marker",
      "type": "Hybrid",
      "thc": 23.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.24,
        "Humulene": 1.02,
        "Limonene": 10.5,
        "Ocimene": 0,
        "Linalool": 4.23,
        "Myrcene": 2.56,
        "Terpinolene": 0.11,
        "Bisabolol": 0.07,
        "Pinene": 0.72,
        "b-Pinene": 1.38
      },
      "state": "NV"
    },
    {
      "id": "NV-134",
      "strain": "Venom OG ",
      "type": "Indica",
      "thc": 23.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.71,
        "Humulene": 1.15,
        "Limonene": 4.89,
        "Ocimene": 0,
        "Linalool": 2.82,
        "Myrcene": 4.38,
        "Terpinolene": 0.33,
        "Bisabolol": 0,
        "Pinene": 0.68,
        "b-Pinene": 1.23
      },
      "state": "NV"
    },
    {
      "id": "NV-288",
      "strain": "The Juice",
      "type": "Hybrid",
      "thc": 23.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.63,
        "Humulene": 0.1,
        "Limonene": 0.35,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 1.78,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.77
      },
      "state": "NV"
    },
    {
      "id": "NV-248",
      "strain": "Funk Bomb",
      "type": "Sativa",
      "thc": 23.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 3.9,
        "Ocimene": 0,
        "Linalool": 1.36,
        "Myrcene": 5.19,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 5.91,
        "b-Pinene": 1.75
      },
      "state": "NV"
    },
    {
      "id": "NV-162",
      "strain": "Triangle Kush",
      "type": "Hybrid",
      "thc": 23.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.95,
        "Humulene": 3.95,
        "Limonene": 3.94,
        "Ocimene": 0,
        "Linalool": 0.68,
        "Myrcene": 3.4,
        "Terpinolene": 0,
        "Bisabolol": 1.74,
        "Pinene": 0.41,
        "b-Pinene": 0.53
      },
      "state": "NV"
    },
    {
      "id": "NV-206",
      "strain": "Zlushie",
      "type": "Hybrid",
      "thc": 23.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.11,
        "Limonene": 0.37,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.46,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NV"
    },
    {
      "id": "NV-129",
      "strain": "Regina George",
      "type": "Hybrid",
      "thc": 23.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.68,
        "Humulene": 1.26,
        "Limonene": 2.31,
        "Ocimene": 0,
        "Linalool": 1.06,
        "Myrcene": 1.85,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.22,
        "b-Pinene": 0.38
      },
      "state": "NV"
    },
    {
      "id": "NV-255",
      "strain": "Jealousy",
      "type": "Hybrid",
      "thc": 23.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.6,
        "Humulene": 0.63,
        "Limonene": 5.63,
        "Ocimene": 0,
        "Linalool": 1.71,
        "Myrcene": 1.12,
        "Terpinolene": 0.05,
        "Bisabolol": 0.06,
        "Pinene": 0.49,
        "b-Pinene": 0.94
      },
      "state": "NV"
    },
    {
      "id": "NV-121",
      "strain": "Kosher Kush",
      "type": "Indica",
      "thc": 23.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.69,
        "Humulene": 0.95,
        "Limonene": 3.16,
        "Ocimene": 0.22,
        "Linalool": 1.48,
        "Myrcene": 2.93,
        "Terpinolene": 0.23,
        "Bisabolol": 0,
        "Pinene": 0.39,
        "b-Pinene": 0.7
      },
      "state": "NV"
    },
    {
      "id": "NV-198",
      "strain": "Point Breeze",
      "type": "Hybrid",
      "thc": 23.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.55,
        "Humulene": 1.46,
        "Limonene": 5.26,
        "Ocimene": 0.42,
        "Linalool": 3.37,
        "Myrcene": 0.31,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.27,
        "b-Pinene": 1.12
      },
      "state": "NV"
    },
    {
      "id": "NV-277",
      "strain": "Cherry Popperz",
      "type": "Indica",
      "thc": 23.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.94,
        "Humulene": 0.33,
        "Limonene": 0.63,
        "Ocimene": 0,
        "Linalool": 0.31,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.11,
        "b-Pinene": 0.11
      },
      "state": "NV"
    },
    {
      "id": "NV-226",
      "strain": "Super Jet Fuel",
      "type": "Hybrid",
      "thc": 23.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 8.39,
        "Humulene": 2.12,
        "Limonene": 5.46,
        "Ocimene": 0,
        "Linalool": 0.52,
        "Myrcene": 2.97,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.52,
        "b-Pinene": 0.78
      },
      "state": "NV"
    },
    {
      "id": "NV-203",
      "strain": "Lemon Cherry Gelato ",
      "type": "Hybrid",
      "thc": 23.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.07,
        "Limonene": 0.77,
        "Ocimene": 0,
        "Linalool": 0.4,
        "Myrcene": 0.44,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "NV"
    },
    {
      "id": "NV-216",
      "strain": "Mandarin Cookies",
      "type": "Hybrid",
      "thc": 23.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.15,
        "Limonene": 0.35,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.48,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NV"
    },
    {
      "id": "NV-115",
      "strain": "Gas Stank",
      "type": "Indica",
      "thc": 23.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.64,
        "Humulene": 1.18,
        "Limonene": 1.99,
        "Ocimene": 0,
        "Linalool": 1.18,
        "Myrcene": 1.93,
        "Terpinolene": 0.47,
        "Bisabolol": 0.79,
        "Pinene": 0.54,
        "b-Pinene": 0.76
      },
      "state": "NV"
    },
    {
      "id": "NV-261",
      "strain": "Skywalker OG ",
      "type": "Hybrid",
      "thc": 23.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.24,
        "Humulene": 1.64,
        "Limonene": 2.5,
        "Ocimene": 0,
        "Linalool": 0.65,
        "Myrcene": 0.09,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.22,
        "b-Pinene": 0.26
      },
      "state": "NV"
    },
    {
      "id": "NV-158",
      "strain": "KMAC",
      "type": "Hybrid",
      "thc": 23.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.04,
        "Humulene": 1.38,
        "Limonene": 4.03,
        "Ocimene": 0,
        "Linalool": 2.37,
        "Myrcene": 0.22,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.51,
        "b-Pinene": 0.48
      },
      "state": "NV"
    },
    {
      "id": "NV-108",
      "strain": "Confidential Cherries",
      "type": "Indica",
      "thc": 23.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.84,
        "Humulene": 0.96,
        "Limonene": 2.74,
        "Ocimene": 0,
        "Linalool": 1.41,
        "Myrcene": 2.16,
        "Terpinolene": 0,
        "Bisabolol": 0.66,
        "Pinene": 0.27,
        "b-Pinene": 0.55
      },
      "state": "NV"
    },
    {
      "id": "NV-160",
      "strain": "Papaya ",
      "type": "Hybrid",
      "thc": 23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.13,
        "Humulene": 1.99,
        "Limonene": 6.49,
        "Ocimene": 0,
        "Linalool": 3.2,
        "Myrcene": 1.54,
        "Terpinolene": 0.16,
        "Bisabolol": 0,
        "Pinene": 0.5,
        "b-Pinene": 0.77
      },
      "state": "NV"
    },
    {
      "id": "NV-224",
      "strain": "Green Crack",
      "type": "Sativa",
      "thc": 22.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.78,
        "Humulene": 1.79,
        "Limonene": 1.74,
        "Ocimene": 0,
        "Linalool": 0.41,
        "Myrcene": 3.33,
        "Terpinolene": 10.47,
        "Bisabolol": 0,
        "Pinene": 1.02,
        "b-Pinene": 0.9
      },
      "state": "NV"
    },
    {
      "id": "NV-289",
      "strain": "Alien Moon Pie ",
      "type": "Hybrid",
      "thc": 22.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.18,
        "Limonene": 3.69,
        "Ocimene": 0,
        "Linalool": 0.73,
        "Myrcene": 18.38,
        "Terpinolene": 0.05,
        "Bisabolol": 0,
        "Pinene": 2.41,
        "b-Pinene": 1.42
      },
      "state": "NV"
    },
    {
      "id": "NV-105",
      "strain": "Bubba Fett",
      "type": "Indica",
      "thc": 22.93,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.48,
        "Humulene": 1.39,
        "Limonene": 4.76,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.13,
        "Terpinolene": 0.05,
        "Bisabolol": 0.11,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "NV"
    },
    {
      "id": "NV-111",
      "strain": "Donny Burger",
      "type": "Hybrid",
      "thc": 22.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.23,
        "Limonene": 0.53,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.59,
        "Terpinolene": 0.03,
        "Bisabolol": 0.08,
        "Pinene": 0.05,
        "b-Pinene": 0.1
      },
      "state": "NV"
    },
    {
      "id": "NV-109",
      "strain": "Cranberry Z",
      "type": "Indica",
      "thc": 22.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.69,
        "Humulene": 0.78,
        "Limonene": 6.06,
        "Ocimene": 0,
        "Linalool": 2.1,
        "Myrcene": 0.86,
        "Terpinolene": 0.5,
        "Bisabolol": 0.62,
        "Pinene": 1.72,
        "b-Pinene": 1.68
      },
      "state": "NV"
    },
    {
      "id": "NV-116",
      "strain": "Gastro Pop",
      "type": "Hybrid",
      "thc": 22.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.96,
        "Humulene": 1.42,
        "Limonene": 3.37,
        "Ocimene": 0,
        "Linalool": 3.03,
        "Myrcene": 1.73,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.44,
        "b-Pinene": 0.67
      },
      "state": "NV"
    },
    {
      "id": "NV-112",
      "strain": "Donut Trip",
      "type": "Hybrid",
      "thc": 22.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.33,
        "Humulene": 1.21,
        "Limonene": 5.84,
        "Ocimene": 0,
        "Linalool": 1.96,
        "Myrcene": 2.7,
        "Terpinolene": 0.02,
        "Bisabolol": 0.07,
        "Pinene": 0.06,
        "b-Pinene": 1.05
      },
      "state": "NV"
    },
    {
      "id": "NV-244",
      "strain": "Marmalade",
      "type": "Hybrid",
      "thc": 22.71,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.44,
        "Humulene": 0.54,
        "Limonene": 0.92,
        "Ocimene": 0.92,
        "Linalool": 0.77,
        "Myrcene": 6.77,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.6,
        "b-Pinene": 0.82
      },
      "state": "NV"
    },
    {
      "id": "NV-205",
      "strain": "Sexual Healing",
      "type": "Hybrid",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.08,
        "Humulene": 0.42,
        "Limonene": 0.66,
        "Ocimene": 3.79,
        "Linalool": 1.44,
        "Myrcene": 9.87,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.98,
        "b-Pinene": 0.5
      },
      "state": "NV"
    },
    {
      "id": "NV-102",
      "strain": "44 Hyena",
      "type": "Indica",
      "thc": 22.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.92,
        "Humulene": 0.87,
        "Limonene": 1.09,
        "Ocimene": 0,
        "Linalool": 1.42,
        "Myrcene": 6.39,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.45
      },
      "state": "NV"
    },
    {
      "id": "NV-171",
      "strain": "Pixie Stix",
      "type": "Indica",
      "thc": 22.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.5,
        "Humulene": 2.16,
        "Limonene": 4.09,
        "Ocimene": 0,
        "Linalool": 1.98,
        "Myrcene": 3.34,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.52,
        "b-Pinene": 0.64
      },
      "state": "NV"
    },
    {
      "id": "NV-161",
      "strain": "Thin Mint x Jealousy",
      "type": "Hybrid",
      "thc": 22.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.77,
        "Humulene": 0,
        "Limonene": 3.42,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-189",
      "strain": "Topanga Glue",
      "type": "Hybrid",
      "thc": 22.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.13,
        "Humulene": 0.61,
        "Limonene": 9.74,
        "Ocimene": 0,
        "Linalool": 3.55,
        "Myrcene": 2.33,
        "Terpinolene": 0.11,
        "Bisabolol": 0,
        "Pinene": 0.69,
        "b-Pinene": 1.24
      },
      "state": "NV"
    },
    {
      "id": "NV-122",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 22.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.5,
        "Humulene": 1.4,
        "Limonene": 7.6,
        "Ocimene": 0,
        "Linalool": 3.2,
        "Myrcene": 4.1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.5,
        "b-Pinene": 1
      },
      "state": "NV"
    },
    {
      "id": "NV-156",
      "strain": "Grapes & Cream",
      "type": "Hybrid",
      "thc": 22.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.16,
        "Humulene": 2.36,
        "Limonene": 2.55,
        "Ocimene": 0,
        "Linalool": 0.77,
        "Myrcene": 0.57,
        "Terpinolene": 0.45,
        "Bisabolol": 0.73,
        "Pinene": 0.54,
        "b-Pinene": 0.7
      },
      "state": "NV"
    },
    {
      "id": "NV-243",
      "strain": "Chem D",
      "type": "Hybrid",
      "thc": 22.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.88,
        "Humulene": 1.27,
        "Limonene": 4.37,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 2.83,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.77
      },
      "state": "NV"
    },
    {
      "id": "NV-213",
      "strain": "Foam",
      "type": "Hybrid",
      "thc": 22.55,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 8.53,
        "Humulene": 2.66,
        "Limonene": 4.31,
        "Ocimene": 0,
        "Linalool": 2.27,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.47,
        "b-Pinene": 0.68
      },
      "state": "NV"
    },
    {
      "id": "NV-128",
      "strain": "Rainbow Zlushie",
      "type": "Hybrid",
      "thc": 22.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.1,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.42,
        "Myrcene": 0.14,
        "Terpinolene": 0.05,
        "Bisabolol": 0.05,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "NV"
    },
    {
      "id": "NV-285",
      "strain": "Canal Street Runtz ",
      "type": "Indica",
      "thc": 22.36,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.57,
        "Humulene": 0.22,
        "Limonene": 0.33,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.58,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.05
      },
      "state": "NV"
    },
    {
      "id": "NV-150",
      "strain": "Big Apple x Kush Mints",
      "type": "Hybrid",
      "thc": 22.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.8,
        "Humulene": 1.9,
        "Limonene": 3.4,
        "Ocimene": 0,
        "Linalool": 2.9,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.7,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-246",
      "strain": "Permanently Divine",
      "type": "Hybrid",
      "thc": 22.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.53,
        "Humulene": 2.49,
        "Limonene": 6.42,
        "Ocimene": 0,
        "Linalool": 2.94,
        "Myrcene": 17.55,
        "Terpinolene": 0,
        "Bisabolol": 0.16,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-192",
      "strain": "Rainbow Sherbert",
      "type": "Hybrid",
      "thc": 22.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.87,
        "Humulene": 1.08,
        "Limonene": 2.48,
        "Ocimene": 0,
        "Linalool": 2.8,
        "Myrcene": 2.69,
        "Terpinolene": 0.21,
        "Bisabolol": 0.84,
        "Pinene": 1.1,
        "b-Pinene": 0.85
      },
      "state": "NV"
    },
    {
      "id": "NV-293",
      "strain": "Garlic Cocktail",
      "type": "Indica",
      "thc": 22.26,
      "cbd": 0.1,
      "lineage": "GMO x Mimosa",
      "terpenes": {
        "Caryophyllene": 0.77,
        "Humulene": 0.26,
        "Limonene": 0.67,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.19,
        "Terpinolene": 0,
        "Bisabolol": 0.2,
        "Pinene": 0.05,
        "b-Pinene": 0.07
      },
      "state": "NV"
    },
    {
      "id": "NV-294",
      "strain": "Grape Gas ",
      "type": "Hybrid",
      "thc": 22.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.31,
        "Humulene": 1.75,
        "Limonene": 2.55,
        "Ocimene": 0,
        "Linalool": 1.98,
        "Myrcene": 0.88,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.34,
        "b-Pinene": 0.52
      },
      "state": "NV"
    },
    {
      "id": "NV-131",
      "strain": "Tidal Wave",
      "type": "Hybrid",
      "thc": 22.21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0.05,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.26,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NV"
    },
    {
      "id": "NV-110",
      "strain": "Daily Grape",
      "type": "Indica",
      "thc": 22.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.01,
        "Humulene": 0.94,
        "Limonene": 6.08,
        "Ocimene": 0,
        "Linalool": 1.02,
        "Myrcene": 0.2,
        "Terpinolene": 0,
        "Bisabolol": 0.92,
        "Pinene": 1.29,
        "b-Pinene": 1.04
      },
      "state": "NV"
    },
    {
      "id": "NV-176",
      "strain": "Miss Kashmir",
      "type": "Hybrid",
      "thc": 22.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.8,
        "Humulene": 1.4,
        "Limonene": 6.2,
        "Ocimene": 0,
        "Linalool": 4.6,
        "Myrcene": 1.2,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.8
      },
      "state": "NV"
    },
    {
      "id": "NV-284",
      "strain": "Blue Guava",
      "type": "Hybrid",
      "thc": 22.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.05,
        "Humulene": 0,
        "Limonene": 5.39,
        "Ocimene": 0,
        "Linalool": 6.62,
        "Myrcene": 2.51,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-119",
      "strain": "Grape Stomper OG",
      "type": "Hybrid",
      "thc": 22.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.02,
        "Humulene": 0,
        "Limonene": 0.68,
        "Ocimene": 0,
        "Linalool": 0.87,
        "Myrcene": 7.28,
        "Terpinolene": 0.2,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-199",
      "strain": "Blue Dashi",
      "type": "Hybrid",
      "thc": 22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.41,
        "Humulene": 1.53,
        "Limonene": 9.59,
        "Ocimene": 0.1,
        "Linalool": 3.07,
        "Myrcene": 0.75,
        "Terpinolene": 0.13,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1.47
      },
      "state": "NV"
    },
    {
      "id": "NV-215",
      "strain": "White Truffle",
      "type": "Hybrid",
      "thc": 21.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.16,
        "Humulene": 3.03,
        "Limonene": 4.56,
        "Ocimene": 0,
        "Linalool": 0.38,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.33,
        "b-Pinene": 1.16
      },
      "state": "NV"
    },
    {
      "id": "NV-286",
      "strain": "Peanut Butter Souffle ",
      "type": "Hybrid",
      "thc": 21.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.8,
        "Humulene": 0.81,
        "Limonene": 0.36,
        "Ocimene": 0,
        "Linalool": 1.62,
        "Myrcene": 6.18,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-200",
      "strain": "Carbon Fiber",
      "type": "Hybrid",
      "thc": 21.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.03,
        "Humulene": 0.7,
        "Limonene": 5.21,
        "Ocimene": 0,
        "Linalool": 4.22,
        "Myrcene": 3.72,
        "Terpinolene": 0.07,
        "Bisabolol": 0,
        "Pinene": 0.54,
        "b-Pinene": 1.03
      },
      "state": "NV"
    },
    {
      "id": "NV-264",
      "strain": "Sunset Sherbet",
      "type": "Hybrid",
      "thc": 21.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.89,
        "Humulene": 1.81,
        "Limonene": 6.38,
        "Ocimene": 0,
        "Linalool": 0.55,
        "Myrcene": 0.23,
        "Terpinolene": 0.06,
        "Bisabolol": 0.09,
        "Pinene": 0.57,
        "b-Pinene": 0.8
      },
      "state": "NV"
    },
    {
      "id": "NV-204",
      "strain": "LFG",
      "type": "Hybrid",
      "thc": 21.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.25,
        "Humulene": 0.75,
        "Limonene": 7.98,
        "Ocimene": 0,
        "Linalool": 5.47,
        "Myrcene": 6.98,
        "Terpinolene": 0.11,
        "Bisabolol": 0,
        "Pinene": 0.65,
        "b-Pinene": 1.26
      },
      "state": "NV"
    },
    {
      "id": "NV-223",
      "strain": "Gelato Glue",
      "type": "Hybrid",
      "thc": 21.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 7.89,
        "Humulene": 2.17,
        "Limonene": 4.35,
        "Ocimene": 0,
        "Linalool": 3.39,
        "Myrcene": 4.1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-283",
      "strain": "Alien Kush",
      "type": "Hybrid",
      "thc": 21.55,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.33,
        "Humulene": 0,
        "Limonene": 3.78,
        "Ocimene": 0,
        "Linalool": 3.24,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-164",
      "strain": "BTY OG",
      "type": "Indica",
      "thc": 21.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 10.78,
        "Humulene": 3.18,
        "Limonene": 4.02,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 6.06,
        "Terpinolene": 0,
        "Bisabolol": 0.94,
        "Pinene": 0.88,
        "b-Pinene": 0.65
      },
      "state": "NV"
    },
    {
      "id": "NV-214",
      "strain": "Ice Cream Cone",
      "type": "Hybrid",
      "thc": 21.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.99,
        "Humulene": 0.64,
        "Limonene": 2.66,
        "Ocimene": 0,
        "Linalool": 2.21,
        "Myrcene": 1.74,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.65,
        "b-Pinene": 0.95
      },
      "state": "NV"
    },
    {
      "id": "NV-135",
      "strain": "Pixie Dust",
      "type": "Hybrid",
      "thc": 21.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.08,
        "Limonene": 0.1,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 1.01,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-181",
      "strain": "Vanilla Frosting",
      "type": "Sativa",
      "thc": 21.24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.76,
        "Humulene": 0.62,
        "Limonene": 2.1,
        "Ocimene": 0,
        "Linalool": 0.93,
        "Myrcene": 0.47,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.91,
        "b-Pinene": 1.1
      },
      "state": "NV"
    },
    {
      "id": "NV-245",
      "strain": "Gas Powered Cake",
      "type": "Hybrid",
      "thc": 21.22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 8.53,
        "Humulene": 2.56,
        "Limonene": 6.37,
        "Ocimene": 0,
        "Linalool": 2.36,
        "Myrcene": 1.06,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.23,
        "b-Pinene": 1.3
      },
      "state": "NV"
    },
    {
      "id": "NV-113",
      "strain": "Fruitcake",
      "type": "Indica",
      "thc": 21.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.06,
        "Humulene": 0.75,
        "Limonene": 1.75,
        "Ocimene": 0,
        "Linalool": 1.16,
        "Myrcene": 11.15,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 2.04,
        "b-Pinene": 1.27
      },
      "state": "NV"
    },
    {
      "id": "NV-287",
      "strain": "Pink Runtz",
      "type": "Hybrid",
      "thc": 21.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.07,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.43,
        "Myrcene": 0.34,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "NV"
    },
    {
      "id": "NV-125",
      "strain": "Pineapple Dolce",
      "type": "Indica",
      "thc": 21.01,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.12,
        "Humulene": 0.07,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.13,
        "Terpinolene": 0.04,
        "Bisabolol": 0.04,
        "Pinene": 0.14,
        "b-Pinene": 0.1
      },
      "state": "NV"
    },
    {
      "id": "NV-259",
      "strain": "Runtz",
      "type": "Hybrid",
      "thc": 20.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.61,
        "Humulene": 2.77,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 1.17,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "NV"
    },
    {
      "id": "NV-114",
      "strain": "Gary Payton",
      "type": "Hybrid",
      "thc": 20.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.76,
        "Humulene": 0.24,
        "Limonene": 0.21,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 0.2,
        "Terpinolene": 0,
        "Bisabolol": 0.12,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NV"
    },
    {
      "id": "NV-132",
      "strain": "Vanilla Frosting ",
      "type": "Indica",
      "thc": 20.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.99,
        "Humulene": 0.91,
        "Limonene": 3.88,
        "Ocimene": 0,
        "Linalool": 1.67,
        "Myrcene": 3.84,
        "Terpinolene": 0,
        "Bisabolol": 0.5,
        "Pinene": 0.24,
        "b-Pinene": 0.61
      },
      "state": "NV"
    },
    {
      "id": "NV-155",
      "strain": "GMO Cookies",
      "type": "Hybrid",
      "thc": 20.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.45,
        "Humulene": 2.84,
        "Limonene": 3.5,
        "Ocimene": 0,
        "Linalool": 0.69,
        "Myrcene": 3.89,
        "Terpinolene": 0.41,
        "Bisabolol": 1.34,
        "Pinene": 0.46,
        "b-Pinene": 0.66
      },
      "state": "NV"
    },
    {
      "id": "NV-268",
      "strain": "Stripper Glitter",
      "type": "Hybrid",
      "thc": 20.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.39,
        "Humulene": 0.87,
        "Limonene": 1.29,
        "Ocimene": 0.77,
        "Linalool": 0.93,
        "Myrcene": 9.02,
        "Terpinolene": 0.22,
        "Bisabolol": 0,
        "Pinene": 0.14,
        "b-Pinene": 0.3
      },
      "state": "NV"
    },
    {
      "id": "NV-212",
      "strain": "Chicken N' Waffles ",
      "type": "Hybrid",
      "thc": 20.62,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.96,
        "Humulene": 0.3,
        "Limonene": 5.09,
        "Ocimene": 0,
        "Linalool": 2,
        "Myrcene": 2.47,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.67,
        "b-Pinene": 0.96
      },
      "state": "NV"
    },
    {
      "id": "NV-225",
      "strain": "Secret Weapon",
      "type": "Sativa",
      "thc": 20.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.1,
        "Humulene": 1.5,
        "Limonene": 2.4,
        "Ocimene": 0,
        "Linalool": 0.8,
        "Myrcene": 6,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0,
        "b-Pinene": 0.6
      },
      "state": "NV"
    },
    {
      "id": "NV-153",
      "strain": "Fuji Sherbet ",
      "type": "Indica",
      "thc": 20.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.53,
        "Humulene": 0,
        "Limonene": 4.22,
        "Ocimene": 0,
        "Linalool": 2.46,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-159",
      "strain": "Mac 1 - H",
      "type": "Hybrid",
      "thc": 20.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.18,
        "Humulene": 1.05,
        "Limonene": 4.29,
        "Ocimene": 0,
        "Linalool": 2.05,
        "Myrcene": 0.56,
        "Terpinolene": 0,
        "Bisabolol": 1.88,
        "Pinene": 1.51,
        "b-Pinene": 0.98
      },
      "state": "NV"
    },
    {
      "id": "NV-220",
      "strain": "Head Cheese",
      "type": "Hybrid",
      "thc": 20.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.17,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 1.08,
        "Myrcene": 16.64,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.1,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-290",
      "strain": "Garlic Mints",
      "type": "Hybrid",
      "thc": 20.43,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.97,
        "Humulene": 0.59,
        "Limonene": 9.59,
        "Ocimene": 3.12,
        "Linalool": 1.72,
        "Myrcene": 1.17,
        "Terpinolene": 0.09,
        "Bisabolol": 0,
        "Pinene": 1.31,
        "b-Pinene": 1.36
      },
      "state": "NV"
    },
    {
      "id": "NV-201",
      "strain": "Governmint Oasis",
      "type": "Hybrid",
      "thc": 20.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.58,
        "Humulene": 0.14,
        "Limonene": 0.5,
        "Ocimene": 0,
        "Linalool": 0.27,
        "Myrcene": 0.6,
        "Terpinolene": 0.01,
        "Bisabolol": 0.01,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "NV"
    },
    {
      "id": "NV-242",
      "strain": "BurgerZ",
      "type": "Hybrid",
      "thc": 20.08,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.92,
        "Humulene": 1.35,
        "Limonene": 2.3,
        "Ocimene": 0,
        "Linalool": 1.77,
        "Myrcene": 6.5,
        "Terpinolene": 0.2,
        "Bisabolol": 0.7,
        "Pinene": 0.29,
        "b-Pinene": 0.61
      },
      "state": "NV"
    },
    {
      "id": "NV-104",
      "strain": "Banana Runtz",
      "type": "Indica",
      "thc": 19.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.88,
        "Humulene": 1.17,
        "Limonene": 2.78,
        "Ocimene": 0,
        "Linalool": 2.79,
        "Myrcene": 4.91,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-281",
      "strain": "White Truffle",
      "type": "Hybrid",
      "thc": 19.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.42,
        "Humulene": 1.49,
        "Limonene": 2.49,
        "Ocimene": 0,
        "Linalool": 2.14,
        "Myrcene": 3.39,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-130",
      "strain": "SoFlo Kerosene",
      "type": "Indica",
      "thc": 19.57,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.16,
        "Humulene": 0.05,
        "Limonene": 0.25,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.08,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.05
      },
      "state": "NV"
    },
    {
      "id": "NV-154",
      "strain": "Glitter Bomb ",
      "type": "Hybrid",
      "thc": 19.29,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.48,
        "Humulene": 1.12,
        "Limonene": 0.59,
        "Ocimene": 0.34,
        "Linalool": 1.82,
        "Myrcene": 3.25,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.19,
        "b-Pinene": 0.2
      },
      "state": "NV"
    },
    {
      "id": "NV-170",
      "strain": "Orange Cookies",
      "type": "Sativa",
      "thc": 19.21,
      "cbd": 0.1,
      "lineage": "Orange Juice X Girl Scout Cookies",
      "terpenes": {
        "Caryophyllene": 4.94,
        "Humulene": 1.84,
        "Limonene": 1.77,
        "Ocimene": 0,
        "Linalool": 3.4,
        "Myrcene": 2.45,
        "Terpinolene": 0.58,
        "Bisabolol": 0,
        "Pinene": 0.15,
        "b-Pinene": 0.22
      },
      "state": "NV"
    },
    {
      "id": "NV-280",
      "strain": "Thin Mintz",
      "type": "Hybrid",
      "thc": 18.99,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.22,
        "Humulene": 1.51,
        "Limonene": 9.47,
        "Ocimene": 0,
        "Linalool": 5.89,
        "Myrcene": 13.61,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 1.18
      },
      "state": "NV"
    },
    {
      "id": "NV-222",
      "strain": "Cherry Tangerine",
      "type": "Hybrid",
      "thc": 18.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.09,
        "Limonene": 0.15,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 1.34,
        "b-Pinene": 0.25
      },
      "state": "NV"
    },
    {
      "id": "NV-278",
      "strain": "Stiiizy OG",
      "type": "Indica",
      "thc": 18.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 11.02,
        "Humulene": 4.02,
        "Limonene": 8.55,
        "Ocimene": 0,
        "Linalool": 3.63,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1.25,
        "b-Pinene": 1.47
      },
      "state": "NV"
    },
    {
      "id": "NV-276",
      "strain": "Black Cherry Gelato - H",
      "type": "Hybrid",
      "thc": 18.29,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.52,
        "Humulene": 1.05,
        "Limonene": 3.92,
        "Ocimene": 0,
        "Linalool": 5.04,
        "Myrcene": 4.44,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.44,
        "b-Pinene": 0.51
      },
      "state": "NV"
    },
    {
      "id": "NV-254",
      "strain": "Hindu Zkittlez",
      "type": "Hybrid",
      "thc": 17.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 10.22,
        "Humulene": 3.35,
        "Limonene": 6.09,
        "Ocimene": 0,
        "Linalool": 3.15,
        "Myrcene": 0.27,
        "Terpinolene": 0.07,
        "Bisabolol": 0.12,
        "Pinene": 0.4,
        "b-Pinene": 0.72
      },
      "state": "NV"
    },
    {
      "id": "NV-241",
      "strain": "Bio Jesus H",
      "type": "Hybrid",
      "thc": 17.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.54,
        "Humulene": 6.3,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.88,
        "Myrcene": 4.4,
        "Terpinolene": 0,
        "Bisabolol": 0.3,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-253",
      "strain": "Gas Candy",
      "type": "Hybrid",
      "thc": 17.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 2.84,
        "Humulene": 0.66,
        "Limonene": 5.94,
        "Ocimene": 0,
        "Linalool": 5.16,
        "Myrcene": 3.41,
        "Terpinolene": 0.6,
        "Bisabolol": 0,
        "Pinene": 0.49,
        "b-Pinene": 1.01
      },
      "state": "NV"
    },
    {
      "id": "NV-302",
      "strain": "Gnarbarian",
      "type": "Hybrid",
      "thc": 17.31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.22,
        "Humulene": 1.55,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 3.74,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NV"
    },
    {
      "id": "NV-151",
      "strain": "Black Ice",
      "type": "Hybrid",
      "thc": 17.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 4.1,
        "Humulene": 1.4,
        "Limonene": 2.8,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 2.4,
        "Terpinolene": 0,
        "Bisabolol": 0.7,
        "Pinene": 0.04,
        "b-Pinene": 0.05
      },
      "state": "NV"
    },
    {
      "id": "NV-163",
      "strain": "Wedding Pie ",
      "type": "Hybrid",
      "thc": 17.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.73,
        "Humulene": 2.07,
        "Limonene": 2.36,
        "Ocimene": 0,
        "Linalool": 0.62,
        "Myrcene": 0.19,
        "Terpinolene": 0,
        "Bisabolol": 0.77,
        "Pinene": 0.29,
        "b-Pinene": 0.36
      },
      "state": "NV"
    },
    {
      "id": "NV-262",
      "strain": "Skywalker OG Kush",
      "type": "Hybrid",
      "thc": 17.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.36,
        "Humulene": 1.02,
        "Limonene": 7.87,
        "Ocimene": 0,
        "Linalool": 3.67,
        "Myrcene": 4.79,
        "Terpinolene": 0.07,
        "Bisabolol": 0,
        "Pinene": 0.68,
        "b-Pinene": 1.24
      },
      "state": "NV"
    },
    {
      "id": "NV-256",
      "strain": "Mousse Cake ",
      "type": "Hybrid",
      "thc": 16.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.15,
        "Humulene": 1.15,
        "Limonene": 2.81,
        "Ocimene": 0,
        "Linalool": 1.18,
        "Myrcene": 1.49,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.3,
        "b-Pinene": 0.51
      },
      "state": "NV"
    },
    {
      "id": "NV-258",
      "strain": "Pinnacle Runtz",
      "type": "Hybrid",
      "thc": 16.56,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.2,
        "Humulene": 1.48,
        "Limonene": 4.78,
        "Ocimene": 0,
        "Linalool": 1.53,
        "Myrcene": 0.23,
        "Terpinolene": 0.04,
        "Bisabolol": 0,
        "Pinene": 0.53,
        "b-Pinene": 0.83
      },
      "state": "NV"
    },
    {
      "id": "NV-257",
      "strain": "Peach Pie",
      "type": "Hybrid",
      "thc": 16.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 6.44,
        "Humulene": 1.68,
        "Limonene": 8.39,
        "Ocimene": 0.5,
        "Linalool": 2.18,
        "Myrcene": 0.42,
        "Terpinolene": 0.08,
        "Bisabolol": 0,
        "Pinene": 1.03,
        "b-Pinene": 1.15
      },
      "state": "NV"
    },
    {
      "id": "NV-263",
      "strain": "Sunset Black Ice",
      "type": "Hybrid",
      "thc": 15.29,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 5.17,
        "Humulene": 1.67,
        "Limonene": 5.76,
        "Ocimene": 0,
        "Linalool": 2.76,
        "Myrcene": 3.28,
        "Terpinolene": 0.06,
        "Bisabolol": 0,
        "Pinene": 0.39,
        "b-Pinene": 0.7
      },
      "state": "NV"
    },
    {
      "id": "NV-157",
      "strain": "Jealousy x Kush Mintz",
      "type": "Hybrid",
      "thc": 15.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 3.31,
        "Humulene": 1.05,
        "Limonene": 2.86,
        "Ocimene": 0,
        "Linalool": 1.53,
        "Myrcene": 0.28,
        "Terpinolene": 0,
        "Bisabolol": 0.54,
        "Pinene": 0.25,
        "b-Pinene": 0.34
      },
      "state": "NV"
    }
  ],
  NY: [
    {
      "id": "NY-150",
      "strain": "Foreign Kush Mints",
      "type": "Indica",
      "thc": 33.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.61,
        "Humulene": 0.2,
        "Limonene": 0.53,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.94,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.07
      },
      "state": "NY"
    },
    {
      "id": "NY-161",
      "strain": "Hell's OG",
      "type": "Hybrid",
      "thc": 32.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-162",
      "strain": "Znow Flakes",
      "type": "Hybrid",
      "thc": 31.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-101",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 31.6,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.14,
        "Limonene": 0.77,
        "Ocimene": 0,
        "Linalool": 0.61,
        "Myrcene": 0.12,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.15
      },
      "state": "NY"
    },
    {
      "id": "NY-147",
      "strain": "Sugar Breath",
      "type": "Hybrid",
      "thc": 31.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.26,
        "Limonene": 1.94,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.45,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.28,
        "b-Pinene": 1.06
      },
      "state": "NY"
    },
    {
      "id": "NY-136",
      "strain": "GMO Punch",
      "type": "Hybrid",
      "thc": 31.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-134",
      "strain": "Vampire Killer",
      "type": "Hybrid",
      "thc": 30.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.5,
        "Humulene": 0.17,
        "Limonene": 0.22,
        "Ocimene": 0.07,
        "Linalool": 0,
        "Myrcene": 0.9,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-144",
      "strain": "Thai Sunrise",
      "type": "Sativa",
      "thc": 30.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.14,
        "Limonene": 0.42,
        "Ocimene": 0.2,
        "Linalool": 0.07,
        "Myrcene": 0.53,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "NY"
    },
    {
      "id": "NY-137",
      "strain": "Honeymoon Diesel",
      "type": "Hybrid",
      "thc": 29.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-111",
      "strain": "THaze",
      "type": "Sativa",
      "thc": 29.78,
      "cbd": 0.1,
      "lineage": "G13 Haze x East Coast Sour Diesel",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-143",
      "strain": "Mint Snackz",
      "type": "Hybrid",
      "thc": 29.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.13,
        "Limonene": 0.49,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "NY"
    },
    {
      "id": "NY-153",
      "strain": "Bananaberry Diesel",
      "type": "Hybrid",
      "thc": 28.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-133",
      "strain": "Urban Legend",
      "type": "Indica",
      "thc": 28.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-156",
      "strain": "Ruby Violet",
      "type": "Sativa",
      "thc": 28.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-100",
      "strain": "Garlic Drip",
      "type": "Indica",
      "thc": 27.93,
      "cbd": 0.1,
      "lineage": "GMO x White OG",
      "terpenes": {
        "Caryophyllene": 0.36,
        "Humulene": 0.15,
        "Limonene": 0.74,
        "Ocimene": 0,
        "Linalool": 0.57,
        "Myrcene": 0.13,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NY"
    },
    {
      "id": "NY-102",
      "strain": "Granny Candy",
      "type": "Sativa",
      "thc": 27.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.53,
        "Humulene": 0.19,
        "Limonene": 0.41,
        "Ocimene": 0.31,
        "Linalool": 0.14,
        "Myrcene": 0.32,
        "Terpinolene": 1.1,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.12
      },
      "state": "NY"
    },
    {
      "id": "NY-152",
      "strain": "Titan Express",
      "type": "Hybrid",
      "thc": 27.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-160",
      "strain": "Bazooka Haze",
      "type": "Sativa",
      "thc": 27.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-129",
      "strain": "Apple Cobbler",
      "type": "Hybrid",
      "thc": 27.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.84,
        "Humulene": 0.24,
        "Limonene": 1.43,
        "Ocimene": 0.14,
        "Linalool": 0.55,
        "Myrcene": 0.17,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.47,
        "b-Pinene": 0.33
      },
      "state": "NY"
    },
    {
      "id": "NY-155",
      "strain": "Miracle Glue",
      "type": "Hybrid",
      "thc": 27.25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-154",
      "strain": "Island Time Kush",
      "type": "Indica",
      "thc": 27.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-164",
      "strain": "Permanent Pie",
      "type": "Indica",
      "thc": 26.97,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Sour 91 Pie",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-105",
      "strain": "Jet Fuel OG",
      "type": "Hybrid",
      "thc": 26.96,
      "cbd": 0.1,
      "lineage": "Aspen OG x High Country Diesel",
      "terpenes": {
        "Caryophyllene": 0.67,
        "Humulene": 0.21,
        "Limonene": 0.74,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.65,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "NY"
    },
    {
      "id": "NY-163",
      "strain": "Inkberry Pie",
      "type": "Indica",
      "thc": 26.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-130",
      "strain": "Duct Tape",
      "type": "Indica",
      "thc": 26.75,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.6,
        "Humulene": 0.21,
        "Limonene": 0.41,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.32,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NY"
    },
    {
      "id": "NY-104",
      "strain": "Jack's Delight",
      "type": "Sativa",
      "thc": 26.67,
      "cbd": 0.1,
      "lineage": "Jack Herer x (AD4 x Point Break",
      "terpenes": {
        "Caryophyllene": 0.57,
        "Humulene": 0.24,
        "Limonene": 0.16,
        "Ocimene": 0.29,
        "Linalool": 0.06,
        "Myrcene": 0.37,
        "Terpinolene": 0.92,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.13
      },
      "state": "NY"
    },
    {
      "id": "NY-138",
      "strain": "Bruntz",
      "type": "Sativa",
      "thc": 26.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-131",
      "strain": "Cherry Berry Latte",
      "type": "Sativa",
      "thc": 26.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.07,
        "Humulene": 0.02,
        "Limonene": 0.16,
        "Ocimene": 0.27,
        "Linalool": 0.05,
        "Myrcene": 0.3,
        "Terpinolene": 0.7,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "NY"
    },
    {
      "id": "NY-113",
      "strain": "Chicken N Wafflez",
      "type": "Sativa",
      "thc": 26.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.17,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.28,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.09
      },
      "state": "NY"
    },
    {
      "id": "NY-135",
      "strain": "Blue Nerdz",
      "type": "Hybrid",
      "thc": 26.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-122",
      "strain": "LA Kush Cake",
      "type": "Indica",
      "thc": 26.07,
      "cbd": 0.1,
      "lineage": "Kush Mints x Wedding Cake",
      "terpenes": {
        "Caryophyllene": 0.6,
        "Humulene": 0.16,
        "Limonene": 0.38,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.12,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "NY"
    },
    {
      "id": "NY-146",
      "strain": "True OG",
      "type": "Indica",
      "thc": 25.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.09,
        "Limonene": 0.1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.71,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-115",
      "strain": "Fat Billy",
      "type": "Hybrid",
      "thc": 25.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.07,
        "Limonene": 0.85,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.43,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "NY"
    },
    {
      "id": "NY-151",
      "strain": "Moonbeam Gelato",
      "type": "Hybrid",
      "thc": 25.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.08,
        "Limonene": 0.43,
        "Ocimene": 0.04,
        "Linalool": 0.06,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "NY"
    },
    {
      "id": "NY-148",
      "strain": "Delphi Diesel",
      "type": "Sativa",
      "thc": 25.12,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.23,
        "Limonene": 0.24,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.36,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.01,
        "b-Pinene": 0.03
      },
      "state": "NY"
    },
    {
      "id": "NY-108",
      "strain": "Rose Gold Runtz",
      "type": "Hybrid",
      "thc": 25.03,
      "cbd": 0.1,
      "lineage": "Apples & Bananas x White Runtz",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.14,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-110",
      "strain": "Taffy Twist",
      "type": "Indica",
      "thc": 24.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.48,
        "Humulene": 0.13,
        "Limonene": 0.82,
        "Ocimene": 0,
        "Linalool": 0.36,
        "Myrcene": 0.18,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "NY"
    },
    {
      "id": "NY-114",
      "strain": "Durban Z",
      "type": "Sativa",
      "thc": 24.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-128",
      "strain": "Zack's Cake",
      "type": "Hybrid",
      "thc": 24.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-127",
      "strain": "Sudzz",
      "type": "Indica",
      "thc": 23.92,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.73,
        "Humulene": 0.27,
        "Limonene": 0.21,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.01,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-103",
      "strain": "Hash Queen",
      "type": "Sativa",
      "thc": 23.9,
      "cbd": 0.1,
      "lineage": "Killer Queen x Puck",
      "terpenes": {
        "Caryophyllene": 0.59,
        "Humulene": 0.16,
        "Limonene": 0.19,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.69,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.01,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-109",
      "strain": "Sour Diesel (S",
      "type": "Sativa",
      "thc": 23.78,
      "cbd": 0.1,
      "lineage": "Chemdawg 91 x Super Skunk",
      "terpenes": {
        "Caryophyllene": 0.7,
        "Humulene": 0.27,
        "Limonene": 1.13,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.76,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.14
      },
      "state": "NY"
    },
    {
      "id": "NY-142",
      "strain": "Banana Papaya",
      "type": "Hybrid",
      "thc": 23.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-107",
      "strain": "Lemon Gelato Cookies",
      "type": "Sativa",
      "thc": 23.61,
      "cbd": 0.1,
      "lineage": "Lemon Cookies x Gelato #1",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0.22,
        "Limonene": 0.31,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "NY"
    },
    {
      "id": "NY-132",
      "strain": "Orange Slice Nebula",
      "type": "Hybrid",
      "thc": 23.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.09,
        "Humulene": 0.04,
        "Limonene": 0.11,
        "Ocimene": 0.01,
        "Linalool": 0.01,
        "Myrcene": 0.39,
        "Terpinolene": 0.83,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "NY"
    },
    {
      "id": "NY-141",
      "strain": "Agent Z",
      "type": "Hybrid",
      "thc": 23.34,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0.05,
        "Limonene": 0.32,
        "Ocimene": 0.01,
        "Linalool": 0.17,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.06
      },
      "state": "NY"
    },
    {
      "id": "NY-124",
      "strain": "Rainbow Zlushie",
      "type": "Hybrid",
      "thc": 22.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.3,
        "Humulene": 0.07,
        "Limonene": 0.81,
        "Ocimene": 0,
        "Linalool": 0.59,
        "Myrcene": 0.19,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "NY"
    },
    {
      "id": "NY-126",
      "strain": "Slapz",
      "type": "Hybrid",
      "thc": 22.94,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.08,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.09,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "NY"
    },
    {
      "id": "NY-112",
      "strain": "Cereal Milk",
      "type": "Hybrid",
      "thc": 22.41,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.68,
        "Humulene": 0.22,
        "Limonene": 0.48,
        "Ocimene": 0.12,
        "Linalool": 0.31,
        "Myrcene": 0.03,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.12,
        "b-Pinene": 0.1
      },
      "state": "NY"
    },
    {
      "id": "NY-145",
      "strain": "Tierz",
      "type": "Hybrid",
      "thc": 22.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-117",
      "strain": "Gelato AK",
      "type": "Hybrid",
      "thc": 21.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.64,
        "Humulene": 0.23,
        "Limonene": 0.53,
        "Ocimene": 0.06,
        "Linalool": 0.06,
        "Myrcene": 0.16,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "NY"
    },
    {
      "id": "NY-106",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 21.1,
      "cbd": 0.1,
      "lineage": "Oregon Lemon x Orange Crush",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.09,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 0.22,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.07
      },
      "state": "NY"
    },
    {
      "id": "NY-120",
      "strain": "Jahspresso",
      "type": "Sativa",
      "thc": 20.92,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-123",
      "strain": "Night Owl Haze",
      "type": "Sativa",
      "thc": 20.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-116",
      "strain": "Frozen Margarita",
      "type": "Sativa",
      "thc": 19.79,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-118",
      "strain": "Hybrid Blend",
      "type": "Hybrid",
      "thc": 19.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.05,
        "Limonene": 0.32,
        "Ocimene": 0,
        "Linalool": 0.48,
        "Myrcene": 0.05,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-119",
      "strain": "Indica Blend",
      "type": "Indica",
      "thc": 18.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.1,
        "Limonene": 0.35,
        "Ocimene": 0.02,
        "Linalool": 0.17,
        "Myrcene": 0.02,
        "Terpinolene": 0.03,
        "Bisabolol": 0,
        "Pinene": 0.11,
        "b-Pinene": 0.08
      },
      "state": "NY"
    },
    {
      "id": "NY-125",
      "strain": "Sativa Blend",
      "type": "Sativa",
      "thc": 18.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.32,
        "Humulene": 0.1,
        "Limonene": 0.05,
        "Ocimene": 0.12,
        "Linalool": 0.03,
        "Myrcene": 0.08,
        "Terpinolene": 0.89,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "NY"
    },
    {
      "id": "NY-121",
      "strain": "Kosher Kush",
      "type": "Indica",
      "thc": 18.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.07,
        "Limonene": 0.35,
        "Ocimene": 0,
        "Linalool": 0.24,
        "Myrcene": 1.34,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.06
      },
      "state": "NY"
    },
    {
      "id": "NY-139",
      "strain": "Lemon Cherry Gelato",
      "type": "Indica",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-140",
      "strain": "Papaya Juice",
      "type": "Sativa",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-157",
      "strain": "Sunday Gravy",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-158",
      "strain": "Tropical Treats",
      "type": "Sativa",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    },
    {
      "id": "NY-159",
      "strain": "Garlicane",
      "type": "Hybrid",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "NY"
    }
  ],
  VA: [
    {
      "id": "VA-114",
      "strain": "BK OG",
      "type": "Hybrid",
      "thc": 32.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.62,
        "Humulene": 0.18,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.64,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.1
      },
      "state": "VA"
    },
    {
      "id": "VA-110",
      "strain": "Mystic Mint",
      "type": "Indica",
      "thc": 32.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.36,
        "Humulene": 0.1,
        "Limonene": 1.28,
        "Ocimene": 0.01,
        "Linalool": 0.24,
        "Myrcene": 0.39,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.32,
        "b-Pinene": 0.26
      },
      "state": "VA"
    },
    {
      "id": "VA-129",
      "strain": "GMO (H",
      "type": "Indica",
      "thc": 32.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.76,
        "Humulene": 0.3,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 1.37,
        "Terpinolene": 0,
        "Bisabolol": 0.19,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-130",
      "strain": "HiFlyer",
      "type": "Hybrid",
      "thc": 30.45,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.44,
        "Humulene": 0.16,
        "Limonene": 0.8,
        "Ocimene": 0.01,
        "Linalool": 0.29,
        "Myrcene": 1.45,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.07,
        "b-Pinene": 0.12
      },
      "state": "VA"
    },
    {
      "id": "VA-133",
      "strain": "Purple Starfruit",
      "type": "Hybrid",
      "thc": 30.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.08,
        "Limonene": 0.66,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.43,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "VA"
    },
    {
      "id": "VA-115",
      "strain": "Chem Dawg",
      "type": "Sativa",
      "thc": 29.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.98,
        "Humulene": 0.32,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.07,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "VA"
    },
    {
      "id": "VA-107",
      "strain": "Jet Fuel OG",
      "type": "Hybrid",
      "thc": 27.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.18,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.73,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "VA"
    },
    {
      "id": "VA-135",
      "strain": "Sherbanger",
      "type": "Hybrid",
      "thc": 26.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.23,
        "Humulene": 0.35,
        "Limonene": 0.84,
        "Ocimene": 0.03,
        "Linalool": 0.3,
        "Myrcene": 0.83,
        "Terpinolene": 0,
        "Bisabolol": 0.13,
        "Pinene": 0.16,
        "b-Pinene": 0.16
      },
      "state": "VA"
    },
    {
      "id": "VA-109",
      "strain": "LA Kush Cake",
      "type": "Indica",
      "thc": 26.56,
      "cbd": 0.1,
      "lineage": "Kush Mints x Wedding Cake",
      "terpenes": {
        "Caryophyllene": 0.8,
        "Humulene": 0.26,
        "Limonene": 0.46,
        "Ocimene": 0.01,
        "Linalool": 0.19,
        "Myrcene": 0.33,
        "Terpinolene": 0.05,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.1
      },
      "state": "VA"
    },
    {
      "id": "VA-137",
      "strain": "Tropical Banana",
      "type": "Sativa",
      "thc": 26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.75,
        "Humulene": 0.22,
        "Limonene": 0.31,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.76,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "VA"
    },
    {
      "id": "VA-106",
      "strain": "Animal Face 19",
      "type": "Indica",
      "thc": 25.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.88,
        "Humulene": 0.28,
        "Limonene": 0.62,
        "Ocimene": 0,
        "Linalool": 0.4,
        "Myrcene": 0.97,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.04,
        "b-Pinene": 0.09
      },
      "state": "VA"
    },
    {
      "id": "VA-111",
      "strain": "White Durban",
      "type": "Sativa",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.32,
        "Humulene": 0.09,
        "Limonene": 0.28,
        "Ocimene": 0.23,
        "Linalool": 0.05,
        "Myrcene": 0.6,
        "Terpinolene": 0.69,
        "Bisabolol": 0,
        "Pinene": 0.12,
        "b-Pinene": 0.18
      },
      "state": "VA"
    },
    {
      "id": "VA-101",
      "strain": "Black Maple",
      "type": "Indica",
      "thc": 25.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.75,
        "Humulene": 0.22,
        "Limonene": 0.78,
        "Ocimene": 0.01,
        "Linalool": 0.25,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.29,
        "b-Pinene": 0.2
      },
      "state": "VA"
    },
    {
      "id": "VA-102",
      "strain": "Black Maple 2",
      "type": "Hybrid",
      "thc": 25.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.75,
        "Humulene": 0.22,
        "Limonene": 0.78,
        "Ocimene": 0.01,
        "Linalool": 0.25,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.29,
        "b-Pinene": 0.2
      },
      "state": "VA"
    },
    {
      "id": "VA-117",
      "strain": "Purple Starfruit",
      "type": "Indica",
      "thc": 24.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.11,
        "Humulene": 0.05,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.31,
        "Myrcene": 0.24,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "VA"
    },
    {
      "id": "VA-131",
      "strain": "Lemon Fresh",
      "type": "Sativa",
      "thc": 24.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.08,
        "Limonene": 0.16,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.61,
        "Terpinolene": 1.26,
        "Bisabolol": 0.03,
        "Pinene": 0.05,
        "b-Pinene": 0.11
      },
      "state": "VA"
    },
    {
      "id": "VA-104",
      "strain": "Creamsicle Sunset",
      "type": "Hybrid",
      "thc": 24.67,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.45,
        "Humulene": 0.17,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.33,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-105",
      "strain": "Hybrid",
      "type": "Hybrid",
      "thc": 24.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.18,
        "Limonene": 0.51,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 1.59,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-112",
      "strain": "Baklava (I",
      "type": "Hybrid",
      "thc": 24.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.09,
        "Limonene": 0.32,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.51,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "VA"
    },
    {
      "id": "VA-126",
      "strain": "Space Mints",
      "type": "Hybrid",
      "thc": 24.23,
      "cbd": 0.1,
      "lineage": "Wedding Cake & Kush Mints",
      "terpenes": {
        "Caryophyllene": 0.57,
        "Humulene": 0.17,
        "Limonene": 0.51,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 1.23,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-128",
      "strain": "Fall 97",
      "type": "Hybrid",
      "thc": 23.41,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.98,
        "Humulene": 0.31,
        "Limonene": 0.65,
        "Ocimene": 0.02,
        "Linalool": 0.23,
        "Myrcene": 0.18,
        "Terpinolene": 0.06,
        "Bisabolol": 0.17,
        "Pinene": 0.03,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-100",
      "strain": "Banana Cream 13",
      "type": "Indica",
      "thc": 22.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.11,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.32,
        "Myrcene": 0.46,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-116",
      "strain": "Donnie Burger",
      "type": "Hybrid",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.16,
        "Limonene": 0.55,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 1.14,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-121",
      "strain": "Velvet Berry Kush",
      "type": "Indica",
      "thc": 22.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.52,
        "Humulene": 0.15,
        "Limonene": 0.4,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.42,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-108",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 22.41,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.2,
        "Limonene": 0.55,
        "Ocimene": 0,
        "Linalool": 0.34,
        "Myrcene": 0.62,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "VA"
    },
    {
      "id": "VA-124",
      "strain": "Guerilla Grape",
      "type": "Indica",
      "thc": 22.26,
      "cbd": 0.1,
      "lineage": "Original Glue & Vino OG",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.19,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.74,
        "Terpinolene": 0,
        "Bisabolol": 0.1,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-103",
      "strain": "Chicken n' Wafflez",
      "type": "Sativa",
      "thc": 22.15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.16,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.23,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "VA"
    },
    {
      "id": "VA-113",
      "strain": "Black Triangle II",
      "type": "Hybrid",
      "thc": 22.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.28,
        "Humulene": 0.07,
        "Limonene": 0.4,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 1.26,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-125",
      "strain": "La Sage",
      "type": "Hybrid",
      "thc": 22.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.08,
        "Limonene": 0.1,
        "Ocimene": 0.11,
        "Linalool": 0.03,
        "Myrcene": 0.17,
        "Terpinolene": 0.55,
        "Bisabolol": 0,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "VA"
    },
    {
      "id": "VA-120",
      "strain": "Southside Skunk",
      "type": "Hybrid",
      "thc": 21.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.11,
        "Limonene": 0.32,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.46,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "VA"
    },
    {
      "id": "VA-118",
      "strain": "Cookies N' Cream",
      "type": "Hybrid",
      "thc": 21.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.48,
        "Humulene": 0.11,
        "Limonene": 0.37,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.31,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.1,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-127",
      "strain": "DNA Cake",
      "type": "Hybrid",
      "thc": 21.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.07,
        "Limonene": 0.66,
        "Ocimene": 0,
        "Linalool": 0.34,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "VA"
    },
    {
      "id": "VA-119",
      "strain": "MAC Whip",
      "type": "Hybrid",
      "thc": 21.58,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.13,
        "Limonene": 0.35,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 0.55,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.1,
        "b-Pinene": 0.09
      },
      "state": "VA"
    },
    {
      "id": "VA-123",
      "strain": "Guava Cooler",
      "type": "Hybrid",
      "thc": 21.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.2,
        "Humulene": 0.05,
        "Limonene": 0.49,
        "Ocimene": 0.06,
        "Linalool": 0.2,
        "Myrcene": 0.8,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "VA"
    },
    {
      "id": "VA-136",
      "strain": "Spritzer",
      "type": "Hybrid",
      "thc": 20.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.09,
        "Limonene": 0.58,
        "Ocimene": 0.06,
        "Linalool": 0.04,
        "Myrcene": 0.37,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.17,
        "b-Pinene": 0.13
      },
      "state": "VA"
    },
    {
      "id": "VA-134",
      "strain": "RS11",
      "type": "Hybrid",
      "thc": 20.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.1,
        "Limonene": 0.35,
        "Ocimene": 0.04,
        "Linalool": 0.05,
        "Myrcene": 0.2,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.06,
        "b-Pinene": 0.06
      },
      "state": "VA"
    },
    {
      "id": "VA-122",
      "strain": "B52 Bomber",
      "type": "Sativa",
      "thc": 20.07,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.09,
        "Limonene": 0.06,
        "Ocimene": 0.09,
        "Linalool": 0.07,
        "Myrcene": 0.76,
        "Terpinolene": 0.36,
        "Bisabolol": 0.07,
        "Pinene": 0.08,
        "b-Pinene": 0.07
      },
      "state": "VA"
    },
    {
      "id": "VA-132",
      "strain": "Miss DNA",
      "type": "Hybrid",
      "thc": 17.61,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.18,
        "Humulene": 0.04,
        "Limonene": 0.52,
        "Ocimene": 0.03,
        "Linalool": 0,
        "Myrcene": 0.82,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.08,
        "b-Pinene": 0.09
      },
      "state": "VA"
    }
  ],
RI: [
    {
      "id": "RI-202",
      "strain": "Gelato Cake",
      "type": "Hybrid",
      "thc": 31.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-175",
      "strain": "Candy Fumez",
      "type": "Hybrid",
      "thc": 31.43,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-198",
      "strain": "Peanut Butter Breath",
      "type": "Hybrid",
      "thc": 31.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-104",
      "strain": "GMO ",
      "type": "Indica",
      "thc": 31.1,
      "cbd": 0.1,
      "lineage": "GSC x Chemdawg",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-176",
      "strain": "CHERRYLICIOUS I",
      "type": "Hybrid",
      "thc": 31.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-192",
      "strain": "Triple Burger",
      "type": "Hybrid",
      "thc": 31,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-166",
      "strain": "Hashburger H",
      "type": "Hybrid",
      "thc": 30.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-236",
      "strain": "Caked Up",
      "type": "Indica",
      "thc": 30.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-172",
      "strain": "BLUETHOUSAND9",
      "type": "Hybrid",
      "thc": 30.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-160",
      "strain": "Ole Bliss",
      "type": "Indica",
      "thc": 29.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-237",
      "strain": "Miss Bliss",
      "type": "Hybrid",
      "thc": 29.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-212",
      "strain": "SOUR SORBET",
      "type": "Hybrid",
      "thc": 29.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-213",
      "strain": "Garlic Monstah",
      "type": "Indica",
      "thc": 29.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-174",
      "strain": "Candied Garlic",
      "type": "Hybrid",
      "thc": 29.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-125",
      "strain": "Crescendo",
      "type": "Sativa",
      "thc": 29.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-203",
      "strain": "ZEBRA ZTRIPEZ",
      "type": "Hybrid",
      "thc": 29.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-211",
      "strain": "Sherb Cream Pie",
      "type": "Hybrid",
      "thc": 29.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-161",
      "strain": "Rainbow Runtz",
      "type": "Hybrid",
      "thc": 29,
      "cbd": 0.1,
      "lineage": "ZKZ X Dosidos",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-235",
      "strain": "Buttered Apple",
      "type": "Indica",
      "thc": 28.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-208",
      "strain": "ARCTIC MINTS",
      "type": "Hybrid",
      "thc": 28.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-105",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 28.5,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-178",
      "strain": "Trash Panda",
      "type": "Hybrid",
      "thc": 28.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-204",
      "strain": "Mimosa Cake H",
      "type": "Hybrid",
      "thc": 28.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-159",
      "strain": "Cali Zmoothie",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-233",
      "strain": "The Soap H",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-109",
      "strain": "Paradise Snacks",
      "type": "Indica",
      "thc": 28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-153",
      "strain": "Sugar Mintz ",
      "type": "Hybrid",
      "thc": 28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-234",
      "strain": "Blueberry Muffins",
      "type": "Indica",
      "thc": 28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-210",
      "strain": "HAN SOLO ",
      "type": "Indica",
      "thc": 27.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-162",
      "strain": "Deez Cookies",
      "type": "Hybrid",
      "thc": 27.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-177",
      "strain": "PEACH RINGZ",
      "type": "Hybrid",
      "thc": 27.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-216",
      "strain": "Super Lemon Cherry Gelato",
      "type": "Indica",
      "thc": 27.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-158",
      "strain": "Zombie Death",
      "type": "Sativa",
      "thc": 27.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-190",
      "strain": "Zombie Death",
      "type": "Sativa",
      "thc": 27.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-245",
      "strain": "Joker Candy H",
      "type": "Hybrid",
      "thc": 27.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-173",
      "strain": "Blueberry Breath",
      "type": "Hybrid",
      "thc": 27.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-225",
      "strain": "Apple Mints ",
      "type": "Hybrid",
      "thc": 27.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-182",
      "strain": "RICKY'S BROTHERS KUSH",
      "type": "Indica",
      "thc": 27.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-132",
      "strain": "Gaspee Point Gas",
      "type": "Hybrid",
      "thc": 27.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-143",
      "strain": "R.R #17",
      "type": "Hybrid",
      "thc": 27.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-242",
      "strain": "Haymaker Haze",
      "type": "Sativa",
      "thc": 27.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-170",
      "strain": "Jungle Funk",
      "type": "Hybrid",
      "thc": 26.93,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-189",
      "strain": "Skywalker Kush OG",
      "type": "Indica",
      "thc": 26.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-241",
      "strain": "Heady Tropper",
      "type": "Sativa",
      "thc": 26.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-229",
      "strain": "Yellow Tail",
      "type": "Hybrid",
      "thc": 26.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-218",
      "strain": "Solomon Grundy",
      "type": "Hybrid",
      "thc": 26.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-238",
      "strain": "Watermelon Gusherz",
      "type": "Hybrid",
      "thc": 26.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-222",
      "strain": "Amalfi Coast ",
      "type": "Indica",
      "thc": 26.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-148",
      "strain": "Royal Runtz H",
      "type": "Hybrid",
      "thc": 26.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-231",
      "strain": "Don Mega",
      "type": "Hybrid",
      "thc": 26.38,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-185",
      "strain": "Cherry On Top",
      "type": "Indica",
      "thc": 26.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-113",
      "strain": "Animal Face",
      "type": "Indica",
      "thc": 26.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-209",
      "strain": "GRAPE GAS ",
      "type": "Hybrid",
      "thc": 26.16,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-128",
      "strain": "End Game",
      "type": "Hybrid",
      "thc": 26.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-205",
      "strain": "Northern Lights",
      "type": "Hybrid",
      "thc": 26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-121",
      "strain": "Carbon Fiber",
      "type": "Hybrid",
      "thc": 25.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-186",
      "strain": "Wedding Pie",
      "type": "Hybrid",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-240",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-215",
      "strain": "Strawberry Banana ",
      "type": "Sativa",
      "thc": 25.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-232",
      "strain": "Apple Mac H",
      "type": "Hybrid",
      "thc": 25.66,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-127",
      "strain": "Dosido ",
      "type": "Indica",
      "thc": 25.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-137",
      "strain": "Larry's Lemons",
      "type": "Hybrid",
      "thc": 25.63,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-102",
      "strain": "Creamsicle Sunset",
      "type": "Hybrid",
      "thc": 25.6,
      "cbd": 0.1,
      "lineage": "Ethos Cookies x Mandarin Sunset",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-157",
      "strain": "White Wedding",
      "type": "Indica",
      "thc": 25.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-101",
      "strain": "Chem Cookies",
      "type": "Hybrid",
      "thc": 25.5,
      "cbd": 0.1,
      "lineage": "Chem Dawg I95 x GSC",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-120",
      "strain": "Brownie Scout",
      "type": "Indica",
      "thc": 25.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-147",
      "strain": "Reign Man",
      "type": "Hybrid",
      "thc": 25.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-131",
      "strain": "Fruity Pebbles OG",
      "type": "Hybrid",
      "thc": 25.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-165",
      "strain": "Biscotti Pancake",
      "type": "Hybrid",
      "thc": 25.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-134",
      "strain": "Grapefruit Chem",
      "type": "Hybrid",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-197",
      "strain": "Grape Cream Cake",
      "type": "Indica",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-207",
      "strain": "Chocolate Oranges ",
      "type": "Hybrid",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-133",
      "strain": "GMO ",
      "type": "Indica",
      "thc": 25.14,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-193",
      "strain": "Chemberrly 1",
      "type": "Hybrid",
      "thc": 25.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-141",
      "strain": "OMG",
      "type": "Hybrid",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-196",
      "strain": "Gorilla Candy 9",
      "type": "Indica",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-164",
      "strain": "Super Sour",
      "type": "Sativa",
      "thc": 24.97,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-138",
      "strain": "Ocean Boats",
      "type": "Hybrid",
      "thc": 24.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-163",
      "strain": "R.R #17",
      "type": "Hybrid",
      "thc": 24.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-184",
      "strain": "Apples & Bananas",
      "type": "Hybrid",
      "thc": 24.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-124",
      "strain": "Oreo OG",
      "type": "Hybrid",
      "thc": 24.77,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-206",
      "strain": "Pink Lemonade",
      "type": "Hybrid",
      "thc": 24.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-122",
      "strain": "Chicken n' Wafflez",
      "type": "Sativa",
      "thc": 24.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-167",
      "strain": "S.A.G.E.",
      "type": "Sativa",
      "thc": 24.54,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-224",
      "strain": "Sonic Strawberry",
      "type": "Sativa",
      "thc": 24.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-135",
      "strain": "Han Solo Burger I",
      "type": "Indica",
      "thc": 24.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-219",
      "strain": "Sundae Brunch",
      "type": "Hybrid",
      "thc": 24.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-114",
      "strain": "Apple Fritters",
      "type": "Hybrid",
      "thc": 24.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-187",
      "strain": "Dark Ghost Train H",
      "type": "Hybrid",
      "thc": 24.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-118",
      "strain": "Biker Kush",
      "type": "Indica",
      "thc": 24.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-223",
      "strain": "Car Wreck",
      "type": "Hybrid",
      "thc": 24.17,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-139",
      "strain": "Ocean Royale",
      "type": "Hybrid",
      "thc": 24.11,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-107",
      "strain": "Jack's Delight",
      "type": "Sativa",
      "thc": 24.1,
      "cbd": 0.1,
      "lineage": "Jack Herer x (AD4 x Point Break",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-239",
      "strain": "Galactic Warheads",
      "type": "Sativa",
      "thc": 24.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-112",
      "strain": "AK Skunk",
      "type": "Hybrid",
      "thc": 24.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-154",
      "strain": "Sweetie Pie",
      "type": "Hybrid",
      "thc": 24.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-100",
      "strain": "Cereal Milk",
      "type": "Hybrid",
      "thc": 24,
      "cbd": 0.1,
      "lineage": "Strawberry Lemonade x Thicc Mint Cookies",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-195",
      "strain": "Garlic Knots 3",
      "type": "Indica",
      "thc": 23.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-183",
      "strain": "STRAWBERRY GAS",
      "type": "Hybrid",
      "thc": 23.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-227",
      "strain": "Pie Hoe",
      "type": "Hybrid",
      "thc": 23.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-103",
      "strain": "DULCE DE UVA",
      "type": "Indica",
      "thc": 23.3,
      "cbd": 0.1,
      "lineage": "Ice Cream Cake x (Grape Pie x Wedding Crasher",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-117",
      "strain": "Baby Yoda",
      "type": "Hybrid",
      "thc": 23.26,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-169",
      "strain": "Dirty Mack",
      "type": "Hybrid",
      "thc": 23.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-181",
      "strain": "Northern Lights",
      "type": "Sativa",
      "thc": 23.19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-111",
      "strain": "95 Cookies",
      "type": "Hybrid",
      "thc": 23.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-155",
      "strain": "VelcroZ",
      "type": "Hybrid",
      "thc": 23.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-116",
      "strain": "Atreyu",
      "type": "Hybrid",
      "thc": 23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-226",
      "strain": "Blue Zushi",
      "type": "Hybrid",
      "thc": 22.88,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-136",
      "strain": "Kali Mist",
      "type": "Sativa",
      "thc": 22.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-110",
      "strain": "VelcroZ",
      "type": "Hybrid",
      "thc": 22.8,
      "cbd": 0.1,
      "lineage": "Blue Flame OG x Blue Zushi",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-145",
      "strain": "Rainbow Pie",
      "type": "Sativa",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-201",
      "strain": "Tahitian Treat 2 ",
      "type": "Hybrid",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-144",
      "strain": "Rainbow Guavaz",
      "type": "Indica",
      "thc": 22.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-156",
      "strain": "Watermelon Gushers",
      "type": "Indica",
      "thc": 22.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-152",
      "strain": "Smurf Juice",
      "type": "Hybrid",
      "thc": 22.44,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-220",
      "strain": "The Undercaker",
      "type": "Hybrid",
      "thc": 22.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-244",
      "strain": "DEADHEAD GORILLA H",
      "type": "Hybrid",
      "thc": 22.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-126",
      "strain": "Dawg Face",
      "type": "Hybrid",
      "thc": 21.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-191",
      "strain": "Dante's Inferno I",
      "type": "Hybrid",
      "thc": 21.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-228",
      "strain": "Runtz ",
      "type": "Hybrid",
      "thc": 21.75,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-151",
      "strain": "Skunksterdam OG",
      "type": "Hybrid",
      "thc": 21.51,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-188",
      "strain": "DNA Cake",
      "type": "Indica",
      "thc": 21.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-217",
      "strain": "Chem 51",
      "type": "Hybrid",
      "thc": 21.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-214",
      "strain": "Northern Lights S",
      "type": "Sativa",
      "thc": 21.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-115",
      "strain": "Apples and Bananas",
      "type": "Hybrid",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-199",
      "strain": "Platinum Truffles 1",
      "type": "Indica",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-221",
      "strain": "Coffee Creamer",
      "type": "Hybrid",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-179",
      "strain": "Acapulco Gold H",
      "type": "Sativa",
      "thc": 21.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-243",
      "strain": "Bruce Banner",
      "type": "Sativa",
      "thc": 21.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-106",
      "strain": "Grape Bubblegum",
      "type": "Hybrid",
      "thc": 21.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-146",
      "strain": "Red Candy Apple",
      "type": "Sativa",
      "thc": 21.04,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-180",
      "strain": "Glitter Bomb ",
      "type": "Hybrid",
      "thc": 20.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-168",
      "strain": "S.C. Blue Dream",
      "type": "Hybrid",
      "thc": 20.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-171",
      "strain": "Sour Apple",
      "type": "Hybrid",
      "thc": 20.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-194",
      "strain": "Funkdafied 4",
      "type": "Hybrid",
      "thc": 20.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-140",
      "strain": "OGKB V2",
      "type": "Hybrid",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-200",
      "strain": "Player Cake 5 I",
      "type": "Indica",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-108",
      "strain": "Lemon Fresh",
      "type": "Sativa",
      "thc": 19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-130",
      "strain": "Frosted Flakes",
      "type": "Indica",
      "thc": 18.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-129",
      "strain": "FC Cook",
      "type": "Hybrid",
      "thc": 17.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-150",
      "strain": "Sherbcake",
      "type": "Indica",
      "thc": 17.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-119",
      "strain": "Black Maple #22",
      "type": "Hybrid",
      "thc": 17.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-149",
      "strain": "Scotty2Hottie",
      "type": "Indica",
      "thc": 17.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-142",
      "strain": "Pink Zugar",
      "type": "Indica",
      "thc": 16.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-123",
      "strain": "Chimera I",
      "type": "Indica",
      "thc": 15,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    },
    {
      "id": "RI-230",
      "strain": "Cake Berry Brulee",
      "type": "Cbd",
      "thc": 0,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "RI"
    }
  ],
  OH: [
    {
      "id": "OH-129",
      "strain": "Sour Larry Cross",
      "type": "Hybrid",
      "thc": 31.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.63,
        "Humulene": 0.2,
        "Limonene": 0.78,
        "Ocimene": 0,
        "Linalool": 0.59,
        "Myrcene": 0.24,
        "Terpinolene": 0,
        "Bisabolol": 0.1,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-183",
      "strain": "Mac Stomper",
      "type": "Hybrid",
      "thc": 30.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.58,
        "Humulene": 0.17,
        "Limonene": 1.02,
        "Ocimene": 0,
        "Linalool": 0.27,
        "Myrcene": 0.05,
        "Terpinolene": 0,
        "Bisabolol": 0.1,
        "Pinene": 0.18,
        "b-Pinene": 0.22
      },
      "state": "OH"
    },
    {
      "id": "OH-162",
      "strain": "Gush Mints (I",
      "type": "Indica",
      "thc": 29.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.01,
        "Humulene": 0.34,
        "Limonene": 0.64,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.02,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-124",
      "strain": "Garlic Breath 2.0",
      "type": "Indica",
      "thc": 29.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.55,
        "Humulene": 0.22,
        "Limonene": 0.76,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.26,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.12,
        "b-Pinene": 0.15
      },
      "state": "OH"
    },
    {
      "id": "OH-125",
      "strain": "Hella Hz",
      "type": "Hybrid",
      "thc": 28.83,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.46,
        "Humulene": 0.13,
        "Limonene": 0.04,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 1.95,
        "Terpinolene": 0,
        "Bisabolol": 0.13,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-148",
      "strain": "Spirit Soda",
      "type": "Hybrid",
      "thc": 28.55,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.1,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 1.54,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-173",
      "strain": "Rebel Cookies",
      "type": "Indica",
      "thc": 28.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.67,
        "Humulene": 0.32,
        "Limonene": 0.61,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 0.52,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-122",
      "strain": "Area 43",
      "type": "Sativa",
      "thc": 27.86,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.23,
        "Humulene": 0.09,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.4,
        "Myrcene": 0.74,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.1,
        "b-Pinene": 0.14
      },
      "state": "OH"
    },
    {
      "id": "OH-116",
      "strain": "Tamarindo",
      "type": "Hybrid",
      "thc": 27.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.11,
        "Limonene": 0.38,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 0.9,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-159",
      "strain": "Kushlato",
      "type": "Indica",
      "thc": 27.64,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.58,
        "Humulene": 0.18,
        "Limonene": 0.61,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.6,
        "Terpinolene": 0,
        "Bisabolol": 0.13,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-164",
      "strain": "RS11",
      "type": "Hybrid",
      "thc": 27.52,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.12,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.41,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.06,
        "b-Pinene": 0.11
      },
      "state": "OH"
    },
    {
      "id": "OH-160",
      "strain": "Redbird",
      "type": "Hybrid",
      "thc": 27.39,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.12,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.21,
        "Myrcene": 0.17,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-163",
      "strain": "Hippie Crasher (I",
      "type": "Indica",
      "thc": 27.09,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.12,
        "Limonene": 1.07,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.05,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.15,
        "b-Pinene": 0.19
      },
      "state": "OH"
    },
    {
      "id": "OH-182",
      "strain": "Goofiez 4",
      "type": "Hybrid",
      "thc": 27.09,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.65,
        "Humulene": 0.15,
        "Limonene": 0.31,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.42,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-161",
      "strain": "Sing Sling",
      "type": "Sativa",
      "thc": 26.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.48,
        "Humulene": 0.14,
        "Limonene": 0.32,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 0.75,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.03,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-157",
      "strain": "Strawberry Guava (S",
      "type": "Sativa",
      "thc": 26.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.35,
        "Humulene": 0.1,
        "Limonene": 0.66,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 1.28,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-142",
      "strain": "Mad Timewreck",
      "type": "Hybrid",
      "thc": 26.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.09,
        "Humulene": 0.02,
        "Limonene": 0.08,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.58,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.25,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-156",
      "strain": "Orange 43",
      "type": "Hybrid",
      "thc": 26.33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0,
        "Limonene": 0.22,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.58,
        "Terpinolene": 0.83,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-137",
      "strain": "Nuclear Muffin",
      "type": "Hybrid",
      "thc": 26.13,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.11,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.46,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-140",
      "strain": "Crescendo",
      "type": "Hybrid",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.17,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 1.05,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.01,
        "b-Pinene": 0.02
      },
      "state": "OH"
    },
    {
      "id": "OH-171",
      "strain": "Double OG Chem",
      "type": "Indica",
      "thc": 25.81,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.11,
        "Limonene": 0.69,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 1.01,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.06,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-117",
      "strain": "Caddie Rainbowz",
      "type": "Hybrid",
      "thc": 25.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.1,
        "Limonene": 0.2,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.26,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-166",
      "strain": "Disco Diesel",
      "type": "Sativa",
      "thc": 25.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.11,
        "Limonene": 0.5,
        "Ocimene": 0,
        "Linalool": 0.25,
        "Myrcene": 0.22,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-174",
      "strain": "Hippy Tearz",
      "type": "Hybrid",
      "thc": 25.27,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.67,
        "Humulene": 0.19,
        "Limonene": 0.17,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 1.03,
        "Terpinolene": 0,
        "Bisabolol": 0.12,
        "Pinene": 0.11,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-184",
      "strain": "Pink Burst",
      "type": "Indica",
      "thc": 25.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.17,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.38,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-136",
      "strain": "Banana Foster",
      "type": "Sativa",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.13,
        "Limonene": 0.07,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.5,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-101",
      "strain": "Banana Cream",
      "type": "Indica",
      "thc": 24.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.09,
        "Limonene": 0.55,
        "Ocimene": 0,
        "Linalool": 0.35,
        "Myrcene": 0.23,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-155",
      "strain": "Crowd Surfer",
      "type": "Hybrid",
      "thc": 24.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.08,
        "Limonene": 0.94,
        "Ocimene": 0,
        "Linalool": 0.66,
        "Myrcene": 0.38,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-132",
      "strain": "Forum GSC",
      "type": "Indica",
      "thc": 24.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.13,
        "Humulene": 0.45,
        "Limonene": 0.67,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.45,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.13,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-158",
      "strain": "Blue Beach Haze",
      "type": "Sativa",
      "thc": 24.65,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.08,
        "Limonene": 0.04,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.46,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0,
        "b-Pinene": 0.01
      },
      "state": "OH"
    },
    {
      "id": "OH-181",
      "strain": "Chem OG (I",
      "type": "Indica",
      "thc": 24.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.21,
        "Limonene": 0.28,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.83,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "OH"
    },
    {
      "id": "OH-145",
      "strain": "Mosa Kush Mints",
      "type": "Hybrid",
      "thc": 24.57,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.23,
        "Humulene": 0.07,
        "Limonene": 0.67,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.55,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-144",
      "strain": "Funny Bone",
      "type": "Hybrid",
      "thc": 24.05,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.04,
        "Humulene": 0.01,
        "Limonene": 0.33,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.37,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.58,
        "b-Pinene": 0.15
      },
      "state": "OH"
    },
    {
      "id": "OH-114",
      "strain": "Rotten Teeth",
      "type": "Indica",
      "thc": 24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.06,
        "Limonene": 0.97,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.35,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.15,
        "b-Pinene": 0.16
      },
      "state": "OH"
    },
    {
      "id": "OH-169",
      "strain": "Melonade",
      "type": "Hybrid",
      "thc": 23.91,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0.1,
        "Limonene": 0.69,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.26,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-172",
      "strain": "Double OG Sour",
      "type": "Indica",
      "thc": 23.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.12,
        "Limonene": 0.75,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.87,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.07,
        "b-Pinene": 0.13
      },
      "state": "OH"
    },
    {
      "id": "OH-175",
      "strain": "Bubbashine (H",
      "type": "Hybrid",
      "thc": 23.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.41,
        "Humulene": 0.16,
        "Limonene": 0.23,
        "Ocimene": 0,
        "Linalool": 0.14,
        "Myrcene": 0.33,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-180",
      "strain": "Bananas Foster",
      "type": "Sativa",
      "thc": 23.68,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.13,
        "Limonene": 0.08,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.54,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-167",
      "strain": "Earthquake",
      "type": "Sativa",
      "thc": 23.48,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.53,
        "Humulene": 0.15,
        "Limonene": 0.16,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.69,
        "Terpinolene": 0,
        "Bisabolol": 0.11,
        "Pinene": 0.01,
        "b-Pinene": 0.02
      },
      "state": "OH"
    },
    {
      "id": "OH-146",
      "strain": "Peanut Butter Muffin",
      "type": "Sativa",
      "thc": 23.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.54,
        "Humulene": 0.2,
        "Limonene": 1.04,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.08,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.14,
        "b-Pinene": 0.17
      },
      "state": "OH"
    },
    {
      "id": "OH-112",
      "strain": "Purpentine",
      "type": "Hybrid",
      "thc": 22.89,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.52,
        "Humulene": 0.16,
        "Limonene": 0.09,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.34,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "OH"
    },
    {
      "id": "OH-150",
      "strain": "Orangealicious H",
      "type": "Indica",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.06,
        "Humulene": 0.39,
        "Limonene": 0.4,
        "Ocimene": 0,
        "Linalool": 0.3,
        "Myrcene": 0.35,
        "Terpinolene": 0,
        "Bisabolol": 0.17,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-176",
      "strain": "Lemon Cherry Saltz",
      "type": "Hybrid",
      "thc": 22.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.56,
        "Humulene": 0.15,
        "Limonene": 0.65,
        "Ocimene": 0,
        "Linalool": 0.35,
        "Myrcene": 0.04,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.08,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-119",
      "strain": "Muul Fuel",
      "type": "Indica",
      "thc": 22.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.5,
        "Humulene": 0.23,
        "Limonene": 0.68,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1.09,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.05,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-113",
      "strain": "Root Beer Cream Cake",
      "type": "Indica",
      "thc": 22.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.69,
        "Humulene": 0.2,
        "Limonene": 0.27,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 0.58,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-134",
      "strain": "Papaya Power",
      "type": "Indica",
      "thc": 22.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.08,
        "Humulene": 0.02,
        "Limonene": 0.68,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.1,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-135",
      "strain": "Guwop Green",
      "type": "Hybrid",
      "thc": 22.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.5,
        "Humulene": 0.16,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.22,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.09,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-170",
      "strain": "Wedding Cake (H",
      "type": "Hybrid",
      "thc": 22.11,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.55,
        "Humulene": 0.21,
        "Limonene": 1.11,
        "Ocimene": 0,
        "Linalool": 0.18,
        "Myrcene": 0.34,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.24,
        "b-Pinene": 0.19
      },
      "state": "OH"
    },
    {
      "id": "OH-139",
      "strain": "Clementine Punch",
      "type": "Hybrid",
      "thc": 22.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.21,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.01,
        "Myrcene": 0.08,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.17,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-111",
      "strain": "Layered Cakes",
      "type": "Indica",
      "thc": 22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.18,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.27,
        "Myrcene": 0.31,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.04,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-143",
      "strain": "Northern Lights",
      "type": "Indica",
      "thc": 22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.1,
        "Humulene": 0.03,
        "Limonene": 0.2,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 0.64,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.17,
        "b-Pinene": 0.07
      },
      "state": "OH"
    },
    {
      "id": "OH-168",
      "strain": "First Class Funk I",
      "type": "Indica",
      "thc": 22,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.53,
        "Humulene": 0.26,
        "Limonene": 0.95,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.1,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.19,
        "b-Pinene": 0.15
      },
      "state": "OH"
    },
    {
      "id": "OH-121",
      "strain": "92 Cookies",
      "type": "Sativa",
      "thc": 21.72,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0.11,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.74,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-128",
      "strain": "Rainbow X",
      "type": "Hybrid",
      "thc": 21.49,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.11,
        "Limonene": 0.48,
        "Ocimene": 0,
        "Linalool": 0.28,
        "Myrcene": 0.27,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.06,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-110",
      "strain": "Funnel Cake",
      "type": "Hybrid",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.96,
        "Humulene": 0.27,
        "Limonene": 0.45,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.06,
        "Terpinolene": 0,
        "Bisabolol": 0.1,
        "Pinene": 0.12,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-126",
      "strain": "Lemon Dosi",
      "type": "Indica",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.68,
        "Humulene": 0.24,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.3,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-177",
      "strain": "Modified Fruit",
      "type": "Hybrid",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.17,
        "Limonene": 0.59,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.58,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.12,
        "b-Pinene": 0.11
      },
      "state": "OH"
    },
    {
      "id": "OH-179",
      "strain": "Forbidden Fruitcake",
      "type": "Hybrid",
      "thc": 21.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.1,
        "Limonene": 0.49,
        "Ocimene": 0,
        "Linalool": 0.42,
        "Myrcene": 0.18,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-131",
      "strain": "Divine Inferno",
      "type": "Indica",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.1,
        "Limonene": 0.22,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.23,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "OH"
    },
    {
      "id": "OH-151",
      "strain": "Papaya Dieseltang",
      "type": "Hybrid",
      "thc": 21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.27,
        "Humulene": 0.09,
        "Limonene": 0.24,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.7,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.02,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-154",
      "strain": "Khalifa Mints",
      "type": "Hybrid",
      "thc": 21,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.07,
        "Limonene": 0.18,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-105",
      "strain": "L'Orange",
      "type": "Sativa",
      "thc": 20.95,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.29,
        "Humulene": 0.1,
        "Limonene": 0.58,
        "Ocimene": 0,
        "Linalool": 0.29,
        "Myrcene": 0.29,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-100",
      "strain": "Sour Cherry Melon",
      "type": "Indica",
      "thc": 20.92,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.26,
        "Humulene": 0.08,
        "Limonene": 0.51,
        "Ocimene": 0,
        "Linalool": 0.32,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.06,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-147",
      "strain": "Zesty Garlic Cookies",
      "type": "Indica",
      "thc": 20.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.1,
        "Humulene": 0.04,
        "Limonene": 0.6,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.31,
        "Terpinolene": 0,
        "Bisabolol": 0.01,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-127",
      "strain": "Powerplay Punch",
      "type": "Hybrid",
      "thc": 20.73,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.16,
        "Humulene": 0.06,
        "Limonene": 0.4,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.28,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-130",
      "strain": "Strawberry Rhapsody",
      "type": "Hybrid",
      "thc": 20.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.14,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.41,
        "Terpinolene": 0,
        "Bisabolol": 0.18,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "OH"
    },
    {
      "id": "OH-133",
      "strain": "Moonbow",
      "type": "Hybrid",
      "thc": 20.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.37,
        "Humulene": 0.1,
        "Limonene": 0.64,
        "Ocimene": 0,
        "Linalool": 0.37,
        "Myrcene": 0.03,
        "Terpinolene": 0,
        "Bisabolol": 0.08,
        "Pinene": 0.06,
        "b-Pinene": 0.1
      },
      "state": "OH"
    },
    {
      "id": "OH-149",
      "strain": "King Kush",
      "type": "Hybrid",
      "thc": 20.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0.1,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.11,
        "Myrcene": 0.44,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-165",
      "strain": "VC #7",
      "type": "Indica",
      "thc": 20.46,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.11,
        "Limonene": 0.09,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.57,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.01,
        "b-Pinene": 0.02
      },
      "state": "OH"
    },
    {
      "id": "OH-123",
      "strain": "Dosi",
      "type": "Indica",
      "thc": 20.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1.07,
        "Humulene": 0.3,
        "Limonene": 0.28,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.18,
        "Terpinolene": 0,
        "Bisabolol": 0.18,
        "Pinene": 0.03,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-187",
      "strain": "LA Moon Cake",
      "type": "Hybrid",
      "thc": 20.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.13,
        "Limonene": 0.18,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.02,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-152",
      "strain": "Sacred Cookies",
      "type": "Hybrid",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.62,
        "Humulene": 0.18,
        "Limonene": 0.28,
        "Ocimene": 0,
        "Linalool": 0.01,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.08,
        "b-Pinene": 0.13
      },
      "state": "OH"
    },
    {
      "id": "OH-185",
      "strain": "Black Illusion",
      "type": "Hybrid",
      "thc": 19.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.12,
        "Humulene": 0.03,
        "Limonene": 0.2,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 0.05,
        "Terpinolene": 0,
        "Bisabolol": 0.05,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-188",
      "strain": "Wedding Cake",
      "type": "Hybrid",
      "thc": 19.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.15,
        "Humulene": 0.04,
        "Limonene": 0.1,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.13,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-120",
      "strain": "Biscotti OG (I",
      "type": "Indica",
      "thc": 19.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.17,
        "Limonene": 0.41,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.09,
        "Terpinolene": 0,
        "Bisabolol": 0.07,
        "Pinene": 0.07,
        "b-Pinene": 0.08
      },
      "state": "OH"
    },
    {
      "id": "OH-141",
      "strain": "Lemon Jack",
      "type": "Sativa",
      "thc": 19.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.22,
        "Humulene": 0.06,
        "Limonene": 0.02,
        "Ocimene": 0,
        "Linalool": 0.03,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-107",
      "strain": "Permanent Marker (I",
      "type": "Indica",
      "thc": 19.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.49,
        "Humulene": 0.13,
        "Limonene": 0.66,
        "Ocimene": 0,
        "Linalool": 0.39,
        "Myrcene": 0.06,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.21,
        "b-Pinene": 0.17
      },
      "state": "OH"
    },
    {
      "id": "OH-138",
      "strain": "YD Soda",
      "type": "Hybrid",
      "thc": 19,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0.14,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.81,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.19,
        "b-Pinene": 0
      },
      "state": "OH"
    },
    {
      "id": "OH-104",
      "strain": "Honey Zanana",
      "type": "Hybrid",
      "thc": 18.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.15,
        "Humulene": 0.08,
        "Limonene": 0.33,
        "Ocimene": 0,
        "Linalool": 0.06,
        "Myrcene": 0.15,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.04,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-178",
      "strain": "NYC Vapor",
      "type": "Hybrid",
      "thc": 18.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.36,
        "Humulene": 0.09,
        "Limonene": 0.3,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.08,
        "Terpinolene": 0,
        "Bisabolol": 0.06,
        "Pinene": 0.05,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-106",
      "strain": "Mystic Mint",
      "type": "Indica",
      "thc": 18.37,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.13,
        "Humulene": 0.04,
        "Limonene": 0.94,
        "Ocimene": 0,
        "Linalool": 0.17,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.31,
        "b-Pinene": 0.22
      },
      "state": "OH"
    },
    {
      "id": "OH-102",
      "strain": "Black Afghan",
      "type": "Indica",
      "thc": 18.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.08,
        "Limonene": 0.08,
        "Ocimene": 0,
        "Linalool": 0.12,
        "Myrcene": 1.64,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.31,
        "b-Pinene": 0.09
      },
      "state": "OH"
    },
    {
      "id": "OH-103",
      "strain": "Confidential Cherries",
      "type": "Indica",
      "thc": 18.11,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.07,
        "Limonene": 0.34,
        "Ocimene": 0,
        "Linalool": 0.24,
        "Myrcene": 0.15,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "OH"
    },
    {
      "id": "OH-186",
      "strain": "LA Cookies",
      "type": "Indica",
      "thc": 17.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.16,
        "Humulene": 0.05,
        "Limonene": 0.19,
        "Ocimene": 0,
        "Linalool": 0.05,
        "Myrcene": 0.11,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.02,
        "b-Pinene": 0.04
      },
      "state": "OH"
    },
    {
      "id": "OH-108",
      "strain": "Fantasy Melonz",
      "type": "Hybrid",
      "thc": 17.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.06,
        "Limonene": 0.7,
        "Ocimene": 0,
        "Linalool": 0.03,
        "Myrcene": 0.16,
        "Terpinolene": 0,
        "Bisabolol": 0.02,
        "Pinene": 0.13,
        "b-Pinene": 0.12
      },
      "state": "OH"
    },
    {
      "id": "OH-109",
      "strain": "Gelato Punch Cookies",
      "type": "Hybrid",
      "thc": 16.76,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.53,
        "Humulene": 0.21,
        "Limonene": 0.19,
        "Ocimene": 0,
        "Linalool": 0.1,
        "Myrcene": 0.45,
        "Terpinolene": 0,
        "Bisabolol": 0.03,
        "Pinene": 0.02,
        "b-Pinene": 0.03
      },
      "state": "OH"
    },
    {
      "id": "OH-118",
      "strain": "Hash Burger",
      "type": "Indica",
      "thc": 15.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.09,
        "Humulene": 0.03,
        "Limonene": 0.05,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.21,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0.1,
        "b-Pinene": 0.05
      },
      "state": "OH"
    },
    {
      "id": "OH-153",
      "strain": "Khalifa Kush",
      "type": "Hybrid",
      "thc": 14.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.25,
        "Humulene": 0.08,
        "Limonene": 0.05,
        "Ocimene": 0,
        "Linalool": 0.09,
        "Myrcene": 0.06,
        "Terpinolene": 0,
        "Bisabolol": 0.04,
        "Pinene": 0,
        "b-Pinene": 0.01
      },
      "state": "OH"
    }
  ],
  FL: [
    {
      "id": "FL-112",
      "strain": "OMG",
      "type": "Hybrid",
      "thc": 24,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.38,
        "Humulene": 0.16,
        "Limonene": 0.04,
        "Ocimene": 0,
        "Linalool": 0.2,
        "Myrcene": 1.24,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.02,
        "b-Pinene": 0.06
      },
      "state": "FL"
    },
    {
      "id": "FL-128",
      "strain": "RNTZ CKE #2",
      "type": "Hybrid",
      "thc": 23.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 1.25,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0.02
      },
      "state": "FL"
    },
    {
      "id": "FL-122",
      "strain": "CRMSCL SUNSET",
      "type": "Hybrid",
      "thc": 23.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.51,
        "Humulene": 0.19,
        "Limonene": 0.57,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.22,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-108",
      "strain": "Black Afghan",
      "type": "Indica",
      "thc": 23.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.16,
        "Limonene": 0,
        "Ocimene": 0.35,
        "Linalool": 0.2,
        "Myrcene": 1.6,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.34,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-109",
      "strain": "Durban Z",
      "type": "Sativa",
      "thc": 23.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0.05,
        "Limonene": 0.17,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.35,
        "Terpinolene": 1.59,
        "Bisabolol": 0,
        "Pinene": 0.07,
        "b-Pinene": 0.11
      },
      "state": "FL"
    },
    {
      "id": "FL-116",
      "strain": "THaze",
      "type": "Sativa",
      "thc": 21.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.82,
        "Humulene": 0.23,
        "Limonene": 0.39,
        "Ocimene": 0,
        "Linalool": 0.31,
        "Myrcene": 0.29,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "FL"
    },
    {
      "id": "FL-110",
      "strain": "Headcracker",
      "type": "Indica",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.36,
        "Humulene": 0,
        "Limonene": 0.96,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0.32,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-119",
      "strain": "White Durban",
      "type": "Sativa",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.17,
        "Humulene": 0.06,
        "Limonene": 0.25,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.36,
        "Terpinolene": 1.65,
        "Bisabolol": 0,
        "Pinene": 0.08,
        "b-Pinene": 0.14
      },
      "state": "FL"
    },
    {
      "id": "FL-126",
      "strain": "SoFlo Kerosene",
      "type": "Indica",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.07,
        "Limonene": 0.38,
        "Ocimene": 0,
        "Linalool": 0.07,
        "Myrcene": 0.09,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.07
      },
      "state": "FL"
    },
    {
      "id": "FL-111",
      "strain": "L'RANGE",
      "type": "Sativa",
      "thc": 20.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.43,
        "Humulene": 0.14,
        "Limonene": 0.43,
        "Ocimene": 0,
        "Linalool": 0.37,
        "Myrcene": 0.27,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "FL"
    },
    {
      "id": "FL-115",
      "strain": "Soul Mate",
      "type": "Hybrid",
      "thc": 20.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.55,
        "Humulene": 0.21,
        "Limonene": 1.1,
        "Ocimene": 0,
        "Linalool": 0.08,
        "Myrcene": 0.53,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.18,
        "b-Pinene": 0.19
      },
      "state": "FL"
    },
    {
      "id": "FL-114",
      "strain": "RGNA GRGE",
      "type": "Hybrid",
      "thc": 20.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.4,
        "Humulene": 0.13,
        "Limonene": 0.47,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.24,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.08
      },
      "state": "FL"
    },
    {
      "id": "FL-106",
      "strain": "STRWBRRES N CRM",
      "type": "Hybrid",
      "thc": 20.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0.09,
        "Limonene": 0.63,
        "Ocimene": 0.26,
        "Linalool": 0.07,
        "Myrcene": 0.14,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-101",
      "strain": "GMMY BRS",
      "type": "Sativa",
      "thc": 20.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.08,
        "Limonene": 0.11,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.37,
        "Terpinolene": 0.76,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.09
      },
      "state": "FL"
    },
    {
      "id": "FL-100",
      "strain": "GLDN SHWR",
      "type": "Sativa",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.34,
        "Humulene": 0.1,
        "Limonene": 0.68,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.05,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.14,
        "b-Pinene": 0.13
      },
      "state": "FL"
    },
    {
      "id": "FL-102",
      "strain": "Point Break",
      "type": "Sativa",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.81,
        "Humulene": 0,
        "Limonene": 0.55,
        "Ocimene": 0,
        "Linalool": 0.54,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.21,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-117",
      "strain": "TNG",
      "type": "Sativa",
      "thc": 20,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.13,
        "Limonene": 0.93,
        "Ocimene": 0,
        "Linalool": 0.26,
        "Myrcene": 0.09,
        "Terpinolene": 0.03,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.15
      },
      "state": "FL"
    },
    {
      "id": "FL-121",
      "strain": "CRL MLK",
      "type": "Hybrid",
      "thc": 19.8,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0.24,
        "Limonene": 0.42,
        "Ocimene": 0,
        "Linalool": 0.37,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.13,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-103",
      "strain": "RDNCK MNTZ",
      "type": "Indica",
      "thc": 19.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.19,
        "Humulene": 0.06,
        "Limonene": 0.13,
        "Ocimene": 0,
        "Linalool": 0.15,
        "Myrcene": 0.65,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.1,
        "b-Pinene": 0.07
      },
      "state": "FL"
    },
    {
      "id": "FL-125",
      "strain": "PRMNT MRKR",
      "type": "Indica",
      "thc": 19.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.87,
        "Humulene": 0.21,
        "Limonene": 1.03,
        "Ocimene": 0.18,
        "Linalool": 0.6,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0.09,
        "Pinene": 0.23,
        "b-Pinene": 0.2
      },
      "state": "FL"
    },
    {
      "id": "FL-120",
      "strain": "BLU ZSHIMI",
      "type": "Hybrid",
      "thc": 19.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.42,
        "Humulene": 0.11,
        "Limonene": 0.97,
        "Ocimene": 0,
        "Linalool": 0.69,
        "Myrcene": 0.3,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.05,
        "b-Pinene": 0.11
      },
      "state": "FL"
    },
    {
      "id": "FL-107",
      "strain": "SGR BBY",
      "type": "Hybrid",
      "thc": 19.1,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.45,
        "Humulene": 0.19,
        "Limonene": 0.29,
        "Ocimene": 0,
        "Linalool": 0.19,
        "Myrcene": 0.2,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.03,
        "b-Pinene": 0.06
      },
      "state": "FL"
    },
    {
      "id": "FL-105",
      "strain": "SPRY TN",
      "type": "Hybrid",
      "thc": 18.7,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.47,
        "Humulene": 0.18,
        "Limonene": 0.23,
        "Ocimene": 0,
        "Linalool": 0.13,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-104",
      "strain": "RSPBRRY TRFFL",
      "type": "Hybrid",
      "thc": 18.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.24,
        "Humulene": 0.07,
        "Limonene": 0.28,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-123",
      "strain": "East Coast Sour Diesel",
      "type": "Sativa",
      "thc": 18.6,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.39,
        "Humulene": 0.08,
        "Limonene": 0.56,
        "Ocimene": 0,
        "Linalool": 0.22,
        "Myrcene": 0.57,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0.04,
        "b-Pinene": 0.08
      },
      "state": "FL"
    },
    {
      "id": "FL-124",
      "strain": "FRZN MRGRTA",
      "type": "Sativa",
      "thc": 18.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.3,
        "Humulene": 0.09,
        "Limonene": 0.71,
        "Ocimene": 0,
        "Linalool": 0.33,
        "Myrcene": 0.39,
        "Terpinolene": 0.02,
        "Bisabolol": 0,
        "Pinene": 0.09,
        "b-Pinene": 0.13
      },
      "state": "FL"
    },
    {
      "id": "FL-127",
      "strain": "GLDN PNAPPL",
      "type": "Sativa",
      "thc": 17.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.33,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0.39,
        "Myrcene": 0.36,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-118",
      "strain": "VNLLA FRSTNG",
      "type": "Indica",
      "thc": 17.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.31,
        "Humulene": 0,
        "Limonene": 0.52,
        "Ocimene": 0,
        "Linalool": 0.23,
        "Myrcene": 0.25,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "FL"
    },
    {
      "id": "FL-113",
      "strain": "Poddy Mouth",
      "type": "Hybrid",
      "thc": 16.9,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0.21,
        "Humulene": 0.06,
        "Limonene": 0.72,
        "Ocimene": 0,
        "Linalool": 0.16,
        "Myrcene": 0.33,
        "Terpinolene": 0.01,
        "Bisabolol": 0,
        "Pinene": 0.1,
        "b-Pinene": 0.13
      },
      "state": "FL"
    }
  ],
  MI : [
    {
      "id": "MI-100",
      "strain": "Guava Gelato",
      "type": "Hybrid",
      "thc": 22.44,
      "cbd": 0.1,
      "lineage": "Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-102",
      "strain": "Critical Kush",
      "type": "Indica",
      "thc": 22.47,
      "cbd": 0.1,
      "lineage": "Critical Mass x OG Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-103",
      "strain": "Orange Wedding Cake",
      "type": "Hybrid",
      "thc": 31.5,
      "cbd": 0.1,
      "lineage": "Wedding Cake x Orange Theory",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-105",
      "strain": "Donny Burger",
      "type": "Indica",
      "thc": 17.3,
      "cbd": 0.1,
      "lineage": "GMO x Han Solo Burger",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-106",
      "strain": "Deep Space",
      "type": "Hybrid",
      "thc": 28.44,
      "cbd": 0.1,
      "lineage": "Oreoz x Zero Gravity",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-107",
      "strain": "Sunset Sherbet",
      "type": "Hybrid",
      "thc": 33.27,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Pink Panties",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-108",
      "strain": "Gassius Clay",
      "type": "Indica",
      "thc": 29.3,
      "cbd": 0.1,
      "lineage": "Gelonade x Dosidos x Illmatic",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-109",
      "strain": "Rick Jamez #3",
      "type": "Hybrid",
      "thc": 17.32,
      "cbd": 0.1,
      "lineage": "Runtz x Jealousy",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-110",
      "strain": "Sour Garlic Cookies",
      "type": "Hybrid",
      "thc": 26.9,
      "cbd": 0.1,
      "lineage": "Sour Diesel x Garlic Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-113",
      "strain": "Super Boof",
      "type": "Sativa",
      "thc": 26.1,
      "cbd": 0.1,
      "lineage": "Black Cherry Punch x Tropicana Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-114",
      "strain": "Plasma Punch",
      "type": "Indica",
      "thc": 33,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-115",
      "strain": "Gelonade",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Lemon Tree x Gelato #41",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-116",
      "strain": "Blue Runtz Snow Caps",
      "type": "Hybrid",
      "thc": 56.4,
      "cbd": 0.1,
      "lineage": "Runtz x Snowcap",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-117",
      "strain": "Baha Blast",
      "type": "Hybrid",
      "thc": 26.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-118",
      "strain": "Lemon Fumez",
      "type": "Hybrid",
      "thc": 31.03,
      "cbd": 0.1,
      "lineage": "Lemon Berry x Sherb Cream Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-119",
      "strain": "Gator Breath",
      "type": "Hybrid",
      "thc": 31.35,
      "cbd": 0.1,
      "lineage": "Motorbreath x Triangle Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-120",
      "strain": "Detroit Muscle",
      "type": "Hybrid",
      "thc": 28.14,
      "cbd": 0.1,
      "lineage": "GMO x Eastside OG",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-121",
      "strain": "Super Star Fruit",
      "type": "Hybrid",
      "thc": 24.48,
      "cbd": 0.1,
      "lineage": "Starfire Chem x Early Orange",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-122",
      "strain": "Kush Mints",
      "type": "Hybrid",
      "thc": 33,
      "cbd": 0.1,
      "lineage": "Bubba Kush x Animal Mints",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-123",
      "strain": "Kaiju #6",
      "type": "Hybrid",
      "thc": 25.63,
      "cbd": 0.1,
      "lineage": "Chemdog x SFV OG x Gelato x Biscotti x Animal Mints x Bubba Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-124",
      "strain": "Rollie",
      "type": "Hybrid",
      "thc": 31,
      "cbd": 0.1,
      "lineage": "Rollins x White 91",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-125",
      "strain": "Peach Pie",
      "type": "Hybrid",
      "thc": 23.06,
      "cbd": 0.1,
      "lineage": "Rainbow Pie x Dozizoz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-126",
      "strain": "Iced Lemonade",
      "type": "Hybrid",
      "thc": 28.21,
      "cbd": 0.1,
      "lineage": "Lemon Haze x Afghani",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-127",
      "strain": "Head Knock",
      "type": "Hybrid",
      "thc": 33.47,
      "cbd": 0.1,
      "lineage": "Covid 40 x Early Orange",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-128",
      "strain": "Biscotti Pippen",
      "type": "Hybrid",
      "thc": 27.5,
      "cbd": 0.1,
      "lineage": "Gelato #25 x South Florida OG",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-129",
      "strain": "Calabasas Cookies",
      "type": "Sativa",
      "thc": 22.1,
      "cbd": 0.1,
      "lineage": "GSC (Girl Scout Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-130",
      "strain": "Runtz",
      "type": "Hybrid",
      "thc": 24.49,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato #33",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-131",
      "strain": "High Society",
      "type": "Hybrid",
      "thc": 30.63,
      "cbd": 0.1,
      "lineage": "Biscotti x Jet Fuel Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-132",
      "strain": "Permanent Paradize",
      "type": "Hybrid",
      "thc": 26.73,
      "cbd": 0.1,
      "lineage": "PERMANENT MARKER x Z BX2",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-133",
      "strain": "Macchiato",
      "type": "Hybrid",
      "thc": 27.6,
      "cbd": 0.1,
      "lineage": "Sunset Sherbert x HeadBanger",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-134",
      "strain": "Zebra Ztripez",
      "type": "Hybrid",
      "thc": 27.22,
      "cbd": 0.1,
      "lineage": "Z Animal (Bx1.0",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-135",
      "strain": "Jungle Cookie",
      "type": "Hybrid",
      "thc": 27.92,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Jungle Cake",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-136",
      "strain": "Bog Walker",
      "type": "Indica",
      "thc": 32.82,
      "cbd": 0.1,
      "lineage": "Slazerbeam x Skywalker OG",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-137",
      "strain": "Glow Pop",
      "type": "Hybrid",
      "thc": 19.27,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-138",
      "strain": "Magic Marker",
      "type": "Hybrid",
      "thc": 25.35,
      "cbd": 0.1,
      "lineage": "Permanent Marker x RS-11",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-139",
      "strain": "Tropical Burst",
      "type": "Sativa",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-140",
      "strain": "Red Eye",
      "type": "Indica",
      "thc": 26.53,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-141",
      "strain": "Lemon Cherry Gelato",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Sunset Sherbet x Girl Scout Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-142",
      "strain": "Paradize Cove",
      "type": "Sativa",
      "thc": 27.42,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-143",
      "strain": "Pink Pussy",
      "type": "Hybrid",
      "thc": 27.34,
      "cbd": 0.1,
      "lineage": "Astronaut OG x Pink Panther",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-144",
      "strain": "Candy Cartel",
      "type": "Hybrid",
      "thc": 28.13,
      "cbd": 0.1,
      "lineage": "Biscotti x Sherb Cream Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-145",
      "strain": "V-Lone Runtz",
      "type": "Hybrid",
      "thc": 25.7,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-146",
      "strain": "Superman Ice Cream",
      "type": "Hybrid",
      "thc": 27.44,
      "cbd": 0.1,
      "lineage": "Superman OG x Ice Cream Cake",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-147",
      "strain": "Glitter Bomb",
      "type": "Indica",
      "thc": 28.71,
      "cbd": 0.1,
      "lineage": "Grape Gas 10 x OGKB Blueberry Headband",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-148",
      "strain": "Jelly Donut 2.0",
      "type": "Hybrid",
      "thc": 26.85,
      "cbd": 0.1,
      "lineage": "Gary Payton x Jealousy",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-149",
      "strain": "Porn Nug",
      "type": "Hybrid",
      "thc": 28.64,
      "cbd": 0.1,
      "lineage": "Biscotti x MAC1",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-150",
      "strain": "Moby Dick",
      "type": "Sativa",
      "thc": 24.57,
      "cbd": 0.1,
      "lineage": "White Widow x Haze",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-151",
      "strain": "Citrus Rush",
      "type": "Hybrid",
      "thc": 18.4,
      "cbd": 0.1,
      "lineage": "Skunk Tangerine x Do-Si-Dos",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-152",
      "strain": "OG x GMO",
      "type": "Indica",
      "thc": 19.3,
      "cbd": 0.1,
      "lineage": "GMO Cookies x WiFi OG x Triangle Mints",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-153",
      "strain": "Apples & Bananas",
      "type": "Hybrid",
      "thc": 26.19,
      "cbd": 0.1,
      "lineage": "Blue Power x Gelatti",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-154",
      "strain": "Power Puff Girls",
      "type": "Hybrid",
      "thc": 26.29,
      "cbd": 0.1,
      "lineage": "Atomic Apple x Bubblegum Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-155",
      "strain": "Strawberry Pie",
      "type": "Hybrid",
      "thc": 25.49,
      "cbd": 0.1,
      "lineage": "Georgia Pie x Strawberry Fritter",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-156",
      "strain": "Frozen Berriez",
      "type": "Hybrid",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-157",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 28.28,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-158",
      "strain": "Brain Freeze",
      "type": "Hybrid",
      "thc": 30.2,
      "cbd": 0.1,
      "lineage": "LUI x C99",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-159",
      "strain": "Dog Food",
      "type": "Hybrid",
      "thc": 28.28,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-160",
      "strain": "Thai Lights",
      "type": "Sativa",
      "thc": 27.7,
      "cbd": 0.1,
      "lineage": "Thai (landrace x Northern Lights",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-161",
      "strain": "Bad Apple Candy",
      "type": "Hybrid",
      "thc": 63.4,
      "cbd": 0.1,
      "lineage": "Atomic Apple x Xeno #10",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-162",
      "strain": "White Runtz",
      "type": "Hybrid",
      "thc": 69.7,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-163",
      "strain": "Biggie Runtz",
      "type": "Hybrid",
      "thc": 28.84,
      "cbd": 0.1,
      "lineage": "Runtz x Zkittlez",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-164",
      "strain": "Unicorn Piss",
      "type": "Hybrid",
      "thc": 27.14,
      "cbd": 0.1,
      "lineage": "Zkittlez ZOZ x Cat Piss",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-165",
      "strain": "Fruity Cereal",
      "type": "Hybrid",
      "thc": 52.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-166",
      "strain": "Mango Fruz",
      "type": "Hybrid",
      "thc": 26.83,
      "cbd": 0.1,
      "lineage": "Mango x Pineapple Fruz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-168",
      "strain": "Phantom Dog Food",
      "type": "Hybrid",
      "thc": 26.41,
      "cbd": 0.1,
      "lineage": "Phantom x Dog Food",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-169",
      "strain": "Dirty Taxi",
      "type": "Hybrid",
      "thc": 26.89,
      "cbd": 0.1,
      "lineage": "GMO x Chem Dog I-95",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-170",
      "strain": "Z Animals",
      "type": "Hybrid",
      "thc": 31,
      "cbd": 0.1,
      "lineage": "Original Z x Animal Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-171",
      "strain": "Munyunz",
      "type": "Hybrid",
      "thc": 28.26,
      "cbd": 0.1,
      "lineage": "Lemon Haze x Gorilla Glue",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-172",
      "strain": "Purple Dream",
      "type": "Hybrid",
      "thc": 27.48,
      "cbd": 0.1,
      "lineage": "Blue Dream x Granddaddy Purple",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-173",
      "strain": "Strawberry Cough",
      "type": "Sativa",
      "thc": 26.48,
      "cbd": 0.1,
      "lineage": "Haze x Strawberry Fields",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-174",
      "strain": "Strawberry Sprinkles",
      "type": "Hybrid",
      "thc": 54.8,
      "cbd": 0.1,
      "lineage": "Zkittlez x Titty Sprinkles",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-175",
      "strain": "Cookies and Cream",
      "type": "Hybrid",
      "thc": 53.2,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Starfighter",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-176",
      "strain": "Pina Colada",
      "type": "Sativa",
      "thc": 44.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-177",
      "strain": "Skrawberries",
      "type": "Hybrid",
      "thc": 20.94,
      "cbd": 0.1,
      "lineage": "Dante's Inferno x Apricot Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-178",
      "strain": "Sherbet",
      "type": "Hybrid",
      "thc": 24.75,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Pink Panties",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-179",
      "strain": "Street Treat",
      "type": "Hybrid",
      "thc": 31.4,
      "cbd": 0.1,
      "lineage": "Clout Candy x Hood Candy",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-180",
      "strain": "Blue Cookies",
      "type": "Indica",
      "thc": 26,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Blueberry",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-181",
      "strain": "Day Day Blue",
      "type": "Hybrid",
      "thc": 28.78,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-182",
      "strain": "Pixy Pop",
      "type": "Indica",
      "thc": 24.4,
      "cbd": 0.1,
      "lineage": "LA Pop Rocks x Purple Push Pop",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-183",
      "strain": "Bubblegum",
      "type": "Indica",
      "thc": 55.85,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-184",
      "strain": "D-Lish",
      "type": "Hybrid",
      "thc": 24.73,
      "cbd": 0.1,
      "lineage": "Zkittlez x Sweet Retreat",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-185",
      "strain": "Fruit Punch",
      "type": "Sativa",
      "thc": 56.93,
      "cbd": 0.1,
      "lineage": "Skunk x Haze x Northern Lights",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-186",
      "strain": "Danimals",
      "type": "Hybrid",
      "thc": 28.18,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-188",
      "strain": "Washington Apple",
      "type": "Hybrid",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "Apple Fritter x Red Velvet",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-189",
      "strain": "Permanent Chimera",
      "type": "Hybrid",
      "thc": 24.85,
      "cbd": 0.1,
      "lineage": "Chimera #2 x Permanent Marker",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-190",
      "strain": "Papa Smurf OG",
      "type": "Hybrid",
      "thc": 26.86,
      "cbd": 0.1,
      "lineage": "Blue Dream x Cotton Candy",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-191",
      "strain": "2 Unicorns 1 Poop",
      "type": "Hybrid",
      "thc": 26.23,
      "cbd": 0.1,
      "lineage": "Purple Gushers x Rainbow Belts x Unicorn Poop",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-192",
      "strain": "Warheads",
      "type": "Hybrid",
      "thc": 28.85,
      "cbd": 0.1,
      "lineage": "Kaboom x Sour Pez",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-193",
      "strain": "Lemon Oreoz",
      "type": "Hybrid",
      "thc": 26.6,
      "cbd": 0.1,
      "lineage": "Cookies & Cream x Secret Weapon",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-194",
      "strain": "Blue Dream",
      "type": "Hybrid",
      "thc": 27,
      "cbd": 0.1,
      "lineage": "Blueberry x Haze",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-195",
      "strain": "Blue Zushi",
      "type": "Hybrid",
      "thc": 28.29,
      "cbd": 0.1,
      "lineage": "Zkittlez x Kush Mints",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-196",
      "strain": "Raspberry Cream",
      "type": "Hybrid",
      "thc": 53.5,
      "cbd": 0.1,
      "lineage": "Raspberry Kush x Cream Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-198",
      "strain": "Lemon Cherry Gelato",
      "type": "Hybrid",
      "thc": 28.4,
      "cbd": 0.1,
      "lineage": "Sunset Sherbet x Girl Scout Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-199",
      "strain": "Spritzer",
      "type": "Hybrid",
      "thc": 30.02,
      "cbd": 0.1,
      "lineage": "Runtz x Grape Pie x MAC",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-200",
      "strain": "Lemon Mist",
      "type": "Hybrid",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Lemon Skunk x Super Silver Haze",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-201",
      "strain": "LA Candy Pop",
      "type": "Hybrid",
      "thc": 28.61,
      "cbd": 0.1,
      "lineage": "Candyland x LA Confidential",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-202",
      "strain": "Candy Bonez",
      "type": "Indica",
      "thc": 21.16,
      "cbd": 0.1,
      "lineage": "Sherb Cream Pie x Obama Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-203",
      "strain": "Pink Runtz",
      "type": "Hybrid",
      "thc": 55.06,
      "cbd": 0.1,
      "lineage": "Gelato x Zkittlez",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-204",
      "strain": "Creamy Smoothie",
      "type": "Indica",
      "thc": 25.45,
      "cbd": 0.1,
      "lineage": "Cream x Gelonade",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-205",
      "strain": "Lemon Fumez",
      "type": "Hybrid",
      "thc": 29.58,
      "cbd": 0.1,
      "lineage": "Lemon Berry x Sherb Cream Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-206",
      "strain": "Pink Lemonade",
      "type": "Hybrid",
      "thc": 28.68,
      "cbd": 0.1,
      "lineage": "Lemon Tree x Red Velvet",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-207",
      "strain": "Clout Loops",
      "type": "Hybrid",
      "thc": 29.2,
      "cbd": 0.1,
      "lineage": "Fruit Loops OG",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-208",
      "strain": "Permanent Marker",
      "type": "Hybrid",
      "thc": 27.93,
      "cbd": 0.1,
      "lineage": "Biscotti x Jealousy x Sherbet BX",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-209",
      "strain": "Lemon Cherry Frosty",
      "type": "Hybrid",
      "thc": 28.3,
      "cbd": 0.1,
      "lineage": "Lemon Cherry x Frosty",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-210",
      "strain": "Captain Krunch",
      "type": "Hybrid",
      "thc": 29.94,
      "cbd": 0.1,
      "lineage": "OG Kush x Kushberry",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-212",
      "strain": "Candy Apple Jacks",
      "type": "Hybrid",
      "thc": 28.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-213",
      "strain": "London Berries",
      "type": "Indica",
      "thc": 21.53,
      "cbd": 0.1,
      "lineage": "London Pound Cake 75 x Permanent Marker",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-214",
      "strain": "GMO",
      "type": "Indica",
      "thc": 27.4,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Chemdawg",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-215",
      "strain": "Candy Gas",
      "type": "Hybrid",
      "thc": 25.26,
      "cbd": 0.1,
      "lineage": "Kandy Kush x OG #18",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-216",
      "strain": "Sherbanger",
      "type": "Hybrid",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Sunset Sherbet x Headbanger",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-217",
      "strain": "Clown OG",
      "type": "Hybrid",
      "thc": 25.2,
      "cbd": 0.1,
      "lineage": "SFV OG x Wedding Cake",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-218",
      "strain": "Scented Marker",
      "type": "Hybrid",
      "thc": 26.38,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Pineapple Fruz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-219",
      "strain": "Brain Stew",
      "type": "Indica",
      "thc": 28.14,
      "cbd": 0.1,
      "lineage": "Triangle Kush x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-220",
      "strain": "Permanent Marker",
      "type": "Hybrid",
      "thc": 24.1,
      "cbd": 0.1,
      "lineage": "Biscotti x Jealousy x Sherb Bx",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-221",
      "strain": "Forbidden Fruit",
      "type": "Hybrid",
      "thc": 29.49,
      "cbd": 0.1,
      "lineage": "LA Kush Cake x Purple Push Pop",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-222",
      "strain": "Burnout OG",
      "type": "Hybrid",
      "thc": 23.15,
      "cbd": 0.1,
      "lineage": "Cherry Pie x GSC x Biker Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-223",
      "strain": "Black Magic",
      "type": "Hybrid",
      "thc": 30.85,
      "cbd": 0.1,
      "lineage": "Wavy x Bebesita",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-225",
      "strain": "LA Baker",
      "type": "Hybrid",
      "thc": 27.89,
      "cbd": 0.1,
      "lineage": "The Cookies x Sorbet",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-226",
      "strain": "Runtz",
      "type": "Hybrid",
      "thc": 23.67,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-229",
      "strain": "Potato Runtz",
      "type": "Hybrid",
      "thc": 26.06,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-230",
      "strain": "Pie Face",
      "type": "Hybrid",
      "thc": 28.32,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-232",
      "strain": "Candy Cartel",
      "type": "Hybrid",
      "thc": 28.37,
      "cbd": 0.1,
      "lineage": "Sherb Cream Pie x Biscotti",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-233",
      "strain": "Sub Zero #6",
      "type": "Hybrid",
      "thc": 27.12,
      "cbd": 0.1,
      "lineage": "Oreoz x Superboof",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-236",
      "strain": "Log Cabin OG",
      "type": "Sativa",
      "thc": 28.98,
      "cbd": 0.1,
      "lineage": "Lemon OG Kush Breath x Biker Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-237",
      "strain": "London Cherry Gelato",
      "type": "Hybrid",
      "thc": 25.8,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-238",
      "strain": "Znapple",
      "type": "Hybrid",
      "thc": 28.13,
      "cbd": 0.1,
      "lineage": "Super Boof x Shady Apples",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-239",
      "strain": "Candy Bonez",
      "type": "Indica",
      "thc": 27.19,
      "cbd": 0.1,
      "lineage": "Sherb Cream Pie x Obama Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-240",
      "strain": "Blue Dream",
      "type": "Hybrid",
      "thc": 23.65,
      "cbd": 0.1,
      "lineage": "Blueberry x Haze",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-241",
      "strain": "Lantz",
      "type": "Hybrid",
      "thc": 27.02,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-242",
      "strain": "Washington Apple",
      "type": "Indica",
      "thc": 28.24,
      "cbd": 0.1,
      "lineage": "Pez x Ortega",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-243",
      "strain": "Animal Tree",
      "type": "Hybrid",
      "thc": 27.43,
      "cbd": 0.1,
      "lineage": "Lemon Tree x Animal Mints",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-244",
      "strain": "Sherbie",
      "type": "Hybrid",
      "thc": 27.31,
      "cbd": 0.1,
      "lineage": "G33 x SCP",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-245",
      "strain": "Blue Candy",
      "type": "Hybrid",
      "thc": 24.02,
      "cbd": 0.1,
      "lineage": "Blueberry x Cotton Candy Kush",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-246",
      "strain": "Runtzatta",
      "type": "Hybrid",
      "thc": 28.58,
      "cbd": 0.1,
      "lineage": "Runtz x Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-247",
      "strain": "Dante's Inferno",
      "type": "Hybrid",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Oreoz x Devil Driver",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-248",
      "strain": "Sub Zero",
      "type": "Hybrid",
      "thc": 25.46,
      "cbd": 0.1,
      "lineage": "Oreoz x Superboof",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-249",
      "strain": "Bullet Breath",
      "type": "Hybrid",
      "thc": 33.22,
      "cbd": 0.1,
      "lineage": "Peacemaker x Puppy Breath",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-251",
      "strain": "Lemon Cherry Airheadz",
      "type": "Indica",
      "thc": 28,
      "cbd": 0.1,
      "lineage": "Lemon Cherry Terdz x Airheadz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-252",
      "strain": "Biscotti Runtz",
      "type": "Hybrid",
      "thc": 28.45,
      "cbd": 0.1,
      "lineage": "Biscotti x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-253",
      "strain": "Bling Blaow",
      "type": "Indica",
      "thc": 26.2,
      "cbd": 0.1,
      "lineage": "Glitter Bomb x Gastro Pop #5",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-254",
      "strain": "How The Shifter Stole Christmas",
      "type": "Hybrid",
      "thc": 28.33,
      "cbd": 0.1,
      "lineage": "Pressure Pack x Gear Shifters",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-255",
      "strain": "Glitter Glue",
      "type": "Hybrid",
      "thc": 27.62,
      "cbd": 0.1,
      "lineage": "Glitter Bomb x Gorilla Glue",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-256",
      "strain": "Lemon Cherry ICEE",
      "type": "Hybrid",
      "thc": 21.32,
      "cbd": 0.1,
      "lineage": "Lemon Cherry Gelato x Ice Cream Cake Bx",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-257",
      "strain": "Blue Gushers",
      "type": "Hybrid",
      "thc": 26.11,
      "cbd": 0.1,
      "lineage": "Gelato 41 x Triangle Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-258",
      "strain": "Gelato 41",
      "type": "Hybrid",
      "thc": 23.53,
      "cbd": 0.1,
      "lineage": "Thin Mint Girl Scout Cookies x Sunset Sherbet",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-259",
      "strain": "Dream Boat",
      "type": "Indica",
      "thc": 26.17,
      "cbd": 0.1,
      "lineage": "Orange Cookie Chem x Big O",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-260",
      "strain": "Grape Pie",
      "type": "Indica",
      "thc": 28.5,
      "cbd": 0.1,
      "lineage": "Cherry Pie x Grape Stomper",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-261",
      "strain": "Jelly Donut",
      "type": "Hybrid",
      "thc": 52.6,
      "cbd": 0.1,
      "lineage": "Purple Punch x French Toast",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-262",
      "strain": "Pink Certz",
      "type": "Hybrid",
      "thc": 24.74,
      "cbd": 0.1,
      "lineage": "The Menthol x Grape Gasoline",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-263",
      "strain": "Cherry Cola",
      "type": "Hybrid",
      "thc": 28.74,
      "cbd": 0.1,
      "lineage": "Runtz x Brainstew",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-264",
      "strain": "Detroit OG",
      "type": "Hybrid",
      "thc": 37.59,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-265",
      "strain": "Rainbow Runtz",
      "type": "Hybrid",
      "thc": 28.25,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-266",
      "strain": "Orange Cooler",
      "type": "Sativa",
      "thc": 26.89,
      "cbd": 0.1,
      "lineage": "Orange Crush x Cooler",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-267",
      "strain": "Papaya Punch",
      "type": "Hybrid",
      "thc": 24.16,
      "cbd": 0.1,
      "lineage": "Papaya x Purple Punch",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-268",
      "strain": "Sharpiez",
      "type": "Hybrid",
      "thc": 26.9,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Zoap",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-269",
      "strain": "Banana Conda",
      "type": "Hybrid",
      "thc": 25.9,
      "cbd": 0.1,
      "lineage": "Snake Cake x Dual OG #4",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-270",
      "strain": "Cherry Pop Tart",
      "type": "Hybrid",
      "thc": 26.28,
      "cbd": 0.1,
      "lineage": "Cherry Pie x GSC",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-271",
      "strain": "Mega",
      "type": "Hybrid",
      "thc": 27.78,
      "cbd": 0.1,
      "lineage": "RS11 x Sherb Cream Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-272",
      "strain": "Blue Zu",
      "type": "Hybrid",
      "thc": 34,
      "cbd": 0.1,
      "lineage": "Purple Yuzu x Blue Power",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-273",
      "strain": "Indianapolis Gas",
      "type": "Hybrid",
      "thc": 35.96,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-275",
      "strain": "Shangri-La Runtz",
      "type": "Hybrid",
      "thc": 25.03,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-276",
      "strain": "Jack In The Box",
      "type": "Hybrid",
      "thc": 28.58,
      "cbd": 0.1,
      "lineage": "Candy Strain x Jack Herer",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-277",
      "strain": "Melonade Mimosa",
      "type": "Hybrid",
      "thc": 53.02,
      "cbd": 0.1,
      "lineage": "Melonade x Mimosa",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-278",
      "strain": "Red Velvet Cake",
      "type": "Hybrid",
      "thc": 54.5,
      "cbd": 0.1,
      "lineage": "Lemon Cherry Gelato x Pina Acai",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-279",
      "strain": "Space Cake",
      "type": "Hybrid",
      "thc": 25.33,
      "cbd": 0.1,
      "lineage": "Girl Scout Cookies x Snow Lotus",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-280",
      "strain": "Zkittlez x Runtz",
      "type": "Hybrid",
      "thc": 28.05,
      "cbd": 0.1,
      "lineage": "Zkittlez x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-281",
      "strain": "Mic Drop",
      "type": "Hybrid",
      "thc": 25.67,
      "cbd": 0.1,
      "lineage": "E85 x Apples N Bananas",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-282",
      "strain": "Permanent Marker x ADL",
      "type": "Hybrid",
      "thc": 28.76,
      "cbd": 0.1,
      "lineage": "Permanent Marker x ADL",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-283",
      "strain": "Zkittlez x OG",
      "type": "Hybrid",
      "thc": 28.1,
      "cbd": 0.1,
      "lineage": "Zkittlez x OG Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-284",
      "strain": "Permanent Marker x Lemon Cherry Sherbet",
      "type": "Hybrid",
      "thc": 28.14,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Lemon Cherry Sherbet",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-285",
      "strain": "Shift Alone",
      "type": "Hybrid",
      "thc": 28.61,
      "cbd": 0.1,
      "lineage": "Pressure Pack x Gear Shifters",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-286",
      "strain": "Double Rainbow Sherb",
      "type": "Hybrid",
      "thc": 27.69,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-287",
      "strain": "Glow Pop",
      "type": "Hybrid",
      "thc": 24.83,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-288",
      "strain": "Lemon Lime",
      "type": "Sativa",
      "thc": 25.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-289",
      "strain": "Permanent Marker",
      "type": "Hybrid",
      "thc": 25.37,
      "cbd": 0.1,
      "lineage": "Biscotti x Jealousy x Sherbet BX",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-290",
      "strain": "Zupa",
      "type": "Hybrid",
      "thc": 26.9,
      "cbd": 0.1,
      "lineage": "Zoap x Superboof",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-292",
      "strain": "Project X",
      "type": "Hybrid",
      "thc": 28.41,
      "cbd": 0.1,
      "lineage": "Forum Cookies x Secret Cookies x Cherry Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-293",
      "strain": "Lemon Rizz",
      "type": "Sativa",
      "thc": 25.22,
      "cbd": 0.1,
      "lineage": "MAC 1 x Deep Breath",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-295",
      "strain": "Lazazza",
      "type": "Hybrid",
      "thc": 27.1,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Zkittles",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-296",
      "strain": "Elon Musky",
      "type": "Hybrid",
      "thc": 28.23,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-297",
      "strain": "Goyard x Biscotti Cake",
      "type": "Hybrid",
      "thc": 26.42,
      "cbd": 0.1,
      "lineage": "Goyard x Biscotti Cake",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-298",
      "strain": "Blueberry Muffin",
      "type": "Hybrid",
      "thc": 23.58,
      "cbd": 0.1,
      "lineage": "Razzleberry x Purple Panty Dropper",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-299",
      "strain": "Popz 41",
      "type": "Hybrid",
      "thc": 26.13,
      "cbd": 0.1,
      "lineage": "Gelato 41 x Zkittlez",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-302",
      "strain": "Sherbtang",
      "type": "Hybrid",
      "thc": 27.77,
      "cbd": 0.1,
      "lineage": "Sherb Cream Pie x Superboof",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-303",
      "strain": "Space Guavaz",
      "type": "Hybrid",
      "thc": 25,
      "cbd": 0.1,
      "lineage": "Space Runtz x Guavaz 74",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-306",
      "strain": "Blumosa",
      "type": "Hybrid",
      "thc": 26.17,
      "cbd": 0.1,
      "lineage": "Blue Cookies x Mimosa",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-307",
      "strain": "Atlanta Peach",
      "type": "Hybrid",
      "thc": 35.82,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-308",
      "strain": "Motorbreath",
      "type": "Hybrid",
      "thc": 27.96,
      "cbd": 0.1,
      "lineage": "Chemdawg x SFV OG Kush",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-309",
      "strain": "Speaker Knockerz",
      "type": "Hybrid",
      "thc": 27.81,
      "cbd": 0.1,
      "lineage": "Runtz x Animal Mintz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-310",
      "strain": "Permanent Cherries",
      "type": "Hybrid",
      "thc": 24.7,
      "cbd": 0.1,
      "lineage": "Lemon Cherry x Kush Mints x Permanent Marker",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-311",
      "strain": "DOUBLE CUP",
      "type": "Hybrid",
      "thc": 26.7,
      "cbd": 0.1,
      "lineage": "AMNESIA HAZE x BIKER KUSH",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-312",
      "strain": "Murder Mitten",
      "type": "Hybrid",
      "thc": 26.4,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-314",
      "strain": "Lituya Bay",
      "type": "Hybrid",
      "thc": 27.47,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-315",
      "strain": "The Mistress",
      "type": "Hybrid",
      "thc": 26.31,
      "cbd": 0.1,
      "lineage": "Wedding Pie x Project 4516",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-316",
      "strain": "Candy Blues",
      "type": "Hybrid",
      "thc": 27.2,
      "cbd": 0.1,
      "lineage": "Blue Nerdz x Sherb Cream Pie",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-317",
      "strain": "ZAC",
      "type": "Hybrid",
      "thc": 25.61,
      "cbd": 0.1,
      "lineage": "Zkittlez x Animal Cookies",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-318",
      "strain": "Lemon Mist",
      "type": "Hybrid",
      "thc": 21.3,
      "cbd": 0.1,
      "lineage": "Lemon Skunk x Super Silver Haze",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-320",
      "strain": "Sherb Cream Pie",
      "type": "Hybrid",
      "thc": 20.14,
      "cbd": 0.1,
      "lineage": "Ice Cream Cake x Sherb BX1",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-322",
      "strain": "Gogurtz",
      "type": "Hybrid",
      "thc": 27.48,
      "cbd": 0.1,
      "lineage": "Cap Junky x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 1,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-323",
      "strain": "MI MAC",
      "type": "Hybrid",
      "thc": 28.8,
      "cbd": 0.1,
      "lineage": "Alien Cookies x Colombian x Starfighter",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-324",
      "strain": "Moon Blend",
      "type": "Hybrid",
      "thc": 25.5,
      "cbd": 0.1,
      "lineage": "Space Runtz x Devil Driver",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-325",
      "strain": "Super Buff Cherry",
      "type": "Hybrid",
      "thc": 18.8,
      "cbd": 0.1,
      "lineage": "Super Boof x Tropicanna Cherry",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-326",
      "strain": "Amarelli",
      "type": "Sativa",
      "thc": 24.35,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-327",
      "strain": "Bubblegum Marker",
      "type": "Indica",
      "thc": 23.9,
      "cbd": 0.1,
      "lineage": "Sherbet x Permanent Marker",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-328",
      "strain": "Scented Marker",
      "type": "Hybrid",
      "thc": 26.5,
      "cbd": 0.1,
      "lineage": "Permanent Marker x Pineapple Fruz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-331",
      "strain": "Larry Legend",
      "type": "Hybrid",
      "thc": 25.08,
      "cbd": 0.1,
      "lineage": "Larry OG x Legend OG",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-333",
      "strain": "Runtzbow",
      "type": "Hybrid",
      "thc": 26.3,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 0,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-334",
      "strain": "Biskante",
      "type": "Hybrid",
      "thc": 21.06,
      "cbd": 0.1,
      "lineage": "MELONADE x BISCOTTI",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-338",
      "strain": "Animal Cocktail",
      "type": "Hybrid",
      "thc": 27.8,
      "cbd": 0.1,
      "lineage": "Animal Face x Garlic Cocktail",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-339",
      "strain": "ADL x Lemon Cherry",
      "type": "Hybrid",
      "thc": 29.4,
      "cbd": 0.1,
      "lineage": "ADL x Lemon Cherry Gelato",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-340",
      "strain": "Lemon Cherry Gelato",
      "type": "Hybrid",
      "thc": 28.89,
      "cbd": 0.1,
      "lineage": "Sunset Sherbet x GSC",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-341",
      "strain": "StrawGuava",
      "type": "Hybrid",
      "thc": 22.56,
      "cbd": 0.1,
      "lineage": "Strawberry Banana x Papaya",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-342",
      "strain": "Devil's Advocate",
      "type": "Hybrid",
      "thc": 28.9,
      "cbd": 0.1,
      "lineage": "Devil Driver x Yellow Zushi",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-343",
      "strain": "Flawless",
      "type": "Hybrid",
      "thc": 28.7,
      "cbd": 0.1,
      "lineage": "Zkittlez x Bebesita",
      "terpenes": {
        "Caryophyllene": 0,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-344",
      "strain": "93 Octane",
      "type": "Hybrid",
      "thc": 26.38,
      "cbd": 0.1,
      "lineage": "Candyland x Humboldt OG",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-345",
      "strain": "D-Lish",
      "type": "Hybrid",
      "thc": 20.36,
      "cbd": 0.1,
      "lineage": "Zkittlez x Sweet Retreat",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-346",
      "strain": "Tropical Treatz",
      "type": "Hybrid",
      "thc": 23.79,
      "cbd": 0.1,
      "lineage": "Zoap x Fundip",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-347",
      "strain": "Keezu",
      "type": "Hybrid",
      "thc": 24.5,
      "cbd": 0.1,
      "lineage": "Green Cherry Pie x Platinum Cookies x Candyland x Rainbow Beltz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-348",
      "strain": "Red Hotz",
      "type": "Hybrid",
      "thc": 24.03,
      "cbd": 0.1,
      "lineage": "Biscotti x Gassius Clay x Sweet Retreat x Zkittles",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-349",
      "strain": "Sugar Rainbow Luxe",
      "type": "Hybrid",
      "thc": 26.68,
      "cbd": 0.1,
      "lineage": "Cadillac Rainbows x High Fructose Corn Syrup",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 1
      },
      "state": "MI"
    },
    {
      "id": "MI-350",
      "strain": "Blue Razz Runtz",
      "type": "Hybrid",
      "thc": 27.48,
      "cbd": 0.1,
      "lineage": "Runtz x Blue Razz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-351",
      "strain": "Pink Runtz",
      "type": "Hybrid",
      "thc": 29.71,
      "cbd": 0.1,
      "lineage": "Zkittlez x Gelato x Rainbow Sherbet x Pink Panties",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 1,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 1,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-352",
      "strain": "Modified Banana Pebbles",
      "type": "Hybrid",
      "thc": 30.98,
      "cbd": 0.1,
      "lineage": "Fruity Pebbles OG x Modified Banana",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-353",
      "strain": "Gumbo",
      "type": "Indica",
      "thc": 26.5,
      "cbd": 0.1,
      "lineage": "Unknown",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 0,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-354",
      "strain": "Lemon Cherry Runtz",
      "type": "Hybrid",
      "thc": 28.51,
      "cbd": 0.1,
      "lineage": "Sunset Sherbet x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-355",
      "strain": "Runtz 2.0",
      "type": "Hybrid",
      "thc": 28.78,
      "cbd": 0.1,
      "lineage": "Unicorn Poop x Runtz",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 0,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 0,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-356",
      "strain": "Strawberry Cough",
      "type": "Hybrid",
      "thc": 22.37,
      "cbd": 0.1,
      "lineage": "Strawberry Fields x Haze",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 1,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 0
      },
      "state": "MI"
    },
    {
      "id": "MI-357",
      "strain": "StrawGuava",
      "type": "Hybrid",
      "thc": 22.56,
      "cbd": 0.1,
      "lineage": "Strawberry Banana x Papaya",
      "terpenes": {
        "Caryophyllene": 1,
        "Humulene": 0,
        "Limonene": 1,
        "Ocimene": 0,
        "Linalool": 1,
        "Myrcene": 1,
        "Terpinolene": 0,
        "Bisabolol": 0,
        "Pinene": 1,
        "b-Pinene": 1
      },
      "state": "MI"
    }
],

CT : [
  {
    "id": "CT-100",
    "strain": "GMO",
    "type": "Indica",
    "thc": 32.47,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.12,
      "Limonene": 0.79,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.79,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.06,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-101",
    "strain": "Jet Fuel",
    "type": "Hybrid",
    "thc": 18.7,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.3,
      "Humulene": 0.1,
      "Limonene": 0.38,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.28,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.08
    },
    "state": "CT"
  },
  {
    "id": "CT-102",
    "strain": "OMG",
    "type": "Hybrid",
    "thc": 28.66,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.38,
      "Humulene": 0.15,
      "Limonene": 0.57,
      "Ocimene": 0.03,
      "Linalool": 0.07,
      "Myrcene": 0.5,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "CT"
  },
  {
    "id": "CT-103",
    "strain": "Swamp Water Fumez",
    "type": "Hybrid",
    "thc": 30.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.2,
      "Limonene": 0.49,
      "Ocimene": 0.02,
      "Linalool": 0.47,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "CT"
  },
  {
    "id": "CT-104",
    "strain": "Fantasy Melonz",
    "type": "Hybrid",
    "thc": 24.62,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0,
      "Limonene": 0.87,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.32,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.15,
      "b-Pinene": 0.15
    },
    "state": "CT"
  },
  {
    "id": "CT-105",
    "strain": "Bananaconda",
    "type": "Hybrid",
    "thc": 29.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.12,
      "Humulene": 0.04,
      "Limonene": 0.93,
      "Ocimene": 0.1,
      "Linalool": 0.35,
      "Myrcene": 0.07,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.14,
      "b-Pinene": 0.17
    },
    "state": "CT"
  },
  {
    "id": "CT-106",
    "strain": "Glue Fondue",
    "type": "Sativa",
    "thc": 21.11,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.18,
      "Limonene": 0.16,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 1.13,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.04
    },
    "state": "CT"
  },
  {
    "id": "CT-107",
    "strain": "Regina Gorgeous",
    "type": "Hybrid",
    "thc": 23.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.08,
      "Limonene": 0.65,
      "Ocimene": 0.02,
      "Linalool": 0.17,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.08
    },
    "state": "CT"
  },
  {
    "id": "CT-108",
    "strain": "Rose Gold RTZ",
    "type": "Hybrid",
    "thc": 26.07,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.12,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.18,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-109",
    "strain": "Bubba F",
    "type": "Indica",
    "thc": 24.79,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.11,
      "Limonene": 0.45,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "CT"
  },
  {
    "id": "CT-110",
    "strain": "Cherry Burger",
    "type": "Indica",
    "thc": 24.42,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.54,
      "Humulene": 0.25,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-111",
    "strain": "Chkn n WflZ",
    "type": "Sativa",
    "thc": 19.78,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.2,
      "Humulene": 0.1,
      "Limonene": 0.78,
      "Ocimene": 0,
      "Linalool": 0.46,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-112",
    "strain": "Slapz ",
    "type": "Hybrid",
    "thc": 26.5,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.07,
      "Limonene": 0.71,
      "Ocimene": 0.03,
      "Linalool": 0.26,
      "Myrcene": 0.17,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-113",
    "strain": "B Scout",
    "type": "Indica",
    "thc": 21.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.19,
      "Humulene": 0.09,
      "Limonene": 0.45,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.12,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-114",
    "strain": "Mystic Mint",
    "type": "Indica",
    "thc": 23.01,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0.05,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "CT"
  },
  {
    "id": "CT-115",
    "strain": "95 Cook",
    "type": "Hybrid",
    "thc": 17.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.12,
      "Limonene": 0.17,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.09,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.02
    },
    "state": "CT"
  },
  {
    "id": "CT-116",
    "strain": "Go Gr Tz",
    "type": "Hybrid",
    "thc": 19.39,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.06,
      "Limonene": 0.18,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-117",
    "strain": "Indica Blend",
    "type": "Indica",
    "thc": 19.38,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.12,
      "Limonene": 0.13,
      "Ocimene": 0.03,
      "Linalool": 0.16,
      "Myrcene": 0.04,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.04
    },
    "state": "CT"
  },
  {
    "id": "CT-118",
    "strain": "Animal Face",
    "type": "Indica",
    "thc": 17.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-119",
    "strain": "Animal Scout #10",
    "type": "Indica",
    "thc": 14.9,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.1,
      "Limonene": 0.22,
      "Ocimene": 0.03,
      "Linalool": 0.03,
      "Myrcene": 0.19,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "CT"
  },
  {
    "id": "CT-120",
    "strain": "Grape Bubble G",
    "type": "Hybrid",
    "thc": 17.75,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0,
      "Limonene": 0.12,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-121",
    "strain": "Capy",
    "type": "Hybrid",
    "thc": 32.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.13,
      "Limonene": 0.53,
      "Ocimene": 0.01,
      "Linalool": 0.32,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.08
    },
    "state": "CT"
  },
  {
    "id": "CT-122",
    "strain": "Garlic Icing",
    "type": "Indica",
    "thc": 30.59,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.62,
      "Humulene": 0.23,
      "Limonene": 0.89,
      "Ocimene": 0.4,
      "Linalool": 0.24,
      "Myrcene": 0.13,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.56,
      "b-Pinene": 0.38
    },
    "state": "CT"
  },
  {
    "id": "CT-123",
    "strain": "Hippie Crasher",
    "type": "Indica",
    "thc": 30.27,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.16,
      "Limonene": 0.93,
      "Ocimene": 0.17,
      "Linalool": 0.36,
      "Myrcene": 0.09,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.19,
      "b-Pinene": 0.22
    },
    "state": "CT"
  },
  {
    "id": "CT-124",
    "strain": "Medellin",
    "type": "Indica",
    "thc": 29.66,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.43,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.36,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.1
    },
    "state": "CT"
  },
  {
    "id": "CT-125",
    "strain": "Orange Sunshine",
    "type": "Indica",
    "thc": 30.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.82,
      "Humulene": 0.3,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.08
    },
    "state": "CT"
  },
  {
    "id": "CT-126",
    "strain": "Han Solo Burger",
    "type": "Indica",
    "thc": 27.58,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.81,
      "Humulene": 0.46,
      "Limonene": 0.77,
      "Ocimene": 0.05,
      "Linalool": 0.13,
      "Myrcene": 0.63,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.16
    },
    "state": "CT"
  },
  {
    "id": "CT-127",
    "strain": "10G's",
    "type": "Hybrid",
    "thc": 25.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.07,
      "Limonene": 0.63,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.32,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.17,
      "b-Pinene": 0.17
    },
    "state": "CT"
  },
  {
    "id": "CT-128",
    "strain": "Gush Mintz",
    "type": "Indica",
    "thc": 28.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.82,
      "Humulene": 0.32,
      "Limonene": 0.74,
      "Ocimene": 0.04,
      "Linalool": 0.3,
      "Myrcene": 0.06,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-129",
    "strain": "Blackberry Caviar",
    "type": "Indica",
    "thc": 26.45,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.07,
      "Limonene": 0.11,
      "Ocimene": 0.03,
      "Linalool": 0.16,
      "Myrcene": 0.04,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-130",
    "strain": "Pakman",
    "type": "Hybrid",
    "thc": 27.1,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.34,
      "Humulene": 0.11,
      "Limonene": 0.26,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-131",
    "strain": "Jokerz",
    "type": "Indica",
    "thc": 20.82,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.12,
      "Humulene": 0,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.08,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-132",
    "strain": "Red Gary",
    "type": "Hybrid",
    "thc": 27.57,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.15,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.44,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-133",
    "strain": "Tasty Jane",
    "type": "Indica",
    "thc": 22.72,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.16,
      "Humulene": 0.05,
      "Limonene": 0.13,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 1.26,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.32,
      "b-Pinene": 0.15
    },
    "state": "CT"
  },
  {
    "id": "CT-134",
    "strain": "Zuava",
    "type": "Hybrid",
    "thc": 28.5,
    "cbd": 0.1,
    "lineage": "The Original Z x Guava",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.15,
      "Limonene": 0.56,
      "Ocimene": 0.04,
      "Linalool": 0.25,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-135",
    "strain": "Raspberry PRFT",
    "type": "Sativa",
    "thc": 20.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.11,
      "Humulene": 0.04,
      "Limonene": 0,
      "Ocimene": 0.11,
      "Linalool": 0.06,
      "Myrcene": 0.35,
      "Terpinolene": 0.62,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-136",
    "strain": "Bad Decisions",
    "type": "Hybrid",
    "thc": 24.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.13,
      "Humulene": 0.04,
      "Limonene": 0.53,
      "Ocimene": 0.02,
      "Linalool": 0.16,
      "Myrcene": 0.23,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.09
    },
    "state": "CT"
  },
  {
    "id": "CT-137",
    "strain": "Dante's Fire",
    "type": "Hybrid",
    "thc": 26.18,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.12,
      "Limonene": 0.41,
      "Ocimene": 0.21,
      "Linalool": 0,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0,
      "b-Pinene": 0.06
    },
    "state": "CT"
  },
  {
    "id": "CT-138",
    "strain": "Frozen Bag",
    "type": "Hybrid",
    "thc": 23.09,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.18,
      "Humulene": 0.07,
      "Limonene": 0.24,
      "Ocimene": 0.03,
      "Linalool": 0.1,
      "Myrcene": 0.59,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 1.01,
      "b-Pinene": 0.25
    },
    "state": "CT"
  },
  {
    "id": "CT-139",
    "strain": "Midnight O",
    "type": "Hybrid",
    "thc": 30.18,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.33,
      "Humulene": 0.12,
      "Limonene": 0.72,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 1.13,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.06,
      "b-Pinene": 0.12
    },
    "state": "CT"
  },
  {
    "id": "CT-140",
    "strain": "Next Level",
    "type": "Hybrid",
    "thc": 29.76,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.05,
      "Limonene": 1.04,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.69,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.19
    },
    "state": "CT"
  },
  {
    "id": "CT-141",
    "strain": "Peach Diesel",
    "type": "Sativa",
    "thc": 26.82,
    "cbd": 0.1,
    "lineage": ": (Sour Diesel x Thin Mint Cookies) x Peach",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.16,
      "Limonene": 0.23,
      "Ocimene": 0.01,
      "Linalool": 0.21,
      "Myrcene": 2.06,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0,
      "b-Pinene": 0.04
    },
    "state": "CT"
  },
  {
    "id": "CT-142",
    "strain": "Tropical Heatwave",
    "type": "Hybrid",
    "thc": 26.66,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.08,
      "Humulene": 0,
      "Limonene": 1,
      "Ocimene": 0.04,
      "Linalool": 0.24,
      "Myrcene": 0.56,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.08,
      "b-Pinene": 0.14
    },
    "state": "CT"
  },
  {
    "id": "CT-143",
    "strain": "Tropical Drizzle",
    "type": "Hybrid",
    "thc": 19.38,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.13,
      "Humulene": 0.04,
      "Limonene": 0.14,
      "Ocimene": 0.01,
      "Linalool": 0.11,
      "Myrcene": 0.51,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0,
      "b-Pinene": 0.05
    },
    "state": "CT"
  },
  {
    "id": "CT-144",
    "strain": "Zesty Garlic Kookyz",
    "type": "Indica",
    "thc": 25.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.06,
      "Humulene": 0.02,
      "Limonene": 1.02,
      "Ocimene": 0.03,
      "Linalool": 0.06,
      "Myrcene": 0.81,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.12
    },
    "state": "CT"
  },
  {
    "id": "CT-145",
    "strain": "Foreign Kush Mints",
    "type": "Indica",
    "thc": 29.68,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.2,
      "Limonene": 0.53,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 1.43,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-146",
    "strain": "Triple Stack",
    "type": "Indica",
    "thc": 28.47,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.43,
      "Humulene": 0.14,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-147",
    "strain": "Lunar Diesel",
    "type": "Hybrid",
    "thc": 23,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.09,
      "Limonene": 0.61,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.59,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.21
    },
    "state": "CT"
  },
  {
    "id": "CT-148",
    "strain": "Paw Paw",
    "type": "Hybrid",
    "thc": 31.4,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.1,
      "Limonene": 0.14,
      "Ocimene": 0.28,
      "Linalool": 0.11,
      "Myrcene": 0.24,
      "Terpinolene": 1.86,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.17
    },
    "state": "CT"
  },
  {
    "id": "CT-149",
    "strain": "Nuclear Mfns",
    "type": "Hybrid",
    "thc": 23.13,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-150",
    "strain": "Atomic Breath",
    "type": "Hybrid",
    "thc": 29.35,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.31,
      "Humulene": 0.13,
      "Limonene": 0.6,
      "Ocimene": 0.09,
      "Linalool": 0.1,
      "Myrcene": 0.74,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.83,
      "b-Pinene": 0.4
    },
    "state": "CT"
  },
  {
    "id": "CT-151",
    "strain": "White Caps",
    "type": "Indica",
    "thc": 25.76,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.12,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.42,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.03,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-152",
    "strain": "Problem Child",
    "type": "Hybrid",
    "thc": 26.89,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.22,
      "Limonene": 0.21,
      "Ocimene": 0.01,
      "Linalool": 0.08,
      "Myrcene": 0.9,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.04
    },
    "state": "CT"
  },
  {
    "id": "CT-153",
    "strain": "Hi Life",
    "type": "Hybrid",
    "thc": 25.72,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0,
      "Limonene": 0.47,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-154",
    "strain": "Mule Fuel",
    "type": "Hybrid",
    "thc": 32.67,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.06,
      "Limonene": 0.26,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.76,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.28,
      "b-Pinene": 0.12
    },
    "state": "CT"
  },
  {
    "id": "CT-155",
    "strain": "Durban Cookies",
    "type": "Sativa",
    "thc": 25.57,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.16,
      "Limonene": 0.08,
      "Ocimene": 0.14,
      "Linalool": 0.14,
      "Myrcene": 0.2,
      "Terpinolene": 0.36,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.07
    },
    "state": "CT"
  },
  {
    "id": "CT-156",
    "strain": "Sour Fire OG",
    "type": "Hybrid",
    "thc": 23.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.86,
      "Humulene": 0.33,
      "Limonene": 0.09,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.77,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-157",
    "strain": "Glitter Bomb",
    "type": "Indica",
    "thc": 27.51,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.77,
      "Humulene": 0.22,
      "Limonene": 0,
      "Ocimene": 0.11,
      "Linalool": 0.26,
      "Myrcene": 1.3,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-158",
    "strain": "Applescotti",
    "type": "Indica",
    "thc": 25.29,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.05,
      "Humulene": 0.35,
      "Limonene": 0.66,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.19,
      "b-Pinene": 0.15
    },
    "state": "CT"
  },
  {
    "id": "CT-159",
    "strain": "BLB",
    "type": "Hybrid",
    "thc": 29.64,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.37,
      "Humulene": 0.12,
      "Limonene": 0.3,
      "Ocimene": 0.1,
      "Linalool": 0.06,
      "Myrcene": 0.16,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  },
  {
    "id": "CT-160",
    "strain": "BNC-S-20",
    "type": "Hybrid",
    "thc": 30.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.12,
      "Limonene": 0.57,
      "Ocimene": 0.04,
      "Linalool": 0.27,
      "Myrcene": 1.13,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "CT"
  },
  {
    "id": "CT-161",
    "strain": "GGP",
    "type": "Indica",
    "thc": 25.67,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.74,
      "Humulene": 0.23,
      "Limonene": 0.9,
      "Ocimene": 0.11,
      "Linalool": 0.27,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.14,
      "b-Pinene": 0.16
    },
    "state": "CT"
  },
  {
    "id": "CT-162",
    "strain": "SZO",
    "type": "Indica",
    "thc": 28.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.17,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.42,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.06,
      "b-Pinene": 0.11
    },
    "state": "CT"
  },
  {
    "id": "CT-163",
    "strain": "Garlic Krusher",
    "type": "Hybrid",
    "thc": 0.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.34,
      "Limonene": 0.23,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.13,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "CT"
  }
],

MD : [
  {
    "id": "MD-100",
    "strain": "GMO",
    "type": "Indica",
    "thc": 31.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.5,
      "Humulene": 0.18,
      "Limonene": 0.53,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.23,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-101",
    "strain": "Strawberry Guava ",
    "type": "Hybrid",
    "thc": 18.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0.06,
      "Limonene": 0.6,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.53,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-102",
    "strain": "Taffy Twist",
    "type": "Indica",
    "thc": 23.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.08,
      "Limonene": 0.27,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-103",
    "strain": "Venom OG",
    "type": "Indica",
    "thc": 25.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0.06,
      "Limonene": 1.06,
      "Ocimene": 0,
      "Linalool": 0.43,
      "Myrcene": 0.53,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-104",
    "strain": "Guava Jam ",
    "type": "Hybrid",
    "thc": 29.85,
    "cbd": 0.1,
    "lineage": ": Guavaz 62 x Guavaz 74",
    "terpenes": {
      "Caryophyllene": 0.55,
      "Humulene": 0.15,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 0.72,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-105",
    "strain": "Heirloom",
    "type": "Hybrid",
    "thc": 27.37,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.92,
      "Humulene": 0.22,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.52,
      "Myrcene": 0.26,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-106",
    "strain": "Honeydew",
    "type": "Hybrid",
    "thc": 26.71,
    "cbd": 0.1,
    "lineage": ": Guava Gelato x Devil Driver",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0.06,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.43,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-107",
    "strain": "Torrone #2",
    "type": "Hybrid",
    "thc": 27.11,
    "cbd": 0.1,
    "lineage": ": Cream Cookiez x Apple Fritter",
    "terpenes": {
      "Caryophyllene": 0.57,
      "Humulene": 0.18,
      "Limonene": 0.43,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.25,
      "Terpinolene": 0.02,
      "Bisabolol": 0.15,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-108",
    "strain": "Chikitaz",
    "type": "Hybrid",
    "thc": 22.31,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.1,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.1,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-109",
    "strain": "Cadillac Rainbows",
    "type": "Hybrid",
    "thc": 27.08,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.34,
      "Humulene": 0.12,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.38,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.07,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-110",
    "strain": "Mule Fuel ",
    "type": "Hybrid",
    "thc": 27.11,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.08,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.45,
      "Terpinolene": 0.02,
      "Bisabolol": 0.02,
      "Pinene": 0.29,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-111",
    "strain": "Apples and Bananas",
    "type": "Hybrid",
    "thc": 24.41,
    "cbd": 0.1,
    "lineage": "Now N Later x Jet Fuel Gelato",
    "terpenes": {
      "Caryophyllene": 0.31,
      "Humulene": 0.09,
      "Limonene": 0.08,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 1,
      "Terpinolene": 0.02,
      "Bisabolol": 0.02,
      "Pinene": 0.26,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-112",
    "strain": "Apples and Bananas x Medellin",
    "type": "Hybrid",
    "thc": 25.38,
    "cbd": 0.1,
    "lineage": "Now N Later x Jet Fuel Gelato",
    "terpenes": {
      "Caryophyllene": 0.61,
      "Humulene": 0.19,
      "Limonene": 0.26,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.28,
      "Terpinolene": 0.01,
      "Bisabolol": 0.02,
      "Pinene": 0.03,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-113",
    "strain": "Blue Raz",
    "type": "Hybrid",
    "thc": 21.13,
    "cbd": 0.1,
    "lineage": "E85 x Doggy Bagg",
    "terpenes": {
      "Caryophyllene": 0.57,
      "Humulene": 0.2,
      "Limonene": 1.04,
      "Ocimene": 0,
      "Linalool": 0.26,
      "Myrcene": 0.07,
      "Terpinolene": 0.01,
      "Bisabolol": 0.08,
      "Pinene": 0.13,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-114",
    "strain": "Blueberry Caviar",
    "type": "Hybrid",
    "thc": 20.24,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.29,
      "Humulene": 0.09,
      "Limonene": 0.61,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 0.36,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-115",
    "strain": "Fried Banana's",
    "type": "Hybrid",
    "thc": 28.29,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.73,
      "Humulene": 0.18,
      "Limonene": 0.68,
      "Ocimene": 0,
      "Linalool": 0.26,
      "Myrcene": 0.51,
      "Terpinolene": 0,
      "Bisabolol": 0.16,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-116",
    "strain": "Mexican Flan",
    "type": "Hybrid",
    "thc": 20.02,
    "cbd": 0.1,
    "lineage": "Ice Cream Cake x Animal Mints",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.16,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.35,
      "Terpinolene": 0.01,
      "Bisabolol": 0.01,
      "Pinene": 0.08,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-117",
    "strain": "Moonwalkers",
    "type": "Hybrid",
    "thc": 21.69,
    "cbd": 0.1,
    "lineage": "Black Cherry Gelato x Medellin",
    "terpenes": {
      "Caryophyllene": 0.17,
      "Humulene": 0.05,
      "Limonene": 0.12,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.05,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-118",
    "strain": "Pacman",
    "type": "Hybrid",
    "thc": 22.02,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.43,
      "Humulene": 0.11,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-119",
    "strain": "Red Light",
    "type": "Hybrid",
    "thc": 26.35,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.1,
      "Limonene": 0.71,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.42,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-120",
    "strain": "Thai Mango",
    "type": "Hybrid",
    "thc": 18.52,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.12,
      "Limonene": 0.56,
      "Ocimene": 0,
      "Linalool": 0.04,
      "Myrcene": 0.22,
      "Terpinolene": 0.05,
      "Bisabolol": 0.04,
      "Pinene": 0.25,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-121",
    "strain": "That Badu",
    "type": "Hybrid",
    "thc": 20.95,
    "cbd": 0.1,
    "lineage": "Lemonchello x Jet Fuel Gelato",
    "terpenes": {
      "Caryophyllene": 0.08,
      "Humulene": 0.03,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.5,
      "Terpinolene": 0.02,
      "Bisabolol": 0.01,
      "Pinene": 0.12,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-122",
    "strain": "Amnesia OG",
    "type": "Hybrid",
    "thc": 30.65,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.08,
      "Limonene": 0.28,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.38,
      "Terpinolene": 0.7,
      "Bisabolol": 0,
      "Pinene": 0.13,
      "b-Pinene": 0.15
    },
    "state": "MD"
  },
  {
    "id": "MD-123",
    "strain": "Apollo 22",
    "type": "Hybrid",
    "thc": 26.92,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.44,
      "Humulene": 0.12,
      "Limonene": 0.55,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.46,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-124",
    "strain": "Banana Bubbles",
    "type": "Hybrid",
    "thc": 26.94,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.99,
      "Humulene": 0.24,
      "Limonene": 0.55,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.25,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-125",
    "strain": "Burnt Pineapple Haze",
    "type": "Hybrid",
    "thc": 30.62,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.24,
      "Humulene": 0.06,
      "Limonene": 0.15,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.39,
      "Terpinolene": 0.8,
      "Bisabolol": 0.1,
      "Pinene": 0.09,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-126",
    "strain": "Dark Cherry Cream",
    "type": "Hybrid",
    "thc": 20.16,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.07,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.37,
      "Myrcene": 0.26,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-127",
    "strain": "Dosidos #22-22",
    "type": "Indica",
    "thc": 24.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.77,
      "Humulene": 0.17,
      "Limonene": 0.38,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.31,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-128",
    "strain": "Dosi Love",
    "type": "Hybrid",
    "thc": 29.76,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.19,
      "Humulene": 0.29,
      "Limonene": 0.18,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 1.31,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 1.19,
      "b-Pinene": 0.23
    },
    "state": "MD"
  },
  {
    "id": "MD-129",
    "strain": "Gorilla Glue #4 ",
    "type": "Hybrid",
    "thc": 22.22,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.7,
      "Humulene": 0.19,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.23,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-130",
    "strain": "Guava Biscuits",
    "type": "Hybrid",
    "thc": 28.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.71,
      "Humulene": 0.22,
      "Limonene": 0.34,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 0.35,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.04,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-131",
    "strain": "Island Nectar",
    "type": "Hybrid",
    "thc": 27.79,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.12,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0.32,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.05,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-132",
    "strain": "Lava Lamp",
    "type": "Indica",
    "thc": 24.48,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.55,
      "Humulene": 0.18,
      "Limonene": 0.57,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.09,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-133",
    "strain": "Ocifer XX",
    "type": "Hybrid",
    "thc": 23.78,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.18,
      "Limonene": 0.13,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.15,
      "Terpinolene": 0.77,
      "Bisabolol": 0.09,
      "Pinene": 0.09,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-134",
    "strain": "Permanent Cherries",
    "type": "Hybrid",
    "thc": 21.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.08,
      "Limonene": 0.9,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.36,
      "Terpinolene": 0.01,
      "Bisabolol": 0.06,
      "Pinene": 0.11,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-135",
    "strain": "Poonesia",
    "type": "Hybrid",
    "thc": 28.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.33,
      "Humulene": 0.11,
      "Limonene": 0.15,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.63,
      "Terpinolene": 0.04,
      "Bisabolol": 0,
      "Pinene": 1.19,
      "b-Pinene": 0.22
    },
    "state": "MD"
  },
  {
    "id": "MD-136",
    "strain": "Scooby Snacks #2",
    "type": "Hybrid",
    "thc": 22.51,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.76,
      "Humulene": 0.19,
      "Limonene": 0.54,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0.17,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-137",
    "strain": "SFV OG x 8541",
    "type": "Hybrid",
    "thc": 27.22,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.17,
      "Limonene": 0.29,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.84,
      "Terpinolene": 0,
      "Bisabolol": 0.11,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-138",
    "strain": "Sugar Biscuits #9 ",
    "type": "Hybrid",
    "thc": 23.96,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.97,
      "Humulene": 0.33,
      "Limonene": 0.28,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.4,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.04,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-139",
    "strain": "Sugar Biscuit #9",
    "type": "Hybrid",
    "thc": 25.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.9,
      "Humulene": 0.29,
      "Limonene": 0.23,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-140",
    "strain": "Sundae Glaze",
    "type": "Hybrid",
    "thc": 25.9,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.88,
      "Humulene": 0.21,
      "Limonene": 1,
      "Ocimene": 0,
      "Linalool": 0.39,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.09,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-141",
    "strain": "Sundae Walker",
    "type": "Hybrid",
    "thc": 22.79,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.69,
      "Humulene": 0.17,
      "Limonene": 0.68,
      "Ocimene": 0,
      "Linalool": 0.34,
      "Myrcene": 0.36,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.07,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-142",
    "strain": "Sundae Walker #10",
    "type": "Hybrid",
    "thc": 26.09,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.97,
      "Humulene": 0.23,
      "Limonene": 0.67,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.64,
      "Terpinolene": 0,
      "Bisabolol": 0.12,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-143",
    "strain": "Zest Bomb",
    "type": "Hybrid",
    "thc": 21.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.06,
      "Limonene": 0.32,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-144",
    "strain": "Kush Lato",
    "type": "Hybrid",
    "thc": 28.71,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.12,
      "Limonene": 0.64,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 0.34,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-145",
    "strain": "Pink Certz",
    "type": "Hybrid",
    "thc": 28.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.76,
      "Humulene": 0.18,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.17,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.04,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-146",
    "strain": "Frosting",
    "type": "Indica",
    "thc": 22.88,
    "cbd": 0.1,
    "lineage": "Purple Urkel x Cherry Pie",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.12,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.3,
      "Terpinolene": 0.01,
      "Bisabolol": 0.1,
      "Pinene": 0.1,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-147",
    "strain": "Fuji",
    "type": "Hybrid",
    "thc": 24.72,
    "cbd": 0.1,
    "lineage": "Larry OG x Kurple Fantasy",
    "terpenes": {
      "Caryophyllene": 0.36,
      "Humulene": 0.11,
      "Limonene": 1.01,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.37,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-148",
    "strain": "Gascotti",
    "type": "Indica",
    "thc": 23.84,
    "cbd": 0.1,
    "lineage": "Biscotti x another undisclosed strain",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.11,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.28,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-149",
    "strain": "Lush Mintz ",
    "type": "Indica",
    "thc": 25.95,
    "cbd": 0.1,
    "lineage": "Kush Mintz x (F1 Durb x Gushers)",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.11,
      "Limonene": 0.85,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 0.12,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-150",
    "strain": "Margie",
    "type": "Hybrid",
    "thc": 24.18,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.99,
      "Humulene": 0.31,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-151",
    "strain": "Midnight Climax",
    "type": "Hybrid",
    "thc": 30.87,
    "cbd": 0.1,
    "lineage": "MK Ultra with Raven",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.07,
      "Limonene": 0.34,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.14,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-152",
    "strain": "Sour Cream",
    "type": "Hybrid",
    "thc": 24.44,
    "cbd": 0.1,
    "lineage": "G13 Haze x Sour Diesel",
    "terpenes": {
      "Caryophyllene": 0.16,
      "Humulene": 0.05,
      "Limonene": 0.31,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 1.23,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-153",
    "strain": "Stargate",
    "type": "Hybrid",
    "thc": 25.82,
    "cbd": 0.1,
    "lineage": "MK Ultra x Raven",
    "terpenes": {
      "Caryophyllene": 0.54,
      "Humulene": 0.13,
      "Limonene": 0.34,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.83,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-154",
    "strain": "Tropicana Banana ",
    "type": "Hybrid",
    "thc": 27.24,
    "cbd": 0.1,
    "lineage": "Tropicana x Banana Kush",
    "terpenes": {
      "Caryophyllene": 0.33,
      "Humulene": 0.09,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.39,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-155",
    "strain": "Beach Cake",
    "type": "Hybrid",
    "thc": 24.31,
    "cbd": 0.1,
    "lineage": "Florida Cake x TK",
    "terpenes": {
      "Caryophyllene": 1.2,
      "Humulene": 0.41,
      "Limonene": 0.55,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.34,
      "Terpinolene": 0,
      "Bisabolol": 0.11,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-156",
    "strain": "Berry Payton",
    "type": "Hybrid",
    "thc": 17.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.07,
      "Limonene": 0.27,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-157",
    "strain": "Cherry Chem",
    "type": "Indica",
    "thc": 19.98,
    "cbd": 0.1,
    "lineage": "Cherry Pie x Chem 2",
    "terpenes": {
      "Caryophyllene": 1.48,
      "Humulene": 0.39,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0.22,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-158",
    "strain": "Cherry Limeade Cake",
    "type": "Hybrid",
    "thc": 22.12,
    "cbd": 0.1,
    "lineage": "ICC x Gelato 33 x Cherry Limeade",
    "terpenes": {
      "Caryophyllene": 0.66,
      "Humulene": 0.15,
      "Limonene": 0.87,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.08,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.2,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-159",
    "strain": "Florida Wedding",
    "type": "Hybrid",
    "thc": 25.38,
    "cbd": 0.1,
    "lineage": "Wedding Cake x Triangle Kush",
    "terpenes": {
      "Caryophyllene": 0.98,
      "Humulene": 0.24,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-160",
    "strain": "Lemon Royale",
    "type": "Sativa",
    "thc": 26.2,
    "cbd": 0.1,
    "lineage": "Lemon Tree x (GMO x Triangle Kush)",
    "terpenes": {
      "Caryophyllene": 0.8,
      "Humulene": 0.31,
      "Limonene": 0.44,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.14,
      "Terpinolene": 0,
      "Bisabolol": 0.17,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-161",
    "strain": "OG Kush ",
    "type": "Hybrid",
    "thc": 32.29,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.3,
      "Humulene": 0.09,
      "Limonene": 0.13,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-162",
    "strain": "Pave",
    "type": "Hybrid",
    "thc": 23.88,
    "cbd": 0.1,
    "lineage": "Paris OG x The Menthol",
    "terpenes": {
      "Caryophyllene": 0.51,
      "Humulene": 0.14,
      "Limonene": 0.36,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.07,
      "Terpinolene": 0.02,
      "Bisabolol": 0.07,
      "Pinene": 0.09,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-163",
    "strain": "Spritzer",
    "type": "Hybrid",
    "thc": 23,
    "cbd": 0.1,
    "lineage": "Runtz x Grape Pie x MAC",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.14,
      "Limonene": 0.44,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.11,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-164",
    "strain": "Deadband #12",
    "type": "Hybrid",
    "thc": 24.66,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.41,
      "Humulene": 0.14,
      "Limonene": 0.29,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 1.65,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-165",
    "strain": "Funky Guava",
    "type": "Hybrid",
    "thc": 30.15,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.75,
      "Humulene": 0.2,
      "Limonene": 0.54,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.46,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-166",
    "strain": "Gumi 6 (Jelly Zonuts x Zoda)",
    "type": "Hybrid",
    "thc": 24.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.38,
      "Humulene": 0.09,
      "Limonene": 0.67,
      "Ocimene": 0,
      "Linalool": 0.21,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.14,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-167",
    "strain": "Huckleberry Soda #5",
    "type": "Hybrid",
    "thc": 29.03,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.16,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-168",
    "strain": "Ice Cream Cake",
    "type": "Indica",
    "thc": 27.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.76,
      "Humulene": 0.24,
      "Limonene": 0.84,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.16,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-169",
    "strain": "Lemon Cherry Gelato",
    "type": "Hybrid",
    "thc": 31.45,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.12,
      "Limonene": 1.12,
      "Ocimene": 0,
      "Linalool": 0.59,
      "Myrcene": 0.96,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.09,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-170",
    "strain": "Midnight Circus",
    "type": "Hybrid",
    "thc": 21.77,
    "cbd": 0.1,
    "lineage": "Purple Kush X Lemon Skunk",
    "terpenes": {
      "Caryophyllene": 1.3,
      "Humulene": 0.41,
      "Limonene": 0.96,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.16,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-171",
    "strain": "Peach Runtz (Georgia Pie x Runtz)",
    "type": "Hybrid",
    "thc": 25.89,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.15,
      "Humulene": 0.04,
      "Limonene": 0.36,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 1.69,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-172",
    "strain": "Rainbow Push Pop #4",
    "type": "Hybrid",
    "thc": 26.53,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.64,
      "Humulene": 0.23,
      "Limonene": 0.54,
      "Ocimene": 0,
      "Linalool": 0.34,
      "Myrcene": 0.1,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-173",
    "strain": "Red Zushi",
    "type": "Hybrid",
    "thc": 26.24,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.13,
      "Limonene": 0.62,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.28,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-174",
    "strain": "Sunset Octane",
    "type": "Hybrid",
    "thc": 26.47,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.79,
      "Humulene": 0.19,
      "Limonene": 0.78,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.56,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-175",
    "strain": "Thai-Ger King",
    "type": "Sativa",
    "thc": 24.43,
    "cbd": 0.1,
    "lineage": "Golden Tiger x Airborne Skunk",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.09,
      "Limonene": 0.19,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 1.42,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-176",
    "strain": "GMO Empire ",
    "type": "Indica",
    "thc": 27.97,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.55,
      "Humulene": 0.18,
      "Limonene": 1.03,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.18,
      "Terpinolene": 0.02,
      "Bisabolol": 0.05,
      "Pinene": 0.08,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-177",
    "strain": "Kush Mintz",
    "type": "Indica",
    "thc": 28.35,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.53,
      "Humulene": 0.13,
      "Limonene": 0.76,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.24,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-178",
    "strain": "Boston Tea Party ",
    "type": "Hybrid",
    "thc": 26.03,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.66,
      "Humulene": 0.27,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.1,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-179",
    "strain": "Bubble Bath",
    "type": "Indica",
    "thc": 28.78,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.51,
      "Humulene": 0.2,
      "Limonene": 0.51,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.04,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-180",
    "strain": "Cake Mintz ",
    "type": "Indica",
    "thc": 25.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.11,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.2,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-181",
    "strain": "Driz Nipper",
    "type": "Hybrid",
    "thc": 26.16,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.37,
      "Humulene": 0.11,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.11,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-182",
    "strain": "E85 Candi",
    "type": "Hybrid",
    "thc": 23.89,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.19,
      "Humulene": 0.05,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.1,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.13,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-183",
    "strain": "Grandi Runtz",
    "type": "Hybrid",
    "thc": 25.53,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.16,
      "Humulene": 0.05,
      "Limonene": 0.87,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.31,
      "Terpinolene": 0.03,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-184",
    "strain": "Guavanade",
    "type": "Hybrid",
    "thc": 21.18,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.43,
      "Humulene": 0.14,
      "Limonene": 0.54,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.12,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-185",
    "strain": "Hoe Down",
    "type": "Hybrid",
    "thc": 25.17,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.12,
      "Limonene": 0.36,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-186",
    "strain": "Spiked Peach",
    "type": "Hybrid",
    "thc": 25.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.45,
      "Humulene": 0.15,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.08,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-187",
    "strain": "Half Moonana",
    "type": "Hybrid",
    "thc": 24.11,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.07,
      "Limonene": 0.74,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.28,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-188",
    "strain": "Mimosa Kush Mints",
    "type": "Hybrid",
    "thc": 25.28,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.11,
      "Limonene": 0.64,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.35,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-189",
    "strain": "Orange Z ",
    "type": "Hybrid",
    "thc": 20.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.3,
      "Humulene": 0.07,
      "Limonene": 0.43,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.4,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.09,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-190",
    "strain": "Tropicanna Banana",
    "type": "Hybrid",
    "thc": 24.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.7,
      "Humulene": 0.18,
      "Limonene": 0.27,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.62,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.02,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-191",
    "strain": "Wrong Holler",
    "type": "Hybrid",
    "thc": 22.33,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.64,
      "Humulene": 0.15,
      "Limonene": 0.31,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-192",
    "strain": "LA Baker",
    "type": "Indica",
    "thc": 26.22,
    "cbd": 0.1,
    "lineage": "LA Kush Cake x Jungle Cake",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.08,
      "Limonene": 0.83,
      "Ocimene": 0,
      "Linalool": 0.47,
      "Myrcene": 0.58,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.12,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-193",
    "strain": "Swamp Water Fumez",
    "type": "Hybrid",
    "thc": 25.05,
    "cbd": 0.1,
    "lineage": "OGKB 2",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.19,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.51,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-194",
    "strain": "410 Fuel",
    "type": "Hybrid",
    "thc": 25.95,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.45,
      "Humulene": 0.16,
      "Limonene": 0.29,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.77,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-195",
    "strain": "Farmhouse Crumble",
    "type": "Hybrid",
    "thc": 21.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.7,
      "Humulene": 0.19,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.2,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-196",
    "strain": "Sun Squeezed",
    "type": "Hybrid",
    "thc": 28.45,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.01,
      "Humulene": 0.26,
      "Limonene": 0.26,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0.13,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-197",
    "strain": "Underground Reserve",
    "type": "Hybrid",
    "thc": 25.64,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.53,
      "Humulene": 0.13,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0.11,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-198",
    "strain": "Astro GMO",
    "type": "Hybrid",
    "thc": 26.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.37,
      "Humulene": 0.12,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.53,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-199",
    "strain": "Blue Lobster",
    "type": "Hybrid",
    "thc": 22.16,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.06,
      "Limonene": 0.59,
      "Ocimene": 0,
      "Linalool": 0.26,
      "Myrcene": 0.14,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-200",
    "strain": "Cap Junky",
    "type": "Hybrid",
    "thc": 24.97,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.66,
      "Humulene": 0.16,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.34,
      "Myrcene": 0.17,
      "Terpinolene": 0,
      "Bisabolol": 0.13,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-201",
    "strain": "Cheddar Cheeze",
    "type": "Hybrid",
    "thc": 25.6,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.11,
      "Humulene": 0.04,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.25,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-202",
    "strain": "Floral Frost",
    "type": "Hybrid",
    "thc": 27.38,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.26,
      "Humulene": 0.4,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 0.8,
      "Terpinolene": 0,
      "Bisabolol": 0.15,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-203",
    "strain": "Hickory Hash",
    "type": "Hybrid",
    "thc": 26.05,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.36,
      "Humulene": 0.11,
      "Limonene": 0.68,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.26,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-204",
    "strain": "Pillow Mints",
    "type": "Hybrid",
    "thc": 28.4,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.19,
      "Limonene": 0.94,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.66,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.08,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-205",
    "strain": "Tarts",
    "type": "Hybrid",
    "thc": 26.56,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.69,
      "Humulene": 0.22,
      "Limonene": 0.8,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.67,
      "Terpinolene": 0.02,
      "Bisabolol": 0.12,
      "Pinene": 0.07,
      "b-Pinene": 0.1
    },
    "state": "MD"
  },
  {
    "id": "MD-206",
    "strain": "Titan Express",
    "type": "Hybrid",
    "thc": 25.89,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.41,
      "Humulene": 0.12,
      "Limonene": 0.11,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.23,
      "Terpinolene": 0.93,
      "Bisabolol": 0.08,
      "Pinene": 0.08,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-207",
    "strain": "Triple Stack",
    "type": "Indica",
    "thc": 28,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.61,
      "Humulene": 0.14,
      "Limonene": 0.43,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-208",
    "strain": "Watermelon Cakez",
    "type": "Hybrid",
    "thc": 25.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.81,
      "Humulene": 0.24,
      "Limonene": 0.34,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.73,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-210",
    "strain": "Reserve Electric Berry Bliss",
    "type": "Hybrid",
    "thc": 27.63,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.11,
      "Limonene": 1.09,
      "Ocimene": 0,
      "Linalool": 0.47,
      "Myrcene": 0.11,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.29,
      "b-Pinene": 0.2
    },
    "state": "MD"
  },
  {
    "id": "MD-211",
    "strain": "WildFlower Intergalactic",
    "type": "Indica",
    "thc": 28.87,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.06,
      "Limonene": 0.88,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.91,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.18,
      "b-Pinene": 0.17
    },
    "state": "MD"
  },
  {
    "id": "MD-212",
    "strain": "Reserve Intergalactic",
    "type": "Indica",
    "thc": 27.78,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.13,
      "Humulene": 0.04,
      "Limonene": 0.76,
      "Ocimene": 0,
      "Linalool": 0.03,
      "Myrcene": 1.1,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.08,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-213",
    "strain": "Premium Jack Herer",
    "type": "Sativa",
    "thc": 25.65,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.18,
      "Humulene": 0.05,
      "Limonene": 0.19,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.36,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.69,
      "b-Pinene": 0.17
    },
    "state": "MD"
  },
  {
    "id": "MD-214",
    "strain": "Reserve Member Berry",
    "type": "Hybrid",
    "thc": 28.01,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.07,
      "Limonene": 0.84,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.17,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-215",
    "strain": "Premium Member Berry",
    "type": "Hybrid",
    "thc": 25.21,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.1,
      "Limonene": 1.16,
      "Ocimene": 0,
      "Linalool": 0.37,
      "Myrcene": 0.34,
      "Terpinolene": 0.04,
      "Bisabolol": 0,
      "Pinene": 0.19,
      "b-Pinene": 0.18
    },
    "state": "MD"
  },
  {
    "id": "MD-216",
    "strain": "Purple Koala",
    "type": "Indica",
    "thc": 32.12,
    "cbd": 0.1,
    "lineage": "",
    "terpenes": {
      "Caryophyllene": 0.54,
      "Humulene": 0.15,
      "Limonene": 0.67,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.14,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-217",
    "strain": "Starburst",
    "type": "Hybrid",
    "thc": 28.45,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.61,
      "Humulene": 0.28,
      "Limonene": 0.49,
      "Ocimene": 0,
      "Linalool": 0.3,
      "Myrcene": 0.62,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-218",
    "strain": "Sweet Cinnamon Octane",
    "type": "Hybrid",
    "thc": 25.52,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.1,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.17,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-219",
    "strain": "Oreoz",
    "type": "Hybrid",
    "thc": 26.36,
    "cbd": 0.1,
    "lineage": "Secret Weapon x Cookies x Cream",
    "terpenes": {
      "Caryophyllene": 0.63,
      "Humulene": 0.2,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-220",
    "strain": "Grape Mochi I",
    "type": "Hybrid",
    "thc": 40.52,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.1,
      "Humulene": 0.04,
      "Limonene": 0.05,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "MD"
  },
  {
    "id": "MD-221",
    "strain": "Grape Noir",
    "type": "Hybrid",
    "thc": 39.8,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.48,
      "Humulene": 0.15,
      "Limonene": 0.1,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.16,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0
    },
    "state": "MD"
  },
  {
    "id": "MD-222",
    "strain": "Orange Kush Mints",
    "type": "Hybrid",
    "thc": 44.44,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.1,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.13,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.02,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-223",
    "strain": "Private Reserve OG",
    "type": "Hybrid",
    "thc": 45.74,
    "cbd": 0.1,
    "lineage": "OG Kush x Skunk Haze",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.1,
      "Limonene": 0.14,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.1,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0,
      "b-Pinene": 0.01
    },
    "state": "MD"
  },
  {
    "id": "MD-224",
    "strain": "Rain Drops",
    "type": "Indica",
    "thc": 45.91,
    "cbd": 0.1,
    "lineage": "OG Kush x Hash Plant x Bubba Kush",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.07,
      "Limonene": 0.17,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.04,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0.01
    },
    "state": "MD"
  },
  {
    "id": "MD-225",
    "strain": "Red Velvet Kush",
    "type": "Hybrid",
    "thc": 26.82,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.13,
      "Limonene": 0.38,
      "Ocimene": 0,
      "Linalool": 0.18,
      "Myrcene": 0.18,
      "Terpinolene": 0.02,
      "Bisabolol": 0.05,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-226",
    "strain": "95 Tang",
    "type": "Hybrid",
    "thc": 24.76,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.08,
      "Limonene": 0.09,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.01,
      "b-Pinene": 0.02
    },
    "state": "MD"
  },
  {
    "id": "MD-227",
    "strain": "Cherry Pie",
    "type": "Hybrid",
    "thc": 24.3,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0.08,
      "Limonene": 0.19,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.21,
      "Terpinolene": 0.93,
      "Bisabolol": 0,
      "Pinene": 0.13,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-228",
    "strain": "Head Hunter",
    "type": "Hybrid",
    "thc": 24.97,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.52,
      "Humulene": 0.17,
      "Limonene": 1.07,
      "Ocimene": 0,
      "Linalool": 0.38,
      "Myrcene": 0.12,
      "Terpinolene": 0.02,
      "Bisabolol": 0.02,
      "Pinene": 0.26,
      "b-Pinene": 0.23
    },
    "state": "MD"
  },
  {
    "id": "MD-229",
    "strain": "Panlato",
    "type": "Hybrid",
    "thc": 23.77,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.71,
      "Humulene": 0.2,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-230",
    "strain": "Cherry Slushee",
    "type": "Hybrid",
    "thc": 25.9,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.29,
      "Humulene": 0.08,
      "Limonene": 0.17,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 1.5,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.23,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-231",
    "strain": "Dino Bites",
    "type": "Indica",
    "thc": 27.26,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.17,
      "Humulene": 0.05,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 1.51,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-232",
    "strain": "Guava Cream Cake",
    "type": "Hybrid",
    "thc": 26.92,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.64,
      "Humulene": 0.15,
      "Limonene": 0.26,
      "Ocimene": 0,
      "Linalool": 0.3,
      "Myrcene": 0.46,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-233",
    "strain": "Ice Cream Banger",
    "type": "Hybrid",
    "thc": 28.74,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.14,
      "Limonene": 0.81,
      "Ocimene": 0,
      "Linalool": 0.37,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.1
    },
    "state": "MD"
  },
  {
    "id": "MD-234",
    "strain": "Lemon Cherry Sherbert",
    "type": "Hybrid",
    "thc": 29.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.97,
      "Humulene": 0.22,
      "Limonene": 0.83,
      "Ocimene": 0,
      "Linalool": 0.38,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-235",
    "strain": "Loud Cake ",
    "type": "Hybrid",
    "thc": 25.15,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.09,
      "Limonene": 0.59,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.12,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.09,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-236",
    "strain": "Palisades Mintz",
    "type": "Hybrid",
    "thc": 25.77,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.45,
      "Humulene": 0.12,
      "Limonene": 0.79,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.56,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-237",
    "strain": "PB Souffle",
    "type": "Indica",
    "thc": 26.21,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.12,
      "Limonene": 0.47,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.31,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-238",
    "strain": "SKYWALKER 11",
    "type": "Hybrid",
    "thc": 26.06,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.11,
      "Limonene": 0.78,
      "Ocimene": 0,
      "Linalool": 0.49,
      "Myrcene": 0.62,
      "Terpinolene": 0.02,
      "Bisabolol": 0.05,
      "Pinene": 0.06,
      "b-Pinene": 0.1
    },
    "state": "MD"
  },
  {
    "id": "MD-239",
    "strain": "Groovy Diesel",
    "type": "Hybrid",
    "thc": 23.69,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.67,
      "Humulene": 0.15,
      "Limonene": 0.61,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.68,
      "Terpinolene": 0.01,
      "Bisabolol": 0.14,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-240",
    "strain": "Animal Mint Cookies",
    "type": "Hybrid",
    "thc": 26.5,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.1,
      "Limonene": 0.72,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.07,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.2,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-241",
    "strain": "Strawberry Jelly",
    "type": "Hybrid",
    "thc": 22.96,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.34,
      "Humulene": 0.09,
      "Limonene": 0.32,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.6,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-242",
    "strain": "Boss Lady",
    "type": "Hybrid",
    "thc": 29.1,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.14,
      "Limonene": 0.36,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-243",
    "strain": "Bravado",
    "type": "Hybrid",
    "thc": 25.43,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.34,
      "Humulene": 0.11,
      "Limonene": 0.88,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.18,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-244",
    "strain": "Black Cherry Gelato ",
    "type": "Hybrid",
    "thc": 22.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.08,
      "Limonene": 0.57,
      "Ocimene": 0,
      "Linalool": 0.43,
      "Myrcene": 0.61,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-245",
    "strain": "Bubblegum Biscotti",
    "type": "Hybrid",
    "thc": 24.28,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.94,
      "Humulene": 0.21,
      "Limonene": 0.45,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-246",
    "strain": "Biscotti ",
    "type": "Hybrid",
    "thc": 26.29,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.95,
      "Humulene": 0.22,
      "Limonene": 0.89,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0.19,
      "Pinene": 0.19,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-247",
    "strain": "Cold Fusion",
    "type": "Indica",
    "thc": 26.74,
    "cbd": 0.1,
    "lineage": ": Five Stars x The Menthol",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.13,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.49,
      "Terpinolene": 0.63,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-248",
    "strain": "Fiji Sunset",
    "type": "Hybrid",
    "thc": 27.02,
    "cbd": 0.1,
    "lineage": ": Glazed Apricot Gelato x Grape Gasoline",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.07,
      "Limonene": 0.71,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.16,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.09,
      "b-Pinene": 0.1
    },
    "state": "MD"
  },
  {
    "id": "MD-249",
    "strain": "Gruntz",
    "type": "Hybrid",
    "thc": 25.08,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.15,
      "Limonene": 0.28,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.14,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-250",
    "strain": "Moon Boots",
    "type": "Hybrid",
    "thc": 26.06,
    "cbd": 0.1,
    "lineage": ": White Tahoe Cookies x Moon Bow",
    "terpenes": {
      "Caryophyllene": 0.61,
      "Humulene": 0.22,
      "Limonene": 0.32,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.36,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.02,
      "b-Pinene": 0.04
    },
    "state": "MD"
  },
  {
    "id": "MD-251",
    "strain": "Tropical Fusion ",
    "type": "Indica",
    "thc": 25.41,
    "cbd": 0.1,
    "lineage": ": Pineapple Zoz x Moonbow 75",
    "terpenes": {
      "Caryophyllene": 0.38,
      "Humulene": 0.1,
      "Limonene": 0.46,
      "Ocimene": 0,
      "Linalool": 0.38,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-252",
    "strain": "Kandy Jack",
    "type": "Hybrid",
    "thc": 19.04,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.36,
      "Humulene": 0.13,
      "Limonene": 0.2,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.09,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-253",
    "strain": "Blackberry OG",
    "type": "Hybrid",
    "thc": 21.83,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.12,
      "Limonene": 0.07,
      "Ocimene": 0,
      "Linalool": 0.02,
      "Myrcene": 0.23,
      "Terpinolene": 0.45,
      "Bisabolol": 0.02,
      "Pinene": 0.07,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-254",
    "strain": "Sky Lotus",
    "type": "Hybrid",
    "thc": 23.71,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.11,
      "Limonene": 0.44,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.08,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.13,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-255",
    "strain": "California #10",
    "type": "Hybrid",
    "thc": 23.25,
    "cbd": 0.1,
    "lineage": "Kush Mintz x Alien Cookies",
    "terpenes": {
      "Caryophyllene": 0.72,
      "Humulene": 0.17,
      "Limonene": 0.34,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.07,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-256",
    "strain": "Duct Tape",
    "type": "Indica",
    "thc": 23.42,
    "cbd": 0.1,
    "lineage": "Original Glue x Do-Si-Dos",
    "terpenes": {
      "Caryophyllene": 0.63,
      "Humulene": 0.16,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-257",
    "strain": "Garlic Breath",
    "type": "Indica",
    "thc": 24.46,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.1,
      "Limonene": 0.55,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.15,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.06,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-258",
    "strain": "Glitterbomb",
    "type": "Indica",
    "thc": 23.85,
    "cbd": 0.1,
    "lineage": "Gas x OG Kush Breath x Blueberry Headband",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.07,
      "Limonene": 0.16,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 1.11,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MD"
  },
  {
    "id": "MD-259",
    "strain": "Alien Mints",
    "type": "Hybrid",
    "thc": 32.69,
    "cbd": 0.1,
    "lineage": "Alien Cookies x Kush Mints",
    "terpenes": {
      "Caryophyllene": 0.43,
      "Humulene": 0.13,
      "Limonene": 0.27,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.14,
      "Terpinolene": 0.31,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-260",
    "strain": "Compound Z",
    "type": "Indica",
    "thc": 36.32,
    "cbd": 0.1,
    "lineage": "White Runtz x Apple",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.16,
      "Limonene": 0.46,
      "Ocimene": 0,
      "Linalool": 0.44,
      "Myrcene": 0.13,
      "Terpinolene": 0.03,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-261",
    "strain": "Highaleah",
    "type": "Sativa",
    "thc": 28.25,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.08,
      "Humulene": 0.03,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.74,
      "Terpinolene": 1.25,
      "Bisabolol": 0,
      "Pinene": 0.16,
      "b-Pinene": 0.2
    },
    "state": "MD"
  },
  {
    "id": "MD-262",
    "strain": "INFINITY LINX",
    "type": "Sativa",
    "thc": 24.75,
    "cbd": 0.1,
    "lineage": "Cap Junky x Cuban Linx",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.09,
      "Limonene": 0.27,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.26,
      "Terpinolene": 1.12,
      "Bisabolol": 0,
      "Pinene": 0.14,
      "b-Pinene": 0.15
    },
    "state": "MD"
  },
  {
    "id": "MD-263",
    "strain": "Juicee J",
    "type": "Hybrid",
    "thc": 34.29,
    "cbd": 0.1,
    "lineage": "Cap Junky (AKA Alien Mints) x Jealousy",
    "terpenes": {
      "Caryophyllene": 0.41,
      "Humulene": 0.14,
      "Limonene": 0.28,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.15,
      "Terpinolene": 0.29,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.06
    },
    "state": "MD"
  },
  {
    "id": "MD-264",
    "strain": "Pineapple Express ",
    "type": "Sativa",
    "thc": 33.81,
    "cbd": 0.1,
    "lineage": "Trainwreck x Hawaiian",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.19,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0.37,
      "Myrcene": 0.06,
      "Terpinolene": 0.07,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-265",
    "strain": "Banana Puddintain",
    "type": "Hybrid",
    "thc": 30.5,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.5,
      "Humulene": 0.18,
      "Limonene": 0.77,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.97,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.06,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-266",
    "strain": "Chem de la Chem",
    "type": "Hybrid",
    "thc": 28.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.78,
      "Humulene": 0.35,
      "Limonene": 0.89,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.89,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.07,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-267",
    "strain": "GMO x Skywalker OG",
    "type": "Indica",
    "thc": 30.65,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.16,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.49,
      "Terpinolene": 0.01,
      "Bisabolol": 0.03,
      "Pinene": 0.05,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-268",
    "strain": "Golden Pineapple",
    "type": "Sativa",
    "thc": 25.15,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.15,
      "Humulene": 0.03,
      "Limonene": 0.25,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.36,
      "Terpinolene": 1.51,
      "Bisabolol": 0.01,
      "Pinene": 0.09,
      "b-Pinene": 0.16
    },
    "state": "MD"
  },
  {
    "id": "MD-269",
    "strain": "Gush Mints",
    "type": "Hybrid",
    "thc": 31.07,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.62,
      "Humulene": 0.18,
      "Limonene": 0.75,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.15,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.13
    },
    "state": "MD"
  },
  {
    "id": "MD-270",
    "strain": "Peach Crescendo",
    "type": "Hybrid",
    "thc": 26.77,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.59,
      "Humulene": 0.25,
      "Limonene": 1,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.38,
      "Terpinolene": 0.02,
      "Bisabolol": 0.04,
      "Pinene": 0.13,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-271",
    "strain": "Pebblewreck",
    "type": "Hybrid",
    "thc": 22.69,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.33,
      "Humulene": 0.14,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.25,
      "Terpinolene": 0.01,
      "Bisabolol": 0.04,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-272",
    "strain": "Permanent Marker",
    "type": "Hybrid",
    "thc": 22.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.53,
      "Humulene": 0.15,
      "Limonene": 0.68,
      "Ocimene": 0,
      "Linalool": 0.39,
      "Myrcene": 0.07,
      "Terpinolene": 0.01,
      "Bisabolol": 0.04,
      "Pinene": 0.13,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-273",
    "strain": "Purple Punch",
    "type": "Indica",
    "thc": 26.31,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.03,
      "Humulene": 0.45,
      "Limonene": 1.02,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.44,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.08,
      "b-Pinene": 0.17
    },
    "state": "MD"
  },
  {
    "id": "MD-274",
    "strain": "SDG OG",
    "type": "Indica",
    "thc": 26.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.99,
      "Humulene": 0.31,
      "Limonene": 0.61,
      "Ocimene": 0,
      "Linalool": 0.2,
      "Myrcene": 0.78,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.06,
      "b-Pinene": 0.1
    },
    "state": "MD"
  },
  {
    "id": "MD-275",
    "strain": "Strawberry Candy #4",
    "type": "Hybrid",
    "thc": 26.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.08,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.5,
      "Terpinolene": 0.03,
      "Bisabolol": 0.02,
      "Pinene": 0.05,
      "b-Pinene": 0.05
    },
    "state": "MD"
  },
  {
    "id": "MD-276",
    "strain": "Sunshine #4",
    "type": "Hybrid",
    "thc": 29.86,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.41,
      "Humulene": 0.13,
      "Limonene": 0.84,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.82,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.11,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-277",
    "strain": "Beaver Cookies",
    "type": "Hybrid",
    "thc": 25.66,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.21,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.25,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.12
    },
    "state": "MD"
  },
  {
    "id": "MD-278",
    "strain": "Berried Alive",
    "type": "Hybrid",
    "thc": 26.53,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.66,
      "Humulene": 0.23,
      "Limonene": 0.65,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.31,
      "Terpinolene": 0,
      "Bisabolol": 0.01,
      "Pinene": 0.36,
      "b-Pinene": 0.15
    },
    "state": "MD"
  },
  {
    "id": "MD-279",
    "strain": "Commando",
    "type": "Hybrid",
    "thc": 25.58,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.09,
      "Limonene": 1.13,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 0.11,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.76,
      "b-Pinene": 0.35
    },
    "state": "MD"
  },
  {
    "id": "MD-280",
    "strain": "Falcon 9",
    "type": "Indica",
    "thc": 24.02,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.15,
      "Limonene": 0.45,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.18,
      "b-Pinene": 0.11
    },
    "state": "MD"
  },
  {
    "id": "MD-281",
    "strain": "The Cut",
    "type": "Hybrid",
    "thc": 26.32,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.57,
      "Humulene": 0.13,
      "Limonene": 0.88,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.06,
      "Terpinolene": 0.04,
      "Bisabolol": 0,
      "Pinene": 0.19,
      "b-Pinene": 0.16
    },
    "state": "MD"
  },
  {
    "id": "MD-282",
    "strain": "Banana Punch",
    "type": "Hybrid",
    "thc": 30.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.49,
      "Humulene": 0.12,
      "Limonene": 0.72,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.47,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MD"
  },
  {
    "id": "MD-283",
    "strain": "Pound For Pound Cake",
    "type": "Hybrid",
    "thc": 22.96,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.65,
      "Humulene": 0.22,
      "Limonene": 1.12,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 0.07,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.13,
      "b-Pinene": 0.14
    },
    "state": "MD"
  },
  {
    "id": "MD-284",
    "strain": "THE TOAD",
    "type": "Hybrid",
    "thc": 27.83,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.09,
      "Limonene": 0.66,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.32,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MD"
  },
  {
    "id": "MD-285",
    "strain": "Boston Cream",
    "type": "Indica",
    "thc": 28.65,
    "cbd": 0.1,
    "lineage": ": Headband x CDLC",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.09,
      "Limonene": 0.61,
      "Ocimene": 0,
      "Linalool": 0.3,
      "Myrcene": 0.95,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  },
  {
    "id": "MD-286",
    "strain": "Charm City Kush",
    "type": "Indica",
    "thc": 27.84,
    "cbd": 0.1,
    "lineage": ": Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.17,
      "Limonene": 0.67,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.48,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MD"
  }
],

MA : [
  {
    "id": "MA-100",
    "strain": "Xeno",
    "type": "Indica",
    "thc": 28.67,
    "cbd": 0.1,
    "lineage": "Kush Mints x ZKZ",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0.17,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.19,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.06,
      "b-Pinene": 0.11
    },
    "state": "MA"
  },
  {
    "id": "MA-101",
    "strain": "Blueberry Shortcake",
    "type": "Hybrid",
    "thc": 20.37,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.34,
      "Humulene": 0.11,
      "Limonene": 0.12,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.69,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.53,
      "b-Pinene": 0.22
    },
    "state": "MA"
  },
  {
    "id": "MA-102",
    "strain": "Cereal Milk #1",
    "type": "Hybrid",
    "thc": 20.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.15,
      "Limonene": 0.65,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.11,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.18,
      "b-Pinene": 0.12
    },
    "state": "MA"
  },
  {
    "id": "MA-103",
    "strain": "Donut Trip",
    "type": "Hybrid",
    "thc": 20.93,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.2,
      "Humulene": 0.09,
      "Limonene": 0.38,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.12,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MA"
  },
  {
    "id": "MA-104",
    "strain": "Durban Z",
    "type": "Sativa",
    "thc": 0,
    "cbd": 0.1,
    "lineage": "Z x Durban Poison",
    "terpenes": {
      "Caryophyllene": 0.2,
      "Humulene": 0.07,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.24,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.08,
      "b-Pinene": 0.11
    },
    "state": "MA"
  },
  {
    "id": "MA-105",
    "strain": "Fantasy MelonZ",
    "type": "Hybrid",
    "thc": 18.75,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.3,
      "Humulene": 0.09,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.02,
      "Myrcene": 0.09,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.21,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-106",
    "strain": "Gazzurple",
    "type": "Sativa",
    "thc": 20.7,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.11,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "MA"
  },
  {
    "id": "MA-107",
    "strain": "Lemon Fresh",
    "type": "Sativa",
    "thc": 22.91,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.12,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.4,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.08,
      "b-Pinene": 0.11
    },
    "state": "MA"
  },
  {
    "id": "MA-108",
    "strain": "Living Legend",
    "type": "Sativa",
    "thc": 23.1,
    "cbd": 0.1,
    "lineage": "24K x OG Fruit Smoothie",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.11,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.11,
      "b-Pinene": 0.17
    },
    "state": "MA"
  },
  {
    "id": "MA-109",
    "strain": "Mega Lato",
    "type": "Hybrid",
    "thc": 27.55,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.07,
      "Humulene": 0.04,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.04,
      "Myrcene": 0.62,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.12
    },
    "state": "MA"
  },
  {
    "id": "MA-110",
    "strain": "Regina George",
    "type": "Hybrid",
    "thc": 17.86,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.33,
      "Humulene": 0.1,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MA"
  },
  {
    "id": "MA-111",
    "strain": "Confidential Cherries",
    "type": "Indica",
    "thc": 23.21,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.21,
      "Humulene": 0.07,
      "Limonene": 0.14,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.11,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.02,
      "b-Pinene": 0.03
    },
    "state": "MA"
  },
  {
    "id": "MA-112",
    "strain": "Creamsicle Sunset",
    "type": "Hybrid",
    "thc": 14.99,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.96,
      "Humulene": 0.31,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.16,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-113",
    "strain": "Hash Burger ",
    "type": "Hybrid",
    "thc": 23.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.31,
      "Humulene": 0.17,
      "Limonene": 0.52,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.65,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.05,
      "b-Pinene": 0.09
    },
    "state": "MA"
  },
  {
    "id": "MA-114",
    "strain": "Skunk ",
    "type": "Indica",
    "thc": 24.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.21,
      "Limonene": 0.62,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.88,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.05,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-115",
    "strain": "Super Boof",
    "type": "Hybrid",
    "thc": 20.69,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.4,
      "Humulene": 0.11,
      "Limonene": 0.47,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.2,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-116",
    "strain": "Bananaconda ",
    "type": "Hybrid",
    "thc": 27.72,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.23,
      "Humulene": 0.08,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.23,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0.04
    },
    "state": "MA"
  },
  {
    "id": "MA-117",
    "strain": "Blue Gas Can",
    "type": "Hybrid",
    "thc": 28.82,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.16,
      "Humulene": 0.3,
      "Limonene": 0.53,
      "Ocimene": 0,
      "Linalool": 0.43,
      "Myrcene": 0.54,
      "Terpinolene": 0,
      "Bisabolol": 0.18,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "MA"
  },
  {
    "id": "MA-118",
    "strain": "Bluethousand9",
    "type": "Hybrid",
    "thc": 27.34,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.15,
      "Humulene": 0.05,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.3,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-119",
    "strain": "Blueberry Breath",
    "type": "Hybrid",
    "thc": 30.1,
    "cbd": 0.1,
    "lineage": "Cream Pop x Peanut Butter Breath",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.08,
      "Limonene": 0.37,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.38,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.02,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-120",
    "strain": "Sugar Snackz ",
    "type": "Hybrid",
    "thc": 27.03,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.14,
      "Humulene": 0.31,
      "Limonene": 0.89,
      "Ocimene": 0,
      "Linalool": 0.69,
      "Myrcene": 0.58,
      "Terpinolene": 0,
      "Bisabolol": 0.16,
      "Pinene": 0.08,
      "b-Pinene": 0.13
    },
    "state": "MA"
  },
  {
    "id": "MA-121",
    "strain": "Blockberry",
    "type": "Hybrid",
    "thc": 23.69,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.79,
      "Humulene": 0.22,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.48,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.07,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-122",
    "strain": "Cherrylicious",
    "type": "Indica",
    "thc": 26.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.17,
      "Humulene": 0.31,
      "Limonene": 0.93,
      "Ocimene": 0,
      "Linalool": 0.51,
      "Myrcene": 0.59,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.09,
      "b-Pinene": 0.15
    },
    "state": "MA"
  },
  {
    "id": "MA-123",
    "strain": "White Hot Guava",
    "type": "Hybrid",
    "thc": 20.98,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.08,
      "Humulene": 0.03,
      "Limonene": 0.53,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.13,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MA"
  },
  {
    "id": "MA-124",
    "strain": "Champagne Cookies",
    "type": "Hybrid",
    "thc": 25.94,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.06,
      "Humulene": 0.35,
      "Limonene": 1.03,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.24,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.18,
      "b-Pinene": 0.13
    },
    "state": "MA"
  },
  {
    "id": "MA-125",
    "strain": "Garlic Drip",
    "type": "Indica",
    "thc": 25.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.21,
      "Limonene": 0.73,
      "Ocimene": 0,
      "Linalool": 0.47,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0.1,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MA"
  },
  {
    "id": "MA-126",
    "strain": "Offendo",
    "type": "Hybrid",
    "thc": 22.94,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.07,
      "Limonene": 1,
      "Ocimene": 0,
      "Linalool": 0.17,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.07,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-127",
    "strain": "Parfait",
    "type": "Hybrid",
    "thc": 23.12,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.51,
      "Humulene": 0.23,
      "Limonene": 0.79,
      "Ocimene": 0,
      "Linalool": 0.39,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.13,
      "b-Pinene": 0.12
    },
    "state": "MA"
  },
  {
    "id": "MA-128",
    "strain": "Pink Lady",
    "type": "Hybrid",
    "thc": 20.23,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.52,
      "Humulene": 0.13,
      "Limonene": 0.15,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 1.54,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.29,
      "b-Pinene": 0.08
    },
    "state": "MA"
  },
  {
    "id": "MA-129",
    "strain": "Swamp Water Fumez I",
    "type": "Indica",
    "thc": 23.83,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.21,
      "Humulene": 0.47,
      "Limonene": 0.38,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.02,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.04
    },
    "state": "MA"
  },
  {
    "id": "MA-130",
    "strain": "Platinum Garlic ",
    "type": "Hybrid",
    "thc": 24.8,
    "cbd": 0.1,
    "lineage": "GMO x Platinum",
    "terpenes": {
      "Caryophyllene": 0.24,
      "Humulene": 0.08,
      "Limonene": 0.62,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.38,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MA"
  },
  {
    "id": "MA-131",
    "strain": "Sade",
    "type": "Indica",
    "thc": 25.25,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.46,
      "Humulene": 0.11,
      "Limonene": 0.84,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.55,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.06,
      "b-Pinene": 0.09
    },
    "state": "MA"
  },
  {
    "id": "MA-132",
    "strain": "Astro GMO",
    "type": "Hybrid",
    "thc": 28.58,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.29,
      "Humulene": 0.12,
      "Limonene": 0.78,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.38,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-133",
    "strain": "B.A.M.",
    "type": "Sativa",
    "thc": 25.31,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.12,
      "Humulene": 0.04,
      "Limonene": 0.04,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.11,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-134",
    "strain": "Mimosa Kush Mints",
    "type": "Hybrid",
    "thc": 25.43,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.15,
      "Humulene": 0.05,
      "Limonene": 0.3,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-135",
    "strain": "Orange Z",
    "type": "Hybrid",
    "thc": 23.76,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0.06,
      "Limonene": 0.18,
      "Ocimene": 0,
      "Linalool": 0.1,
      "Myrcene": 0.23,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.04,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-136",
    "strain": "Hells Angels OG",
    "type": "Indica",
    "thc": 22.9,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.17,
      "Humulene": 0.06,
      "Limonene": 0.42,
      "Ocimene": 0,
      "Linalool": 0.4,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-137",
    "strain": "Banana OG",
    "type": "Indica",
    "thc": 27.61,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.17,
      "Humulene": 0.13,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.04,
      "Myrcene": 0.95,
      "Terpinolene": 0,
      "Bisabolol": 0.01,
      "Pinene": 0.47,
      "b-Pinene": 0.39
    },
    "state": "MA"
  },
  {
    "id": "MA-138",
    "strain": "Dionysus",
    "type": "Hybrid",
    "thc": 47.67,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.14,
      "Limonene": 0.11,
      "Ocimene": 0,
      "Linalool": 0.07,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "MA"
  },
  {
    "id": "MA-139",
    "strain": "No Strain",
    "type": "Hybrid",
    "thc": 24.39,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.29,
      "Humulene": 0.13,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0.04,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.02,
      "b-Pinene": 0.04
    },
    "state": "MA"
  },
  {
    "id": "MA-140",
    "strain": "Grape Sundae",
    "type": "Hybrid",
    "thc": 26.34,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 1.4,
      "Humulene": 0.41,
      "Limonene": 1.04,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.05,
      "Terpinolene": 0,
      "Bisabolol": 0.12,
      "Pinene": 0.2,
      "b-Pinene": 0.19
    },
    "state": "MA"
  },
  {
    "id": "MA-141",
    "strain": "NF1",
    "type": "Hybrid",
    "thc": 50.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.08,
      "Limonene": 0.05,
      "Ocimene": 0,
      "Linalool": 0.03,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "MA"
  },
  {
    "id": "MA-142",
    "strain": "Sub Zero",
    "type": "Hybrid",
    "thc": 25.55,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.23,
      "Limonene": 0.79,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.6,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.19,
      "b-Pinene": 0.23
    },
    "state": "MA"
  },
  {
    "id": "MA-143",
    "strain": "Tangie x Thank You Jerry",
    "type": "Hybrid",
    "thc": 50.67,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.27,
      "Humulene": 0.08,
      "Limonene": 0.05,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.01,
      "Terpinolene": 0,
      "Bisabolol": 0.09,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "MA"
  },
  {
    "id": "MA-144",
    "strain": "Mazulla",
    "type": "Hybrid",
    "thc": 32.53,
    "cbd": 0.1,
    "lineage": "Amalfi Coast x The Truth",
    "terpenes": {
      "Caryophyllene": 0.45,
      "Humulene": 0.13,
      "Limonene": 0.74,
      "Ocimene": 0,
      "Linalool": 0.34,
      "Myrcene": 0.32,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.04,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-145",
    "strain": "Moonraker",
    "type": "Hybrid",
    "thc": 25.81,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.26,
      "Humulene": 0.08,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.29,
      "Myrcene": 0.09,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.07,
      "b-Pinene": 0.14
    },
    "state": "MA"
  },
  {
    "id": "MA-146",
    "strain": "Permanent Marker ",
    "type": "Hybrid",
    "thc": 27.65,
    "cbd": 0.1,
    "lineage": "Biscotti xSherb x x Jealousy",
    "terpenes": {
      "Caryophyllene": 0.61,
      "Humulene": 0.19,
      "Limonene": 0.71,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.06,
      "Terpinolene": 0,
      "Bisabolol": 0.08,
      "Pinene": 0.29,
      "b-Pinene": 0.2
    },
    "state": "MA"
  },
  {
    "id": "MA-147",
    "strain": "South End Cannoli",
    "type": "Hybrid",
    "thc": 27.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.64,
      "Humulene": 0.17,
      "Limonene": 0.44,
      "Ocimene": 0,
      "Linalool": 0.16,
      "Myrcene": 0.03,
      "Terpinolene": 0,
      "Bisabolol": 0.15,
      "Pinene": 0.12,
      "b-Pinene": 0.09
    },
    "state": "MA"
  },
  {
    "id": "MA-148",
    "strain": "Sunshine Daydream",
    "type": "Indica",
    "thc": 29.85,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.6,
      "Humulene": 0.21,
      "Limonene": 0.8,
      "Ocimene": 0,
      "Linalool": 0.25,
      "Myrcene": 1.26,
      "Terpinolene": 0,
      "Bisabolol": 0.16,
      "Pinene": 0.1,
      "b-Pinene": 0.15
    },
    "state": "MA"
  },
  {
    "id": "MA-149",
    "strain": "Dulce De Uva ",
    "type": "Hybrid",
    "thc": 25.68,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.12,
      "Limonene": 0.73,
      "Ocimene": 0,
      "Linalool": 0.23,
      "Myrcene": 0.7,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.05,
      "b-Pinene": 0.07
    },
    "state": "MA"
  },
  {
    "id": "MA-150",
    "strain": "Black Ice",
    "type": "Indica",
    "thc": 27.57,
    "cbd": 0.1,
    "lineage": "Black Domina x White Widow",
    "terpenes": {
      "Caryophyllene": 0.18,
      "Humulene": 0.06,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.16,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.12,
      "b-Pinene": 0.14
    },
    "state": "MA"
  },
  {
    "id": "MA-151",
    "strain": "Bufo",
    "type": "Hybrid",
    "thc": 32.19,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0.04,
      "Limonene": 0.25,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-152",
    "strain": "Doughboy OG",
    "type": "Indica",
    "thc": 22.48,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.56,
      "Humulene": 0.15,
      "Limonene": 0.46,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.2,
      "Terpinolene": 0,
      "Bisabolol": 0.06,
      "Pinene": 0.1,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-153",
    "strain": "Garlicane",
    "type": "Indica",
    "thc": 21.26,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.51,
      "Humulene": 0.19,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MA"
  },
  {
    "id": "MA-154",
    "strain": "Grease Monkey ",
    "type": "Indica",
    "thc": 27.17,
    "cbd": 0.1,
    "lineage": "GG4 x Cookies & Cream",
    "terpenes": {
      "Caryophyllene": 0.9,
      "Humulene": 0.28,
      "Limonene": 0.3,
      "Ocimene": 0,
      "Linalool": 0.13,
      "Myrcene": 0.27,
      "Terpinolene": 0,
      "Bisabolol": 0.07,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-155",
    "strain": "Heavy Eye",
    "type": "Hybrid",
    "thc": 19.73,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.71,
      "Humulene": 0.19,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.14,
      "Myrcene": 0.04,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.07
    },
    "state": "MA"
  },
  {
    "id": "MA-156",
    "strain": "MAC V2",
    "type": "Hybrid",
    "thc": 29.88,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.31,
      "Humulene": 0.1,
      "Limonene": 0.56,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.38,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.31,
      "b-Pinene": 0.2
    },
    "state": "MA"
  },
  {
    "id": "MA-157",
    "strain": "Moonbow",
    "type": "Hybrid",
    "thc": 22.73,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.39,
      "Humulene": 0.11,
      "Limonene": 0.21,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.12,
      "Terpinolene": 0,
      "Bisabolol": 0.05,
      "Pinene": 0.02,
      "b-Pinene": 0.04
    },
    "state": "MA"
  },
  {
    "id": "MA-158",
    "strain": "Sherbert Honey",
    "type": "Hybrid",
    "thc": 26.55,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0.09,
      "Limonene": 0.49,
      "Ocimene": 0,
      "Linalool": 0.37,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0.04,
      "Pinene": 0.04,
      "b-Pinene": 0.08
    },
    "state": "MA"
  },
  {
    "id": "MA-159",
    "strain": "Zsweet Inzanity",
    "type": "Hybrid",
    "thc": 27.53,
    "cbd": 0.1,
    "lineage": "Durban Poison x Rainmaker x OG Glue",
    "terpenes": {
      "Caryophyllene": 0.37,
      "Humulene": 0.09,
      "Limonene": 0.22,
      "Ocimene": 0,
      "Linalool": 0.04,
      "Myrcene": 0.59,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.06,
      "b-Pinene": 0.12
    },
    "state": "MA"
  },
  {
    "id": "MA-160",
    "strain": "Durban Poison",
    "type": "Sativa",
    "thc": 23.48,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0.12,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.12,
      "Myrcene": 0.26,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "MA"
  },
  {
    "id": "MA-161",
    "strain": "PK Crasher ",
    "type": "Hybrid",
    "thc": 31.21,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.13,
      "Humulene": 0.05,
      "Limonene": 0.87,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.29,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.1,
      "b-Pinene": 0.2
    },
    "state": "MA"
  },
  {
    "id": "MA-162",
    "strain": "Strawberry Afterglow",
    "type": "Hybrid",
    "thc": 29.4,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.38,
      "Humulene": 0.11,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.05,
      "Myrcene": 0.33,
      "Terpinolene": 0,
      "Bisabolol": 0.02,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "MA"
  },
  {
    "id": "MA-163",
    "strain": "Robusta",
    "type": "Hybrid",
    "thc": 21.96,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.29,
      "Humulene": 0.1,
      "Limonene": 0.33,
      "Ocimene": 0,
      "Linalool": 0.19,
      "Myrcene": 0.22,
      "Terpinolene": 0,
      "Bisabolol": 0.03,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MA"
  }
],

MN : 
 [
  {
    "id": "MN-100",
    "strain": "Afternoon Delight #4",
    "type": "Hybrid",
    "thc": 21.5,
    "cbd": 0.1,
    "lineage": "GMO x Trophy Wife",
    "terpenes": {
      "Caryophyllene": 0.55,
      "Humulene": 0.2,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.34,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.07
    },
    "state": "MN"
  },
  {
    "id": "MN-101",
    "strain": "Animal Face",
    "type": "Indica",
    "thc": 24.5,
    "cbd": 0.1,
    "lineage": "Face Off OG x Animal Mints",
    "terpenes": {
      "Caryophyllene": 0.55,
      "Humulene": 0.18,
      "Limonene": 0.47,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.4,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.06
    },
    "state": "MN"
  },
  {
    "id": "MN-102",
    "strain": "Bananaconda",
    "type": "Hybrid",
    "thc": 22.3,
    "cbd": 0.1,
    "lineage": "Snake Cake x Dual OG",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0.05,
      "Limonene": 0.77,
      "Ocimene": 0.15,
      "Linalool": 0.29,
      "Myrcene": 0.05,
      "Terpinolene": 0.03,
      "Bisabolol": 0,
      "Pinene": 0.11,
      "b-Pinene": 0.12
    },
    "state": "MN"
  },
  {
    "id": "MN-103",
    "strain": "Brownie Scout",
    "type": "Indica",
    "thc": 21.8,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.31,
      "Humulene": 0.12,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.06,
      "Myrcene": 0.3,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "MN"
  },
  {
    "id": "MN-104",
    "strain": "Durban Z",
    "type": "Sativa",
    "thc": 20.8,
    "cbd": 0.1,
    "lineage": "ZKZ x Durban Poison",
    "terpenes": {
      "Caryophyllene": 0.14,
      "Humulene": 0.05,
      "Limonene": 0.28,
      "Ocimene": 0.4,
      "Linalool": 0.07,
      "Myrcene": 0.22,
      "Terpinolene": 0.07,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.1
    },
    "state": "MN"
  },
  {
    "id": "MN-105",
    "strain": "Gogurtz",
    "type": "Hybrid",
    "thc": 27,
    "cbd": 0.1,
    "lineage": "Cap Junky x Runtz",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.13,
      "Limonene": 0.74,
      "Ocimene": 0,
      "Linalool": 0.52,
      "Myrcene": 0.21,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.06,
      "b-Pinene": 0.1
    },
    "state": "MN"
  },
  {
    "id": "MN-106",
    "strain": "Runtz S1",
    "type": "Hybrid",
    "thc": 22.1,
    "cbd": 0.1,
    "lineage": "Runtz x Tropical ZKZ",
    "terpenes": {
      "Caryophyllene": 0.35,
      "Humulene": 0.1,
      "Limonene": 0.5,
      "Ocimene": 0,
      "Linalool": 0.5,
      "Myrcene": 0.31,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.09
    },
    "state": "MN"
  },
  {
    "id": "MN-107",
    "strain": "Velcroz",
    "type": "Hybrid",
    "thc": 24.3,
    "cbd": 0.1,
    "lineage": "Blue Flame OG x Blue Zushi",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.13,
      "Limonene": 0.6,
      "Ocimene": 0.01,
      "Linalool": 0.34,
      "Myrcene": 0.4,
      "Terpinolene": 0.04,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.08
    },
    "state": "MN"
  },
  {
    "id": "MN-108",
    "strain": "Chem n' Cookies",
    "type": "Hybrid",
    "thc": 21.6,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.32,
      "Humulene": 0.14,
      "Limonene": 0.13,
      "Ocimene": 0,
      "Linalool": 0.35,
      "Myrcene": 0.83,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0.03
    },
    "state": "MN"
  },
  {
    "id": "MN-109",
    "strain": "Gas & Glue",
    "type": "Hybrid",
    "thc": 24.9,
    "cbd": 0.1,
    "lineage": "(White x GSC) x GG4",
    "terpenes": {
      "Caryophyllene": 0.3,
      "Humulene": 0.11,
      "Limonene": 0.62,
      "Ocimene": 0,
      "Linalool": 0.28,
      "Myrcene": 0.35,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.09
    },
    "state": "MN"
  },
  {
    "id": "MN-110",
    "strain": "Jack's Delight",
    "type": "Sativa",
    "thc": 20.6,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.42,
      "Humulene": 0.17,
      "Limonene": 0.09,
      "Ocimene": 0.28,
      "Linalool": 0.05,
      "Myrcene": 0.17,
      "Terpinolene": 0.31,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "MN"
  },
  {
    "id": "MN-111",
    "strain": "OMG",
    "type": "Hybrid",
    "thc": 22.6,
    "cbd": 0.1,
    "lineage": "GMO x Cherry Pie #5",
    "terpenes": {
      "Caryophyllene": 0.22,
      "Humulene": 0.11,
      "Limonene": 0.29,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.9,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.05
    },
    "state": "MN"
  }
],

AZ : 
[
  {
    "id": "MI-100",
    "strain": "Zoap #54 ",
    "type": "Indica",
    "thc": 21.31,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.21,
      "Limonene": 0.73,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.1,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.13,
      "b-Pinene": 0.14
    },
    "state": "AZ"
  },
  {
    "id": "MI-101",
    "strain": "LPZ ",
    "type": "Sativa",
    "thc": 20.57,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.26,
      "Limonene": 0.4,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.3,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.03,
      "b-Pinene": 0.06
    },
    "state": "AZ"
  },
  {
    "id": "MI-102",
    "strain": "Lemon Tree BX3 ",
    "type": "Sativa",
    "thc": 21.05,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.17,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.48,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.02,
      "b-Pinene": 0.05
    },
    "state": "AZ"
  },
  {
    "id": "MI-103",
    "strain": "Gary Payton ",
    "type": "Hybrid",
    "thc": 22.37,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0,
      "Limonene": 0.35,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0.52,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-104",
    "strain": "Bubba Star Dog",
    "type": "Indica",
    "thc": 27.12,
    "cbd": 0.1,
    "lineage": "Bubba Kush x Stardawg",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.21,
      "Limonene": 0.53,
      "Ocimene": 0,
      "Linalool": 0.09,
      "Myrcene": 0.17,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.1
    },
    "state": "AZ"
  },
  {
    "id": "MI-105",
    "strain": "Cadillac Rainbows Most Wanted ",
    "type": "Indica",
    "thc": 27.51,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.2,
      "Limonene": 0.67,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.22,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.13
    },
    "state": "AZ"
  },
  {
    "id": "MI-106",
    "strain": "The Fizz",
    "type": "Hybrid",
    "thc": 27,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.19,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 1.66,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0.03
    },
    "state": "AZ"
  },
  {
    "id": "MI-107",
    "strain": "RNTZ ",
    "type": "Hybrid",
    "thc": 20.38,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.25,
      "Humulene": 0,
      "Limonene": 0.3,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.25,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-108",
    "strain": "Facade #2",
    "type": "Indica",
    "thc": 24.8,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.41,
      "Humulene": 0,
      "Limonene": 0.65,
      "Ocimene": 0,
      "Linalool": 0.33,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-109",
    "strain": "Papaya ",
    "type": "Indica",
    "thc": 20.14,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.08,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.22,
      "Myrcene": 0.07,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.05,
      "b-Pinene": 0.08
    },
    "state": "AZ"
  },
  {
    "id": "MI-110",
    "strain": "Beaver Cookies ",
    "type": "Hybrid",
    "thc": 21.76,
    "cbd": 0.1,
    "lineage": "Gary Payton x GMO Cookies",
    "terpenes": {
      "Caryophyllene": 1.55,
      "Humulene": 0.56,
      "Limonene": 0.7,
      "Ocimene": 0,
      "Linalool": 0.24,
      "Myrcene": 0.07,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.23,
      "b-Pinene": 0.17
    },
    "state": "AZ"
  },
  {
    "id": "MI-111",
    "strain": "Rose Gold ",
    "type": "Indica",
    "thc": 18.41,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.16,
      "Humulene": 0,
      "Limonene": 0.14,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.18,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-112",
    "strain": "ORO BLZD",
    "type": "Indica",
    "thc": 27.36,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.08,
      "Humulene": 0.15,
      "Limonene": 0.86,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 0.37,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.15,
      "b-Pinene": 0.19
    },
    "state": "AZ"
  },
  {
    "id": "MI-113",
    "strain": "Rainbow Belts ",
    "type": "Indica",
    "thc": 19.57,
    "cbd": 0.1,
    "lineage": "Moonbow x Zkittlez",
    "terpenes": {
      "Caryophyllene": 0.43,
      "Humulene": 0,
      "Limonene": 0.36,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-114",
    "strain": "Sugar Gem ",
    "type": "Indica",
    "thc": 20.05,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.3,
      "Limonene": 0.45,
      "Ocimene": 0,
      "Linalool": 0.31,
      "Myrcene": 0.2,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.08,
      "b-Pinene": 0.1
    },
    "state": "AZ"
  },
  {
    "id": "MI-115",
    "strain": "Pink Zugar",
    "type": "Indica",
    "thc": 23.21,
    "cbd": 0.1,
    "lineage": "Pink Pellegrino x Zuchi",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.26,
      "Limonene": 0.77,
      "Ocimene": 0,
      "Linalool": 0.53,
      "Myrcene": 0.39,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.13
    },
    "state": "AZ"
  },
  {
    "id": "MI-116",
    "strain": "11:11 ",
    "type": "Hybrid",
    "thc": 20.51,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.02,
      "Humulene": 0.19,
      "Limonene": 0.74,
      "Ocimene": 0,
      "Linalool": 0.38,
      "Myrcene": 0.16,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.1,
      "b-Pinene": 0.15
    },
    "state": "AZ"
  },
  {
    "id": "MI-117",
    "strain": "Laff Taff OG ",
    "type": "Hybrid",
    "thc": 18.19,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.2,
      "Limonene": 1.06,
      "Ocimene": 0,
      "Linalool": 0.36,
      "Myrcene": 0.19,
      "Terpinolene": 0.05,
      "Bisabolol": 0,
      "Pinene": 0.14,
      "b-Pinene": 0.19
    },
    "state": "AZ"
  },
  {
    "id": "MI-118",
    "strain": "Chauffeur RTZ ",
    "type": "Hybrid",
    "thc": 20.57,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.16,
      "Limonene": 0.58,
      "Ocimene": 0,
      "Linalool": 0.32,
      "Myrcene": 0.69,
      "Terpinolene": 0.06,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.1
    },
    "state": "AZ"
  },
  {
    "id": "MI-119",
    "strain": "Lemon Gelato ",
    "type": "Sativa",
    "thc": 19.22,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.11,
      "Limonene": 0.39,
      "Ocimene": 0,
      "Linalool": 0.15,
      "Myrcene": 0.16,
      "Terpinolene": 0.02,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "AZ"
  },
  {
    "id": "MI-120",
    "strain": "Lemon ORZ #11 ",
    "type": "Indica",
    "thc": 20.46,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.28,
      "Humulene": 0,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.41,
      "Terpinolene": 0.74,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-121",
    "strain": "Moonbow Sunset ",
    "type": "Indica",
    "thc": 21.83,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.19,
      "Limonene": 0.88,
      "Ocimene": 0,
      "Linalool": 0.27,
      "Myrcene": 0.07,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.17,
      "b-Pinene": 0.17
    },
    "state": "AZ"
  },
  {
    "id": "MI-122",
    "strain": "Durban Kush ",
    "type": "Sativa",
    "thc": 19.2,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0,
      "Humulene": 0.03,
      "Limonene": 0,
      "Ocimene": 0.3,
      "Linalool": 0.01,
      "Myrcene": 0.3,
      "Terpinolene": 1.48,
      "Bisabolol": 0,
      "Pinene": 0.07,
      "b-Pinene": 0.13
    },
    "state": "AZ"
  },
  {
    "id": "MI-123",
    "strain": "Scented Marker ",
    "type": "Hybrid",
    "thc": 19.35,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.47,
      "Humulene": 0,
      "Limonene": 0.24,
      "Ocimene": 0,
      "Linalool": 0,
      "Myrcene": 0.24,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0,
      "b-Pinene": 0
    },
    "state": "AZ"
  },
  {
    "id": "MI-124",
    "strain": "Exhaltation ",
    "type": "Sativa",
    "thc": 19.43,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.23,
      "Limonene": 0.41,
      "Ocimene": 0,
      "Linalool": 0.08,
      "Myrcene": 0.61,
      "Terpinolene": 0.01,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "AZ"
  },
  {
    "id": "MI-125",
    "strain": "Black Amber x Gastro Pop #1",
    "type": "Hybrid",
    "thc": 27.43,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.01,
      "Humulene": 0.11,
      "Limonene": 0,
      "Ocimene": 0,
      "Linalool": 0.41,
      "Myrcene": 1.99,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.01,
      "b-Pinene": 0.02
    },
    "state": "AZ"
  },
  {
    "id": "MI-126",
    "strain": "Sherbo",
    "type": "Indica",
    "thc": 26.84,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {
      "Caryophyllene": 0.78,
      "Humulene": 0.37,
      "Limonene": 0.48,
      "Ocimene": 0,
      "Linalool": 0.11,
      "Myrcene": 0.4,
      "Terpinolene": 0,
      "Bisabolol": 0,
      "Pinene": 0.04,
      "b-Pinene": 0.07
    },
    "state": "AZ"
  }
],

MO : 
[
  {
    "id": "MO-001",
    "strain": "Gaschata #01",
    "type": "Hybrid",
    "thc": 24.27,
    "cbd": 0.1,
    "lineage": "Horchata x Grape Gasoline #1",
    "terpenes": {"Caryophyllene":0.39,"Humulene":0.09,"Limonene":0.54,"Ocimene":0.27,"Linalool":0.37,"Myrcene":1.11,"Terpinolene":0,"Bisabolol":0,"Pinene":0.05,"b-Pinene":0.08},
    "state": "MO"
  },
  {
    "id": "MO-002",
    "strain": "Pink Certz #3",
    "type": "Hybrid",
    "thc": 25.93,
    "cbd": 0.1,
    "lineage": "The Menthol x Grape Gasoline",
    "terpenes": {"Caryophyllene":0.74,"Humulene":0.09,"Limonene":0.59,"Ocimene":0.19,"Linalool":0.25,"Myrcene":0.1,"Terpinolene":0,"Bisabolol":0,"Pinene":0.06,"b-Pinene":0.09},
    "state": "MO"
  },
  {
    "id": "MO-003",
    "strain": "Jokerz #53",
    "type": "Indica",
    "thc": 22.02,
    "cbd": 0.1,
    "lineage": "Jet Fuel Gelato x White Runtz",
    "terpenes": {"Caryophyllene":0.76,"Humulene":0.12,"Limonene":0.94,"Ocimene":0.05,"Linalool":0.39,"Myrcene":0.3,"Terpinolene":0,"Bisabolol":0.06,"Pinene":0.11,"b-Pinene":0.12},
    "state": "MO"
  },
  {
    "id": "MO-004",
    "strain": "Glitter Bomb",
    "type": "Indica",
    "thc": 25.74,
    "cbd": 0.1,
    "lineage": "OGKB Blueberry Headband x Grape Gasoline #10",
    "terpenes": {"Caryophyllene":0.47,"Humulene":0.09,"Limonene":0.09,"Ocimene":0.16,"Linalool":0.26,"Myrcene":0.75,"Terpinolene":0,"Bisabolol":0,"Pinene":0,"b-Pinene":0},
    "state": "MO"
  },
  {
    "id": "MO-005",
    "strain": "Sour Cheetah",
    "type": "Hybrid",
    "thc": 23.79,
    "cbd": 0.1,
    "lineage": "Unknown",
    "terpenes": {"Caryophyllene":0.64,"Humulene":0.12,"Limonene":0.52,"Ocimene":0,"Linalool":0.22,"Myrcene":0.19,"Terpinolene":0,"Bisabolol":0,"Pinene":0.12,"b-Pinene":0.12},
    "state": "MO"
  },
  {
    "id": "MO-006",
    "strain": "Pinnacle",
    "type": "Indica",
    "thc": 19.3,
    "cbd": 0.1,
    "lineage": "Slurty 3 x Gush Mints",
    "terpenes": {"Caryophyllene":0.98,"Humulene":0.18,"Limonene":0.65,"Ocimene":0.06,"Linalool":0.25,"Myrcene":0,"Terpinolene":0,"Bisabolol":0,"Pinene":0.08,"b-Pinene":0.11},
    "state": "MO"
  },
  {
    "id": "MO-007",
    "strain": "Tire Fire",
    "type": "Indica",
    "thc": 24.58,
    "cbd": 0.1,
    "lineage": "High Octane OG x Dosido",
    "terpenes": {"Caryophyllene":0.82,"Humulene":0.13,"Limonene":0.52,"Ocimene":0,"Linalool":0.42,"Myrcene":0.14,"Terpinolene":0,"Bisabolol":0,"Pinene":0.04,"b-Pinene":0.08},
    "state": "MO"
  },
  {
    "id": "MO-008",
    "strain": "Future Haze",
    "type": "Sativa",
    "thc": 20.38,
    "cbd": 0.1,
    "lineage": "Super Lemon Haze x Durban Biscotti",
    "terpenes": {"Caryophyllene":0.46,"Humulene":0.1,"Limonene":0.12,"Ocimene":0.49,"Linalool":0.05,"Myrcene":0.31,"Terpinolene":1.26,"Bisabolol":0,"Pinene":0.05,"b-Pinene":0.09},
    "state": "MO"
  },
  {
    "id": "MO-009",
    "strain": "Malibu Mirage",
    "type": "Indica",
    "thc": 21.13,
    "cbd": 0.1,
    "lineage": "Legend OG x Jet Fuel Gelato",
    "terpenes": {"Caryophyllene":0.75,"Humulene":0.1,"Limonene":0.61,"Ocimene":0.05,"Linalool":0.27,"Myrcene":0.28,"Terpinolene":0,"Bisabolol":0,"Pinene":0.08,"b-Pinene":0.11},
    "state": "MO"
  },
  {
    "id": "MO-010",
    "strain": "Egg Roll",
    "type": "Hybrid",
    "thc": 26.46,
    "cbd": 0.1,
    "lineage": "Chemdog D x Biscotti",
    "terpenes": {"Caryophyllene":1.05,"Humulene":0.15,"Limonene":0.89,"Ocimene":0,"Linalool":0.15,"Myrcene":0.23,"Terpinolene":0,"Bisabolol":0.09,"Pinene":0.13,"b-Pinene":0.15},
    "state": "MO"
  },
  {
    "id": "MO-011",
    "strain": "Bubba Kush",
    "type": "Indica",
    "thc": 20.07,
    "cbd": 0.1,
    "lineage": "Afghani x OG Kush",
    "terpenes": {"Caryophyllene":0.51,"Humulene":0.09,"Limonene":0.21,"Ocimene":0,"Linalool":0.22,"Myrcene":0.46,"Terpinolene":0,"Bisabolol":0.09,"Pinene":0,"b-Pinene":0},
    "state": "MO"
  },
  {
    "id": "MO-012",
    "strain": "Carbon Candy #4",
    "type": "Indica",
    "thc": 23.7,
    "cbd": 0.1,
    "lineage": "Carbon Fiber x Gushers",
    "terpenes": {"Caryophyllene":0.83,"Humulene":0.17,"Limonene":0.69,"Ocimene":0,"Linalool":0.15,"Myrcene":0.15,"Terpinolene":0,"Bisabolol":0.1,"Pinene":0.06,"b-Pinene":0.1},
    "state": "MO"
  },
  {
    "id": "MO-013",
    "strain": "Pixel Face",
    "type": "Hybrid",
    "thc": 19.92,
    "cbd": 0.1,
    "lineage": "Biscotti x Jealousy f2",
    "terpenes": {"Caryophyllene":1.14,"Humulene":0.14,"Limonene":0.54,"Ocimene":0,"Linalool":0.39,"Myrcene":0,"Terpinolene":0,"Bisabolol":0,"Pinene":0.08,"b-Pinene":0.09},
    "state": "MO"
  },
  {
    "id": "MO-014",
    "strain": "Vapor Fuel Bx",
    "type": "Indica",
    "thc": 22.13,
    "cbd": 0.1,
    "lineage": "Chemdog D x i95 x Chem de la Chem",
    "terpenes": {"Caryophyllene":1.53,"Humulene":0.27,"Limonene":0.94,"Ocimene":0,"Linalool":0.27,"Myrcene":0.56,"Terpinolene":0,"Bisabolol":0,"Pinene":0.07,"b-Pinene":0.14},
    "state": "MO"
  },
  {
    "id": "MO-015",
    "strain": "OZ Kush Bx2",
    "type": "Indica",
    "thc": 22.6,
    "cbd": 0.1,
    "lineage": "OZ Kush x Peach Ozz",
    "terpenes": {"Caryophyllene":0.9,"Humulene":0.17,"Limonene":0.32,"Ocimene":0,"Linalool":0.26,"Myrcene":0.3,"Terpinolene":0,"Bisabolol":0.11,"Pinene":0,"b-Pinene":0.05},
    "state": "MO"
  },
  {
    "id": "MO-016",
    "strain": "Lemon Sportiff",
    "type": "Hybrid",
    "thc": 26.94,
    "cbd": 0.1,
    "lineage": "Lemon Tree x Skorange x THC Bomb",
    "terpenes": {"Caryophyllene":0.59,"Humulene":0.11,"Limonene":0.16,"Ocimene":0,"Linalool":0.14,"Myrcene":1.86,"Terpinolene":0,"Bisabolol":0,"Pinene":0.27,"b-Pinene":0.13},
    "state": "MO"
  },
  {
    "id": "MO-017",
    "strain": "Gush Mintz #8",
    "type": "Indica",
    "thc": 25.69,
    "cbd": 0.1,
    "lineage": "Gelato 41 x Triangle Kush x GSC x Fire OG",
    "terpenes": {"Caryophyllene":1.04,"Humulene":0.13,"Limonene":0.8,"Ocimene":0,"Linalool":0.23,"Myrcene":0.14,"Terpinolene":0,"Bisabolol":0,"Pinene":0.06,"b-Pinene":0.11},
    "state": "MO"
  },
  {
    "id": "MO-018",
    "strain": "Peppermint Agave x Rainbow Cheddar #1",
    "type": "Hybrid",
    "thc": 17.02,
    "cbd": 0.1,
    "lineage": "Peppermint Agave x Rainbow Cheddar #1",
    "terpenes": {"Caryophyllene":0.63,"Humulene":0.12,"Limonene":0.39,"Ocimene":0,"Linalool":0.18,"Myrcene":0.13,"Terpinolene":0,"Bisabolol":0,"Pinene":0,"b-Pinene":0.06},
    "state": "MO"
  },
  {
    "id": "MO-019",
    "strain": "Coka",
    "type": "Hybrid",
    "thc": 22.96,
    "cbd": 0.1,
    "lineage": "High Society x White Runtz",
    "terpenes": {"Caryophyllene":1.01,"Humulene":0.18,"Limonene":0.58,"Ocimene":0,"Linalool":0.28,"Myrcene":0.1,"Terpinolene":0,"Bisabolol":0.06,"Pinene":0.07,"b-Pinene":0.09},
    "state": "MO"
  },
  {
    "id": "MO-020",
    "strain": "Heavy Fog #1",
    "type": "Indica",
    "thc": 25.52,
    "cbd": 0.1,
    "lineage": "Peanut Butter Trix x Sherbet #41",
    "terpenes": {"Caryophyllene":1.08,"Humulene":0.19,"Limonene":0.8,"Ocimene":0,"Linalool":0.57,"Myrcene":0.26,"Terpinolene":0,"Bisabolol":0,"Pinene":0.06,"b-Pinene":0.11},
    "state": "MO"
  },
  {
    "id": "MO-021",
    "strain": "Cookies",
    "type": "Hybrid",
    "thc": 22.89,
    "cbd": 0.1,
    "lineage": "OG Kush x Durban Poison x Cherry Kush",
    "terpenes": {"Caryophyllene":0.35,"Humulene":0.09,"Limonene":0.11,"Ocimene":0.74,"Linalool":0.09,"Myrcene":0.45,"Terpinolene":1.35,"Bisabolol":0.08,"Pinene":0.07,"b-Pinene":0.1},
    "state": "MO"
  }
]


};